webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(200);

var _create2 = _interopRequireDefault(_create);

var _promise = __webpack_require__(67);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(37);

var _assign2 = _interopRequireDefault(_assign);

exports.HTTP = HTTP;
exports.resolveHTTP = resolveHTTP;

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(2);

var _plugins = __webpack_require__(20);

var _plugins2 = _interopRequireDefault(_plugins);

var _config = __webpack_require__(104);

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__(65);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_plugins2.default);

function HTTP() {
  var self = this;

  this.apiURl = _config2.default.local.API_URL.replace(/"(.*)"/, '$1');

  this.resource = _vue2.default.axios.create();

  this.resource.interceptors.request.use(function (req) {
    var token = _store2.default.getters['auth/token'];

    if (token) {
      req.headers.common = (0, _assign2.default)({}, req.headers.common, { Authorization: 'Bearer ' + token });
    }

    return req;
  }, function (error) {
    return _promise2.default.reject(error);
  });

  this.relativeUrl = '';

  this.routes = {
    index: function index() {
      return '';
    },
    store: function store() {
      return '';
    },
    show: function show(id) {
      return '/' + id;
    },
    update: function update(id) {
      return '/' + id;
    },
    destroy: function destroy(id) {
      return '/' + id;
    },
    relativeMedia: function relativeMedia(id) {
      return id !== undefined ? self.relativeUrl + '/' + id + '/media' : '/media';
    },
    uploadMedia: function uploadMedia(id) {
      return self.apiURl + self.routes.relativeMedia(id);
    },
    uploadFile: function uploadFile(id) {
      return self.apiURl + (id !== undefined ? self.relativeUrl + '/' + id + '/files' : '/files');
    },
    destroyFile: function destroyFile(id, fileId) {
      return self.apiURl + (id !== undefined ? self.relativeUrl + '/' + id + '/files/' + fileId : '/files/' + fileId);
    }
  };

  this.getRoute = function (name, data) {
    if (self.routes[name]) {
      return self.relativeUrl + self.routes[name](data);
    }
  };

  this.defaultUrl = function () {
    return self.resource.defaults.baseURL;
  };

  this.setUrl = function (url) {
    self.resource.defaults.baseURL = url;

    return self;
  };

  this.getUrl = function () {
    return self.resource.defaults.baseURL;
  };

  this.appendToUrl = function (url) {
    self.relativeUrl = url;

    self.resource.defaults.baseURL += url;

    return self;
  };

  this.index = function (options) {
    return self.resource.get(self.routes.index(), self.parseOptions(options));
  };

  this.store = function (formData, options) {
    return self.resource.post(self.routes.store(), formData, self.parseOptions(options));
  };

  this.show = function (id, options) {
    return self.resource.get(self.routes.show(id), self.parseOptions(options));
  };

  this.destroy = function (id, options) {
    return self.resource.delete(self.routes.destroy(id), self.parseOptions(options));
  };

  this.update = function (id, options) {
    return self.resource.put(self.routes.update(id), self.parseOptions(options));
  };

  this.destroyFile = function (id, fileId, options) {
    return self.resource.delete(self.routes.destroyFile(id, fileId), options);
  };

  this.export = function (query, options) {
    return self.resource.get(self.routes.export(query), self.parseOptions(options));
  };

  this.parseOptions = function (options) {
    var newOptions = (0, _lodash.cloneDeep)(options);

    if (newOptions && newOptions.params) {
      var params = newOptions.params;

      if (params) {
        if ('with' in params) {
          if (params.with.constructor === String) {
            params.with = params.with.split(';');
          }

          if (params.with.constructor === Array) {
            params._with = params.with.join(';');
          }

          delete params['with'];
        }

        if ('orderBy' in params) {
          if (params.orderBy.constructor === String) {
            params._order = params.orderBy;
          } else if (params.orderBy.constructor === Object) {
            if (params.orderBy.name) {
              params._order = params.orderBy.name + ':' + (params.orderBy.direction || 'asc');
            }
          }

          delete params['orderBy'];
        }

        if ('search' in params) {
          if (params.search.constructor === String && params.search !== '') {
            params._search = params.search;
          } else if (params.search.constructor === Object || params.search.constructor === Array) {
            var search = [];

            (0, _lodash.forEach)(params.search, function (value, key) {
              if (value) {
                if (value.constructor === String && value !== '') {
                  search.push(value);
                } else {
                  if (value.constructor === Object || value.constructor === Array) {
                    (0, _lodash.forEach)(value, function (value, key) {
                      if (value !== '') {
                        search.push(key + ':' + value);
                      }
                    });
                  } else {
                    if (value !== '') {
                      search.push(key + ':' + value);
                    }

                    if (value.constructor === String) {
                      search.push(value);
                    } else {
                      search.push(key + ':' + value);
                    }
                  }
                }
              }
            });

            params._search = search;
          }

          delete params['search'];
        }

        if ('scopes' in params) {
          if (params.scopes.constructor === String) {
            params._scopes = params.scopes;
          } else if (params.scopes.constructor === Object || params.scopes.constructor === Array) {
            var scopes = [];

            (0, _lodash.forEach)(params.scopes, function (value, key) {
              if (value.constructor === String) {
                scopes.push(value);
              } else {
                scopes.push(key + ':' + value);
              }
            });

            params._scope = scopes;
          }

          delete params['scopes'];
        }

        if (params.append && params.append.constructor === String) {
          params.append = params.append.split(';');
        }
      }
    }

    return newOptions;
  };
};

function resolveHTTP(url) {
  var http = (0, _create2.default)(new HTTP());

  http.resetUrl = function () {
    http.appendToUrl(url);
  };
  http.resetUrl();

  return http;
}

exports.default = HTTP;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugifyOptions = exports.datepickerOptions = undefined;

var _vueBootstrapDatetimepicker = __webpack_require__(630);

var _vueBootstrapDatetimepicker2 = _interopRequireDefault(_vueBootstrapDatetimepicker);

__webpack_require__(633);

__webpack_require__(635);

__webpack_require__(641);

__webpack_require__(642);

var _vueAxios = __webpack_require__(644);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _bootstrapVue = __webpack_require__(645);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueTransmit = __webpack_require__(754);

var _vueTransmit2 = _interopRequireDefault(_vueTransmit);

var _vueToasted = __webpack_require__(755);

var _vueToasted2 = _interopRequireDefault(_vueToasted);

var _vueJsToggleButton = __webpack_require__(756);

var _vueJsToggleButton2 = _interopRequireDefault(_vueJsToggleButton);

var _vueMoment = __webpack_require__(757);

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _vueTruncateFilter = __webpack_require__(758);

var _vueTruncateFilter2 = _interopRequireDefault(_vueTruncateFilter);

var _vueTheMask = __webpack_require__(759);

var _vueTheMask2 = _interopRequireDefault(_vueTheMask);

var _vueProgressbar = __webpack_require__(760);

var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);

var _axios = __webpack_require__(101);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function install(Vue) {
  Vue.use(_vueAxios2.default, _axios2.default);
  Vue.use(_bootstrapVue2.default);
  Vue.use(_vueTransmit2.default);
  Vue.use(_vueJsToggleButton2.default);
  Vue.use(_vueMoment2.default);
  Vue.use(_vueTruncateFilter2.default);

  Vue.use(_vueTheMask2.default);
  Vue.use(_vueToasted2.default, {
    iconPack: 'fontawesome',
    duration: 3000
  });
  Vue.use(_vueBootstrapDatetimepicker2.default);

  Vue.use(_vueProgressbar2.default, {
    color: '#4dbd74',
    failedColor: 'red',
    height: '4px'
  });
}

exports.default = install;
var datepickerOptions = exports.datepickerOptions = {
  viewMode: 'days',
  format: 'DD/MM/YYYY HH:mm',
  extraFormats: ['YYYY-MM-DD HH:mm:ss'],
  useCurrent: true,
  inline: false,

  icons: {
    time: 'fa fa-clock-o',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'fa fa-dot-circle-o',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
  }
};

var slugifyOptions = exports.slugifyOptions = {
  replacement: '-',
  remove: /[^a-zA-Z\d\s:-]/,
  lower: true
};

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blProcessCategories = exports.processItemsJurisprudence = exports.processItems = exports.sysUsers = exports.blBankAccounts = exports.blAuthorizations = undefined;

var _sysUsers = __webpack_require__(368);

var _sysUsers2 = _interopRequireDefault(_sysUsers);

var _blProcessitems = __webpack_require__(812);

var _blProcessitems2 = _interopRequireDefault(_blProcessitems);

var _blJurisprudencefiles = __webpack_require__(813);

var _blJurisprudencefiles2 = _interopRequireDefault(_blJurisprudencefiles);

var _forms = __webpack_require__(814);

var _forms2 = _interopRequireDefault(_forms);

var _Datatable = __webpack_require__(395);

var _Datatable2 = _interopRequireDefault(_Datatable);

var _ActivateUserElement = __webpack_require__(875);

var _ActivateUserElement2 = _interopRequireDefault(_ActivateUserElement);

var _DeleteElement = __webpack_require__(136);

var _DeleteElement2 = _interopRequireDefault(_DeleteElement);

var _EditElement = __webpack_require__(397);

var _EditElement2 = _interopRequireDefault(_EditElement);

var _OrderElement = __webpack_require__(879);

var _OrderElement2 = _interopRequireDefault(_OrderElement);

var _ToggleOptionElement = __webpack_require__(402);

var _ToggleOptionElement2 = _interopRequireDefault(_ToggleOptionElement);

var _Mailbox = __webpack_require__(404);

var _Mailbox2 = _interopRequireDefault(_Mailbox);

var _Sortable = __webpack_require__(406);

var _Sortable2 = _interopRequireDefault(_Sortable);

var _ExportAccountsButton = __webpack_require__(888);

var _ExportAccountsButton2 = _interopRequireDefault(_ExportAccountsButton);

var _ProcessItemCard = __webpack_require__(891);

var _ProcessItemCard2 = _interopRequireDefault(_ProcessItemCard);

var _JurisprudenceCategoryCard = __webpack_require__(374);

var _JurisprudenceCategoryCard2 = _interopRequireDefault(_JurisprudenceCategoryCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blAuthorizations = exports.blAuthorizations = {
  url: '/bl/authorizations',
  datatable: false
};

var blBankAccounts = exports.blBankAccounts = {
  add: false,
  nested: true,
  parent: 'sys-users',
  parentKey: 'user_id',
  name: 'Contas Bancárias',
  form: _forms2.default.Bl.BankAccount,
  url: '/bl/bank-accounts',
  key: 'bl-bankaccounts',
  indexComponent: false,
  tableOptions: {
    with: ['process'],
    fields: [{
      label: '',
      key: 'status',
      component: _ToggleOptionElement2.default,
      style: 'width: 30px;',
      props: {
        labels: ['Visível', 'Oculto'],
        classes: ['fa fa-eye', 'fa fa-eye-slash'],
        colors: ['green', 'gray']
      }
    }, {
      label: 'Processo',
      key: 'process.company_name',
      sortable: false
    }, {
      label: 'Banco',
      key: 'bank',
      sortable: true
    }, {
      label: 'Favorecido',
      key: 'favored_name',
      sortable: true
    }]
  }
};

var sysUsers = exports.sysUsers = {
  name: 'Usuários',
  key: 'sys-users',
  url: '/system/users',
  api: _sysUsers2.default,
  form: _forms2.default.System.User,
  formOptions: {
    api: {
      params: {
        with: ['address.city', 'bankAccounts.file']
      }
    },
    'omit': ['address.city', 'first_name', 'last_name']
  },
  indexComponent: _Datatable2.default,
  sort: 'id:desc',
  tableOptions: {
    with: ['authorization'],
    fields: [{
      label: '',
      key: 'authorization.completed',
      component: _ToggleOptionElement2.default,
      props: {
        disabled: true,
        classes: ['fa fa-check-circle-o', 'fa fa-times-circle-o']
      },
      style: 'width: 30px;'
    }, {
      align: 'left',
      label: '#',
      key: 'id',
      sortable: true,
      style: 'width: 80px;'
    }, {
      label: 'Perfil',
      key: 'main_role.name',

      class: 'text-ellipsis'
    }, {
      label: 'Nome',
      key: 'name',
      sortable: true,

      class: 'text-ellipsis'
    }, {
      label: 'Email',
      key: 'email',
      sortable: true,

      class: 'text-ellipsis'
    }, {
      label: 'Documento',
      key: 'document',
      sortable: true,

      class: 'text-ellipsis'
    }],
    actions: [{ component: _ActivateUserElement2.default }, { component: _EditElement2.default }, { component: _DeleteElement2.default }]
  }
};

var processItems = exports.processItems = {
  name: 'Itens dos Processos',
  api: _blProcessitems2.default,
  url: '/bl/process-items',
  key: 'bl-process-items',
  form: _forms2.default.Bl.ProcessItem,
  formOptions: {
    api: {
      params: {
        with: ['media', 'file']
      }
    },
    omit: ['file']
  },
  indexComponent: _Datatable2.default,
  tableOptions: {
    with: ['process', 'category'],
    fields: [{
      label: '',
      key: 'status',
      component: _ToggleOptionElement2.default,
      style: 'width: 30px;'
    }, {
      align: 'left',
      label: '#',
      key: 'id',
      sortable: true,
      style: 'width: 80px;'
    }, {

      label: 'Processo',
      key: 'process.company_name',

      class: 'text-ellipsis'
    }, {

      label: 'Categoria',
      key: 'category.name',

      class: 'text-ellipsis'
    }, {
      label: 'Nome',
      key: 'name',
      sortable: true,

      class: 'text-ellipsis'
    }]
  },
  sortableComponent: _ProcessItemCard2.default,
  options: {
    with: ['file', 'media']
  }
};

var processItemsJurisprudence = exports.processItemsJurisprudence = {
  name: 'Arquivos Jurisprudência',
  url: '/bl/jurisprudence-files',
  key: 'bl-jurisprudence-files',
  api: _blJurisprudencefiles2.default,
  form: _forms2.default.Bl.JurisprudenceFile,
  formOptions: {
    api: {
      params: {
        with: ['media', 'file']
      }
    },
    omit: ['file']
  },
  indexComponent: _Datatable2.default,
  tableOptions: {
    with: ['category'],
    fields: [{
      label: '',
      key: 'status',
      component: _ToggleOptionElement2.default,
      style: 'width: 30px;'
    }, {
      align: 'left',
      label: '#',
      key: 'id',
      sortable: true,
      style: 'width: 80px;'
    }, {

      label: 'Categoria',
      key: 'category.name',

      class: 'text-ellipsis'
    }, {
      label: 'Nome',
      key: 'name',
      sortable: true,

      class: 'text-ellipsis'
    }]
  },
  sortableComponent: _JurisprudenceCategoryCard2.default,
  options: {
    with: ['file', 'media']
  }
};

var blProcessCategories = exports.blProcessCategories = {
  name: 'Categorias de Processos',
  form: _forms2.default.Bl.ProcessCategory,
  url: '/bl/process-categories',
  key: 'bl-process-categories',
  indexComponent: _Datatable2.default,
  tableOptions: {
    with: ['process'],
    fields: [{
      label: '',
      key: 'status',
      component: _ToggleOptionElement2.default,
      style: 'width: 30px;'
    }, {
      align: 'left',
      label: '#',
      key: 'id',
      sortable: true,
      style: 'width: 80px;'
    }, {
      label: 'Nome',
      key: 'name',
      sortable: true,

      class: 'text-ellipsis'
    }, {
      label: 'Processo',
      key: 'process.company_name',

      class: 'text-ellipsis'
    }, {
      label: 'Tipo',

      key: 'type_name',

      class: 'text-ellipsis'
    }]
  },
  options: {
    scopes: ['ordered'],
    component: _forms2.default.Bl.ProcessCategoryCard,
    name: 'Categorias'
  }
};

exports.default = {
  'bl-bankaccounts': blBankAccounts,

  'bl-banners': {
    name: 'Banners',
    form: _forms2.default.Bl.Banner,
    url: '/bl/banners',
    key: 'bl-banners',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.BannerCard,
      name: 'Banners'
    }
  },

  'bl-questions': {
    name: 'Dúvidas Frequentes',
    form: _forms2.default.Bl.Question,
    url: '/bl/questions',
    key: 'bl-questions',
    order: '/#/bl-questions-order/',
    indexComponent: _Datatable2.default,
    tableOptions: {
      export: ['id', 'query', 'answer'],
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Pergunta',
        key: 'query',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Resposta',
        key: 'answer',
        sortable: true
      }]
    }
  },

  'bl-questions-order': {
    name: 'Ordernar as Dúvidas Frequentes',
    form: _forms2.default.Bl.Question,
    url: '/bl/questions',
    key: 'bl-questions',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.QuestionCard,
      name: 'Dúvidas Frequentes'
    }
  },

  'bl-contacts': {
    name: 'Contatos',
    url: '/bl/contacts',
    key: 'bl-contacts',
    indexComponent: _Mailbox2.default,
    indexOptions: {
      omit: ['attachments'],
      with: ['attachments.file'],
      orderBy: 'created_at:desc',
      multipleAttachments: true,
      read: 'status'
    },
    filters: [{
      label: 'Lidos',
      icon: 'fa fa-envelope-open-o',
      params: ['status:1']
    }, {
      label: 'Não lidos',
      icon: 'fa fa-envelope',
      params: ['status:0']
    }]
  },

  'bl-career-contacts': {
    name: 'Trabalhe Conosco',
    url: '/bl/career-contacts',
    key: 'bl-career-contacts',
    indexComponent: _Mailbox2.default,
    indexOptions: {
      omit: ['file'],
      with: ['file'],
      orderBy: 'created_at:desc',
      read: 'status',
      attachments: 'file',
      multipleAttachments: false,
      subject: 'career',
      body: 'presentation'
    },
    filters: false
  },

  'bl-stories': {
    name: 'Notícias',
    url: '/bl/stories',
    key: 'bl-stories',
    form: _forms2.default.Bl.Story,
    formOptions: {
      api: {
        params: {
          with: ['media', 'seo', 'friendlyUrls']
        }
      }
    },
    indexComponent: _Datatable2.default,
    tableOptions: {
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        label: '',
        key: 'highlight',
        component: _ToggleOptionElement2.default,
        props: {
          labels: ['Destaque', 'Regular'],
          classes: ['fa fa-star', 'fa fa-star-o'],
          colors: ['#d39e00', 'gray']
        },
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Titulo',
        key: 'title',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Publicação',
        key: 'release_date',
        sortable: true,
        formatters: [{
          type: 'date',
          args: 'DD/MM/YYYY'
        }],

        class: 'text-ellipsis'
      }]
    }
  },

  'bl-story-categories': {
    name: 'Categoria de Notícias',
    url: '/bl/story-categories',
    key: 'bl-story-categories',
    order: '/#/bl-story-categories-order/',
    form: _forms2.default.Bl.StoryCategory,
    indexComponent: _Datatable2.default,
    tableOptions: {
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        label: '',
        key: 'highlight',
        component: _ToggleOptionElement2.default,
        props: {
          labels: ['Destaque', 'Regular'],
          classes: ['fa fa-star', 'fa fa-star-o'],
          colors: ['#d39e00', 'gray']
        },
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Nome',
        key: 'name',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Slug',
        key: 'slug',
        sortable: true,

        class: 'text-ellipsis'
      }]
    }
  },

  'bl-story-categories-order': {
    name: 'Ordernar as Categoria de Notícias',
    form: _forms2.default.Bl.StoryCategory,
    url: '/bl/story-categories',
    key: 'bl-story-categories',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.StoryCategoryCard,
      name: 'Categoria de Notícias'
    }
  },

  'bl-process-file-types': {
    name: 'Tipos de Processos',
    form: _forms2.default.Bl.ProcessFileType,
    url: '/bl/process-file-types',
    key: 'bl-process-file-types',

    indexComponent: _Datatable2.default,
    tableOptions: {
      with: ['role'],
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Nome',
        key: 'name',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Slug',
        key: 'slug',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Perfil',
        key: 'role.name',

        class: 'text-ellipsis'
      }]
    }
  },

  'bl-process-categories': blProcessCategories,

  'bl-processes': {
    name: 'Processos',
    form: _forms2.default.Bl.Process,
    formOptions: {
      api: {
        params: {
          with: ['media', 'submissions.attachments.file', 'submissions.user', 'submissions.type', 'followers']
        }
      }
    },
    url: '/bl/processes',
    key: 'bl-processes',

    indexComponent: _Datatable2.default,
    indexButtons: [_ExportAccountsButton2.default],
    tableOptions: {
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Nome',
        key: 'company_name',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Slug',
        key: 'slug',
        sortable: true,

        class: 'text-ellipsis'
      }]
    }
  },

  'bl-processes-order': {
    name: 'Ordernar os Processos',
    form: _forms2.default.Bl.Process,
    url: '/bl/processes',
    key: 'bl-processes',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.ProcessCard,
      name: 'Processos'
    }
  },

  'bl-process-items': processItems,

  'bl-jurisprudence-files': processItemsJurisprudence,

  'bl-process-types': {
    name: 'Tipos de processo',
    url: '/bl/process-types',

    key: 'bl-process-types',
    order: '/#/bl-process-types-order/',
    form: _forms2.default.Bl.ProcessType,
    formOptions: {
      api: {
        params: {
          with: []
        }
      },
      'omit': ['created_at', 'updated_at']
    },
    indexComponent: _Datatable2.default,
    sort: 'id:desc',
    tableOptions: {
      with: [],
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Nome',
        key: 'name',
        sortable: true,
        class: 'text-ellipsis'
      }, {
        label: 'Slug',
        key: 'slug',
        sortable: true,
        class: 'text-ellipsis'
      }],
      actions: [{ component: _OrderElement2.default }, { component: _EditElement2.default }, { component: _DeleteElement2.default }]
    }
  },

  'bl-process-types-order': {
    name: 'Ordernar os Tipos de Processos',
    form: _forms2.default.Bl.ProcessType,
    url: '/bl/process-types',
    key: 'bl-process-types',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.ProcessTypeCard,
      name: 'Tipos de Processos'
    }
  },

  'bl-jurisprudence-categories': {
    name: 'Categorias de Jurisprudência',
    url: '/bl/jurisprudence-categories',
    key: 'bl-jurisprudence-categories',
    order: '/#/bl-jurisprudence-categories-order/',
    form: _forms2.default.Bl.JurisprudenceCategory,
    indexComponent: _Datatable2.default,
    tableOptions: {
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Nome',
        key: 'name',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Slug',
        key: 'slug',
        sortable: true,

        class: 'text-ellipsis'
      }]
    }
  },

  'bl-jurisprudence-categories-order': {
    name: 'Ordernar as Categorias de Jurisprudência',
    form: _forms2.default.Bl.JurisprudenceCategory,
    url: '/bl/jurisprudence-categories',
    key: 'bl-jurisprudence-categories',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.JurisprudenceCategoryCard,
      name: 'Categorias de Jurisprudência'
    }
  },

  'bl-resumes': {
    name: 'Currículos',
    url: '/bl/resumes',
    key: 'bl-resumes',
    order: '/#/bl-resumes-order/',
    form: _forms2.default.Bl.Resume,
    indexComponent: _Datatable2.default,
    tableOptions: {
      fields: [{
        label: '',
        key: 'status',
        component: _ToggleOptionElement2.default,
        style: 'width: 30px;'
      }, {
        align: 'left',
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      }, {
        label: 'Nome',
        key: 'name',
        sortable: true,

        class: 'text-ellipsis'
      }, {
        label: 'Slug',
        key: 'slug',
        sortable: true,

        class: 'text-ellipsis'
      }]
    }
  },

  'bl-resumes-order': {
    name: 'Ordernar os Currículos',
    form: _forms2.default.Bl.Resume,
    url: '/bl/resumes',
    key: 'bl-resumes',
    indexComponent: _Sortable2.default,
    options: {
      component: _forms2.default.Bl.ResumeCard,
      name: 'Currículos'
    }
  },

  'sys-users': sysUsers,

  'bl-authorizations': blAuthorizations
};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(67);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(775);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(778);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(779);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(780);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(792);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formBackendValidation = __webpack_require__(797);

var _formBackendValidation2 = _interopRequireDefault(_formBackendValidation);

var _util = __webpack_require__(800);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyForm = function (_Form) {
  (0, _inherits3.default)(MyForm, _Form);

  function MyForm() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, MyForm);
    return (0, _possibleConstructorReturn3.default)(this, (MyForm.__proto__ || (0, _getPrototypeOf2.default)(MyForm)).call(this, data, options));
  }

  (0, _createClass3.default)(MyForm, [{
    key: 'submit',
    value: function submit(requestType, url) {
      var _this2 = this;

      this.__validateRequestType(requestType);
      this.errors.clear();
      this.processing = true;
      this.successful = false;

      return new _promise2.default(function (resolve, reject) {
        _this2.__http[requestType](url, _this2.hasFiles() ? (0, _util.objectToFormData)(_this2.data()) : _this2.data()).then(function (response) {
          _this2.processing = false;
          _this2.onSuccess(response.data);

          resolve([response.data, response]);
        }).catch(function (error) {
          _this2.processing = false;
          _this2.onFail(error);

          reject(error);
        });
      });
    }
  }]);
  return MyForm;
}(_formBackendValidation2.default);

exports.default = MyForm;

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(11);

var _vuex2 = _interopRequireDefault(_vuex);

var _auth = __webpack_require__(460);

var _auth2 = _interopRequireDefault(_auth);

var _errors = __webpack_require__(605);

var _errors2 = _interopRequireDefault(_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  strict: true,

  modules: {
    auth: _auth2.default,
    errors: _errors2.default
  }
});

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseUrl = undefined;

var _promise = __webpack_require__(67);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(37);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(155);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(65);

var _store2 = _interopRequireDefault(_store);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _config = __webpack_require__(104);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseUrl = exports.baseUrl = _config2.default.dev.env.API_URL.replace(/"(.*)"/, '$1');

_axios2.default.defaults.baseURL = baseUrl;

_axios2.default.interceptors.request.use(function (req) {
  var token = _store2.default.getters['auth/token'];

  if (token) {
    req.headers.common = (0, _assign2.default)({}, req.headers.common, { Authorization: 'Bearer ' + token });
  }

  return req;
}, function (error) {
  return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    if (error.response.status === 422) {
      try {
        _store2.default.dispatch('errors/clearError', ['UnprocessableEntity']);
        _store2.default.dispatch('errors/setError', ['UnprocessableEntity', error.response.data]);
      } catch (e) {
        _store2.default.dispatch('errors/pushGlobalError', [{ message: 'Houve um erro ao identificar o problema com o upload' }]);
      }
    }

    if (error.response.status === 401) {
      _vue2.default.auth.logout({ redirect: { name: 'login' } });
    } else if (error.response.status === 500) {
      _vue2.default.router.push({ name: '500' });
    }
  }

  if (!error.response && error.request) {
    var errorMessage = {
      message: 'Houve um erro na servidor.'
    };

    _store2.default.dispatch('errors/pushGlobalError', [errorMessage]);
  }

  return _promise2.default.reject(error);
});

window.axios = _axios2.default;

exports.default = _axios2.default;

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(509)

module.exports = {
  build: {
    env: __webpack_require__(161),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: './',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: Object({"NODE_ENV":"production","API_URL":"https://api.bladmjudicial.com.br/v1","SITE_URL":"https://www.bladmjudicial.com.br"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(604),
    port: 8081,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  },
  local: __webpack_require__(123)
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  SITE_URL: '"https://www.bladmjudicial.com.br"',
  // SITE_URL: '"https://api-bladmjudicial.owinteractive.com/v1"',

  //API_URL: '"http://api.bladmjudicial.com.self/v1"'
  API_URL: '"https://api.bladmjudicial.com.br/v1"',
};


/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteElement_vue__ = __webpack_require__(399);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1705d36a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteElement_vue__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(872)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1705d36a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1705d36a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteElement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1705d36a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteElement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestPasswordReset = requestPasswordReset;
exports.fetchUser = fetchUser;

var _axios = __webpack_require__(101);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function requestPasswordReset(credentials) {
  return _axios2.default.post('/password/email', credentials);
}

function fetchUser(options) {
  return _axios2.default.get('/whoami');
}

exports.default = {
  requestPasswordReset: requestPasswordReset,
  fetchUser: fetchUser
};

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

const merge = __webpack_require__(162)
const localEnv = __webpack_require__(123)

module.exports = merge({
  NODE_ENV: '"production"',
  API_URL: '"production_api_url"',
  SITE_URL: '"production_site_url"',
}, localEnv)


/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContainerFull = __webpack_require__(608);

var _ContainerFull2 = _interopRequireDefault(_ContainerFull);

var _ContainerDefault = __webpack_require__(612);

var _ContainerDefault2 = _interopRequireDefault(_ContainerDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ContainerFull: _ContainerFull2.default,
  ContainerDefault: _ContainerDefault2.default
};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nav__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav___default.a.items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      processing: false,

      credentials: {
        username: '',
        password: ''
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    error: 'errors/getFirstGlobal',
    fieldError: 'errors/getFirstGlobalError'
  }), {
    usernameError: function usernameError() {
      return this.fieldError('username');
    },
    passwordError: function passwordError() {
      return this.fieldError('password');
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    storeToken: 'auth/storeToken',
    pushError: 'errors/pushGlobalError',
    clearError: 'errors/clearGlobalErrors'
  }), {
    login: function login() {
      var self = this;
      self.processing = true;

      self.clearError();
      self.$auth.login({
        params: self.credentials,
        success: function success() {
          self.processing = false;
          self.storeToken([self.$auth]);
        },
        error: function error(e) {
          self.processing = false;
          if (e.response) {
            self.pushError([e.response.data]);
          }
        },

        redirect: { name: 'app.dashboard' },
        rememberMe: true,
        fetchUser: true
      });
    }
  })
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_auth__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      success: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    error: 'errors/getFirstGlobal',
    fieldError: 'errors/getFirstGlobalError'
  }), {
    usernameError: function usernameError() {
      return this.fieldError('username');
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    pushError: 'errors/pushGlobalError',
    clearError: 'errors/clearGlobalErrors'
  }), {
    requestPasswordReset: function requestPasswordReset() {
      var self = this;

      self.clearError();

      Object(__WEBPACK_IMPORTED_MODULE_4__services_auth__["requestPasswordReset"])({ username: self.username }).then(function (res) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(res.headers, 'x-message-level') === 'success') {
          self.success = Object(__WEBPACK_IMPORTED_MODULE_3_he__["decode"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(res.headers, 'x-message-content'));
        }

        self.username = '';
      }).catch(function (e) {
        if (e.response) {
          self.pushError([e.response.data]);
        }
      });
    }
  })
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widgets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: {},

      cards: [{
        title: 'Usuários',
        key: 'users',
        showTotal: false,
        action: null
      }, {
        title: 'Total de Documentos',
        key: 'documents',
        showTotal: true,
        action: null
      }, {
        title: 'Últimas Noticias',
        key: 'stories',
        showTotal: true,
        action: null
      }],

      widgets: [__WEBPACK_IMPORTED_MODULE_1__components_widgets___default.a.Bl.Authorizations, __WEBPACK_IMPORTED_MODULE_1__components_widgets___default.a.Bl.ProcessFiles, __WEBPACK_IMPORTED_MODULE_1__components_widgets___default.a.System.User, __WEBPACK_IMPORTED_MODULE_1__components_widgets___default.a.Bl.Contacts]
    };
  },


  methods: {
    get: __WEBPACK_IMPORTED_MODULE_0_lodash__["get"],

    refresh: function refresh() {
      var self = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])('/dashboard/cards').index().then(function (res) {
        self.data = res.data;
      });
    }
  },

  created: function created() {
    this.refresh();
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_api__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-system-user',
  data: function data() {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos usuários cadastrados',
        caption: '',
        icon: 'fa fa-users',
        colSize: 6,
        entity: {
          url: '/system/users',
          params: {
            per_page: 5,
            _order: 'id:desc'
          }
        },
        link: {
          href: '/#/sys-users/',
          target: '_self'
        }
      }
    };
  },

  methods: {
    refresh: function refresh() {
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_0__services_api__["resolveHTTP"])(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection;
        self.pagination = res.data.pagination;
      });
    }
  },
  created: function created() {
    this.refresh();
  }
});

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_api__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-bl-career-contacts',
  data: function data() {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos Currículos enviados',
        icon: 'fa fa-briefcase',
        colSize: 12,
        entity: {
          url: '/bl/career-contacts',
          params: {
            per_page: 5,
            _order: 'id:desc'
          }
        },
        link: {
          href: '/#/bl-career-contacts/',
          target: '_self'
        }
      }
    };
  },


  methods: {
    refresh: function refresh() {
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_0__services_api__["resolveHTTP"])(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection;
        self.pagination = res.data.pagination;
      });
    }
  },
  created: function created() {
    this.refresh();
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-bl-process-files',

  data: function data() {
    return {
      items: [],
      pagination: [],

      options: {
        name: 'Últimos Documentos',
        icon: 'fa fa-files-o',
        colSize: 12,
        entity: {
          url: '/bl/process-submissions',
          params: {
            per_page: 5,
            _order: 'id:desc',
            with: ['type', 'user', 'attachments.file', 'process']
          }
        },
        link: {
          href: '/#/bl-processes/',
          target: '_self'
        }
      }
    };
  },

  methods: {
    get: __WEBPACK_IMPORTED_MODULE_0_lodash__["get"],

    refresh: function refresh() {
      var self = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["resolveHTTP"])(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection;
        self.pagination = res.data.pagination;
      });
    }
  },

  created: function created() {
    this.refresh();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_bl_authorizations__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_bl_authorizations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_api_bl_authorizations__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-system-user',
  data: function data() {
    return {
      show: false,
      authorization: null,
      declineModal: false,
      processingAuthorizations: [],

      collection: [],
      pagination: [],
      fields: [{ key: 'user', label: 'Usuário' }, { key: 'role', label: 'Perfil' }, { key: 'created_at', label: 'Data de criação' }, { key: 'actions', label: 'Ações' }],

      options: {
        name: 'Autorizações de Acesso Pendentes',
        caption: '',
        icon: 'fa fa-lock',
        colSize: 12,
        entity: {
          url: '/bl/authorizations',
          params: {
            with: ['user.roles'],
            _search: { status: 0 },
            per_page: 5
          }
        },

        route: {
          name: 'bl-authorizations.index'
        },

        link: false
      }
    };
  },


  computed: {},

  methods: {
    href: function href(item) {
      if (this.options.link) {
        return this.options.link.href + item.id || '#!';
      }

      return null;
    },
    approve: function approve(authorization) {
      var self = this;

      self.$Progress.start();
      self.processingAuthorizations.push(authorization.id);
      return __WEBPACK_IMPORTED_MODULE_0__services_api_bl_authorizations___default.a.approve(authorization).then(function (res) {
        var index = self.processingAuthorizations.indexOf(authorization.id);

        if (index > -1) {
          self.processingAuthorizations.splice(index, 1);
        }

        self.$Progress.finish();
        self.$toasted.success('Usuário autorizado com sucesso');
        self.refresh();
      });
    },
    showDeclineModal: function showDeclineModal(authorization) {
      this.authorization = authorization;
      this.declineModal = true;
    },
    decline: function decline() {
      var self = this;

      self.declineModal = false;
      self.$Progress.start();

      __WEBPACK_IMPORTED_MODULE_0__services_api_bl_authorizations___default.a.decline(self.authorization).then(function (res) {
        self.$Progress.finish();
        self.$toasted.success('Autorização negada e o usuário foi removido.');
        self.refresh();
        self.authorization = null;
      });
    },
    refresh: function refresh() {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0__services_api_bl_authorizations___default.a.index({
        params: self.options.entity.params
      }).then(function (res) {
        self.show = res.data.collection.length > 0;
        self.collection = res.data.collection;
        self.pagination = res.data.pagination;
      });
    }
  },

  created: function created() {
    this.refresh();
  }
});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var Api = (0, _api.resolveHTTP)('/bl/authorizations');

Api.decline = function (authorization) {
  return Api.resource.post('/decline/' + authorization.id);
};

Api.approve = function (authorization) {
  return Api.resource.post('/authorize/' + authorization.id);
};

exports.default = Api;

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_api__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget-bl-contacts',
  data: function data() {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos contatos',
        caption: '',
        icon: 'fa fa-envelope',
        colSize: 6,
        entity: {
          url: '/bl/contacts',
          params: {
            per_page: 5,
            _order: 'id:desc',
            _with: 'attachments.file'
          }
        },
        link: {
          href: '/#/bl-contacts/',
          target: '_self'
        }
      }
    };
  },

  methods: {
    refresh: function refresh() {
      var self = this;
      Object(__WEBPACK_IMPORTED_MODULE_0__services_api__["resolveHTTP"])(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection;
        self.pagination = res.data.pagination;
      });
    }
  },
  created: function created() {
    this.refresh();
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_form__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: true,
      processing: false,
      submitted: false,

      http: null,

      form: new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a({}, { resetOnSuccess: false }),
      empty: {
        contact_receivers: '',
        career_contact_receivers: '',
        authorization_receivers: '',
        rao_title: '',
        rao_phone: '',
        rao_address: '',
        rao_latitude: '',
        rao_longitude: '',
        sap_title: '',
        sap_phone: '',
        sap_address: '',
        sap_latitude: '',
        sap_longitude: '',
        privacy_policy_status: true,
        privacy_policy_text: '',
        cookies_status: true,
        cookies_text: ''
      }
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }), {
    setFormData: function setFormData(data) {
      this.form = new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a({
        contact_receivers: data.contact_receivers || '',
        career_contact_receivers: data.career_contact_receivers || '',
        authorization_receivers: data.authorization_receivers || '',
        rao_title: data.rao_title || '',
        rao_phone: data.rao_phone || '',
        rao_address: data.rao_address || '',
        rao_latitude: data.rao_latitude || '',
        rao_longitude: data.rao_longitude || '',
        sap_title: data.sap_title || '',
        sap_phone: data.sap_phone || '',
        sap_address: data.sap_address || '',
        sap_latitude: data.sap_latitude || '',
        sap_longitude: data.sap_longitude || '',
        privacy_policy_status: data.privacy_policy_status ? data.privacy_policy_status === '1' : true,
        privacy_policy_text: data.privacy_policy_text || '',
        cookies_status: data.cookies_status ? data.cookies_status === '1' : true,
        cookies_text: data.cookies_text || ''
      }, { resetOnSuccess: false });
    },
    refresh: function refresh() {
      var _this = this;

      var self = this;

      self.processing = true;
      self.http.index().then(function (res) {
        self.processing = false;
        self.setFormData(res.data);
        self.show = false;
        self.$nextTick(function () {
          _this.show = true;
        });
      }).catch(function () {
        self.processing = false;
        self.$toasted.info('Houve um erro receber as configurações');
      });
    },
    onSubmit: function onSubmit(evt) {
      var self = this;

      self.clearError(['UnprocessableEntity']);

      self.processing = true;
      self.submitted = false;

      self.form.put(self.http.getRoute('store')).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            data = _ref2[0],
            res = _ref2[1];

        self.submitted = true;
        self.processing = false;

        self.$toasted.success('Configurações atualizadas com sucesso');
      }).catch(function (e) {
        self.submitted = true;
        self.processing = false;
      });
    },
    onReset: function onReset(evt) {
      var _this2 = this;

      this.form.reset();
      this.submitted = false;

      this.show = false;
      this.$nextTick(function () {
        _this2.show = true;
      });
    }
  }),

  created: function created() {
    this.http = Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/settings');
  },
  mounted: function mounted() {
    this.refresh();
  }
});

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_sys_users__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_sys_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api_sys_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_form__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: true,
      processing: false,
      submitted: false,

      updatePassword: false,

      form: new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a({
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      }),

      empty: {
        name: '',
        email: ''
      }
    };
  },


  watch: {
    loggedUser: function loggedUser(value) {
      this.setFormData(value);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    isAuthenticated: 'auth/isAuthenticated',
    loggedUser: 'auth/user'
  }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])({
    token: 'auth/token'
  }), {

    ready: {
      get: function get() {
        var ready = this.$auth.ready() && this.isAuthenticated && !Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(this.loggedUser);

        if (ready) {
          this.onReset();
        }

        return ready;
      },
      set: function set() {}
    },

    avatarUrl: function avatarUrl() {
      return __WEBPACK_IMPORTED_MODULE_3__services_api_sys_users___default.a.avatarUrl(this.loggedUser);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    refreshTokenAndUser: 'auth/refreshTokenAndUser',
    fetchUser: 'auth/fetchUser'
  }), {
    togglePassword: function togglePassword() {
      this.updatePassword = !this.updatePassword;

      if (!this.updatePassword) {
        this.form.password = '';
        this.form.password_confirmation = '';
      }
    },
    onSubmit: function onSubmit() {
      var self = this;

      self.processing = true;
      self.submitted = false;

      if (!self.updatePassword) {
        delete self.form.password;
        delete self.form.password_confirmation;
      }

      self.form.put(__WEBPACK_IMPORTED_MODULE_3__services_api_sys_users___default.a.getRoute('update', self.loggedUser.id)).then(function (data) {
        self.submitted = true;
        self.processing = false;

        self.$toasted.success('Usuário atualizado com sucesso');

        self.setFormData(data);
        self.fetchUser();
      }).catch(function (e) {

        self.submitted = true;
        self.processing = false;
      });
    },
    onReset: function onReset() {
      var _this = this;

      this.form.reset();
      this.submitted = false;

      this.show = false;
      this.$nextTick(function () {
        _this.show = true;
      });
    },
    setFormData: function setFormData(userData) {
      this.form = new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a({
        name: userData.name,
        email: userData.email,
        password: '',
        password_confirmation: ''
      });
    }
  }),

  created: function created() {
    var self = this;

    self.setFormData(self.loggedUser || self.empty);
  }
});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var _axios = __webpack_require__(101);

var Api = (0, _api.resolveHTTP)('/system/users');

Api.avatarUrl = function (user) {
  return _axios.baseUrl + '/system/users/' + user.id + '/media';
};

exports.default = Api;

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_bl_authorizations__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_bl_authorizations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api_bl_authorizations__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      entity: null,

      caption: 'Autorizações pendentes',

      authorization: null,

      declineModal: false,

      collection: [],

      fields: [{ key: 'user', label: 'Usuário' }, { key: 'role', label: 'Perfil' }, { key: 'created_at', label: 'Data de criação' }, { key: 'actions', label: 'Ações' }]
    };
  },


  methods: {
    approve: function approve(authorization) {
      var self = this;

      self.$Progress.start();
      return __WEBPACK_IMPORTED_MODULE_1__services_api_bl_authorizations___default.a.approve(authorization).then(function (res) {
        self.$Progress.finish();
        self.$toasted.success('Usuário autorizado com sucesso');
        self.refreshCollection();
      });
    },
    showDeclineModal: function showDeclineModal(authorization) {
      this.authorization = authorization;
      this.declineModal = true;
    },
    decline: function decline() {
      var self = this;

      self.declineModal = false;
      self.$Progress.start();

      return __WEBPACK_IMPORTED_MODULE_1__services_api_bl_authorizations___default.a.decline(self.authorization).then(function (res) {
        self.$Progress.finish();
        self.$toasted.success('Autorização negada e o usuário foi removido.');
        self.refreshCollection();
        self.authorization = null;
      });
    },
    refreshCollection: function refreshCollection() {
      var self = this;

      self.$Progress.start();

      __WEBPACK_IMPORTED_MODULE_1__services_api_bl_authorizations___default.a.index({ params: {
          _search: { status: 0 },
          _with: 'user.roles',
          _onepage: true
        } }).then(function (res) {
        self.$Progress.finish();
        self.collection = res.data.collection;
      });
    }
  },

  created: function created() {
    this.entity = __WEBPACK_IMPORTED_MODULE_0__entities__["blAuthorizations"];

    this.refreshCollection();
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },
    submitted: {
      type: Boolean,
      default: false
    },
    instance: {
      type: Object,
      default: function _default() {
        return {
          file: {}
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false,
      locks: {
        categories: true
      },
      file: {},

      selectedCategory: null,
      categories: [],

      empty: {
        _attach_files: [],
        name: '',
        source: '',
        category_id: '',
        file: null,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form.category_id', false)) {
          this.selectedCategory = null;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form._attach_files', false))) {
          this.clearFileInput();
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !this.locks.categories;
    },
    uploadUrl: function uploadUrl() {
      return this.http.routes.uploadFile(this.instance.id);
    },
    fileInstance: function fileInstance() {
      var file = {};

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.file)) {
        file = this.file;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.file)) {
        file = this.instance.file;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance._links)) {
        file['_links'] = this.instance._links;
      }

      return file;
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    handleUploadFile: function handleUploadFile(file, response, progress) {
      if (this.form._attach_files === undefined) {
        this.form._attach_files = this.form.initial._attach_files || [];
      }
      this.form._attach_files.push(response);

      this.file = response;
    },
    handleRemoveFile: function handleRemoveFile(file) {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }

      this.clearFileInput();
    },
    removeFile: function removeFile() {
      var self = this;
      self.confirmRemoveModal = false;
      this.$Progress.start();
      self.http.destroyFile(self.instance.id, self.fileInstance.id).then(function (res) {
        self.clearFileInput();
        self.$toasted.success('Arquivo removido com sucesso');
        self.$emit('refresh');
      });
    },
    clearFileInput: function clearFileInput() {
      this.form._attach_files = [];
      this.file = {};
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["resolveHTTP"])('/bl/jurisprudence-categories').index({ params: { _onepage: true } }).then(function (res) {
      self.categories = res.data.collection;
      self.locks.categories = false;

      self.selectedCategory = self.form.category_id ? self.categories.find(function (o) {
        return o.id === self.form.category_id;
      }) : null;
    });

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(self.instance);

      self.form.category_id = self.instance.category_id || null;
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty);
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__plugins__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      processing: false,
      show: true,
      userEditedSlug: false,

      locks: {
        processes: true,
        types: true,
        items: true
      },

      selectedProcess: null,
      processes: [],

      selectedType: null,
      types: [],

      processItemEntity: null,
      items: [],

      empty: {
        name: '',
        slug: null,
        process_id: null,
        type_id: null,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.process_id', false)) {
          this.selectedProcess = null;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.type_id', false)) {
          this.selectedType = null;
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !(this.locks.processes || this.locks.types || this.locks.items);
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_0_slugify___default()(self.form.name, __WEBPACK_IMPORTED_MODULE_4__plugins__["slugifyOptions"]);
      self.$nextTick(function () {
        self.show = true;
      });
    },
    refreshFileCollection: function refreshFileCollection() {
      var self = this;

      self.$Progress.start();

      self.processItemHttp.index({ params: {
          search: { 'category.id': self.form.id },
          _with: 'file',
          _onepage: true
        } }).then(function (res) {
        self.locks.items = false;
        self.$Progress.finish();
        self.items = res.data.collection;
      }).catch(function (e) {
        self.$Progress.fail();

        console.error(e);
      });
    },
    handleUploadFile: function handleUploadFile(file, response, progress) {
      this.items.push(response);
    },
    handleDrop: function handleDrop(_ref) {
      var newIndex = _ref.newIndex,
          oldIndex = _ref.oldIndex;

      var self = this;

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true;
        var previousId = null;

        if (newIndex !== 0) {
          previousId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(self.items[newIndex - 1], 'id', null);
        }

        var elementId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(self.items[newIndex], 'id');

        self.processItemHttp.resource.put(elementId + '/after/' + (previousId || '')).finally(function () {
          self.processing = false;
        });
      }
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = self.form.process_id ? self.processes.find(function (o) {
        return o.id === self.form.process_id;
      }) : null;
    });

    self.types = [{ id: 1, name: 'Imagem' }, { id: 2, name: 'Video' }, { id: 4, name: 'Arquivos' }];

    self.selectedType = self.form.type_id ? self.types.find(function (o) {
      return o.id === self.form.type_id;
    }) : null;

    self.locks.types = false;
    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
      self.form.process_id = self.instance.process_id || null;
      self.form.type_id = self.instance.type_id || null;
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty);
    }

    self.processItemEntity = __WEBPACK_IMPORTED_MODULE_2__entities__["processItemsJurisprudence"];
    self.processItemHttp = __WEBPACK_IMPORTED_MODULE_2__entities__["processItemsJurisprudence"].api || Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])(__WEBPACK_IMPORTED_MODULE_2__entities__["processItemsJurisprudence"].url);

    self.refreshFileCollection();
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JurisprudenceCategoryCard_vue__ = __webpack_require__(375);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce165060_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceCategoryCard_vue__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(819)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce165060"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JurisprudenceCategoryCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce165060_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceCategoryCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce165060_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceCategoryCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },

  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },
  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroy(self.instance.id).then(function (res) {
        location.reload();
        self.$toasted.success('Item removido com sucesso.');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__plugins__);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      processing: false,
      show: true,
      userEditedSlug: false,

      locks: {
        processes: true,
        types: true,
        items: true
      },

      selectedProcess: null,
      processes: [],

      selectedType: null,
      types: [],

      processItemEntity: null,
      items: [],
      resume: '',
      subtitle: '',

      empty: {
        name: '',
        slug: null,
        process_id: null,
        type_id: null,
        resume: '',
        subtitle: '',
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.process_id', false)) {
          this.selectedProcess = null;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.type_id', false)) {
          this.selectedType = null;
        }
      },
      resume: function resume(next) {
        Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, 'resume', next);
      },
      subtitle: function subtitle(next) {
        Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, 'subtitle', next);
      },

      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !(this.locks.processes || this.locks.types || this.locks.items);
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_0_slugify___default()(self.form.name, __WEBPACK_IMPORTED_MODULE_3__plugins__["slugifyOptions"]);
      self.$nextTick(function () {
        self.show = true;
      });
    },
    handleUploadFile: function handleUploadFile(file, response, progress) {
      this.items.push(response);
    },
    handleDrop: function handleDrop(_ref) {
      var newIndex = _ref.newIndex,
          oldIndex = _ref.oldIndex;

      var self = this;

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true;
        var previousId = null;

        if (newIndex !== 0) {
          previousId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(self.items[newIndex - 1], 'id', null);
        }

        var elementId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(self.items[newIndex], 'id');

        self.processItemHttp.resource.put(elementId + '/after/' + (previousId || '')).finally(function () {
          self.processing = false;
        });
      }
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = self.form.process_id ? self.processes.find(function (o) {
        return o.id === self.form.process_id;
      }) : null;
    });

    self.types = [{ id: 1, name: 'Imagem' }, { id: 2, name: 'Video' }, { id: 4, name: 'Arquivos' }];

    self.selectedType = self.form.type_id ? self.types.find(function (o) {
      return o.id === self.form.type_id;
    }) : null;

    self.locks.types = false;
    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
      self.resume = self.instance.resume;
      self.subtitle = self.instance.subtitle;
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty);
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },

  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },
  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroy(self.instance.id).then(function (res) {
        location.reload();
        self.$toasted.success('Item removido com sucesso.');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__plugins__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      processing: false,
      show: true,
      userEditedSlug: false,

      locks: {
        processes: true,
        types: true,
        items: true
      },

      selectedProcess: null,
      processes: [],

      selectedType: null,
      types: [],

      processItemEntity: null,
      items: [],

      empty: {
        name: '',
        slug: null,
        process_id: null,
        type_id: null,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.process_id', false)) {
          this.selectedProcess = null;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.type_id', false)) {
          this.selectedType = null;
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !(this.locks.processes || this.locks.types || this.locks.items);
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_0_slugify___default()(self.form.name, __WEBPACK_IMPORTED_MODULE_4__plugins__["slugifyOptions"]);
      self.$nextTick(function () {
        self.show = true;
      });
    },
    refreshFileCollection: function refreshFileCollection() {
      var self = this;

      self.$Progress.start();

      self.processItemHttp.index({ params: {
          search: { 'category.id': self.form.id },
          _with: 'file',
          _onepage: true
        } }).then(function (res) {
        self.locks.items = false;
        self.$Progress.finish();
        self.items = res.data.collection;
      }).catch(function (e) {
        self.$Progress.fail();

        console.error(e);
      });
    },
    handleUploadFile: function handleUploadFile(file, response, progress) {
      this.items.push(response);
    },
    handleDrop: function handleDrop(_ref) {
      var newIndex = _ref.newIndex,
          oldIndex = _ref.oldIndex;

      var self = this;

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true;
        var previousId = null;

        if (newIndex !== 0) {
          previousId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(self.items[newIndex - 1], 'id', null);
        }

        var elementId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(self.items[newIndex], 'id');

        self.processItemHttp.resource.put(elementId + '/after/' + (previousId || '')).finally(function () {
          self.processing = false;
        });
      }
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = self.form.process_id ? self.processes.find(function (o) {
        return o.id === self.form.process_id;
      }) : null;
    });

    self.types = [{ id: 1, name: 'Imagem' }, { id: 2, name: 'Video' }, { id: 4, name: 'Arquivos' }];

    self.selectedType = self.form.type_id ? self.types.find(function (o) {
      return o.id === self.form.type_id;
    }) : null;

    self.locks.types = false;
    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
      self.form.process_id = self.instance.process_id || null;
      self.form.type_id = self.instance.type_id || null;
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty);
    }

    self.processItemEntity = __WEBPACK_IMPORTED_MODULE_2__entities__["processItems"];
    self.processItemHttp = __WEBPACK_IMPORTED_MODULE_2__entities__["processItems"].api || Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])(__WEBPACK_IMPORTED_MODULE_2__entities__["processItems"].url);

    self.refreshFileCollection();
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {},

  methods: {}
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__plugins__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      show: true,
      userEditedSlug: false,

      empty: {
        name: '',
        slug: '',
        status: true
      }
    };
  },


  methods: {
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_1_slugify___default()(self.form.name, __WEBPACK_IMPORTED_MODULE_2__plugins__["slugifyOptions"]);
      self.$nextTick(function () {
        self.show = true;
      });
    }
  },

  created: function created() {
    var self = this;

    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
    } else {
      self.form.setInitialValues(this.empty);
      self.form.withData(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(this.empty));
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {},

  methods: {}
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {
          file: {}
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      show: true,
      showDeleteFileModal: false,
      deletableFile: null,

      locks: {
        processes: true,
        types: true
      },

      selectedProcess: null,
      processes: [],

      selectedFavoredType: null,
      types: [{ id: 1, name: 'Pessoa Física' }, { id: 2, name: 'Pessoa Jurídica' }],

      empty: {
        file: {},
        process_id: '',
        same_person: false,
        bank: '',
        agency: '',
        account_number: '',
        creditor_name: '',
        favored_name: '',
        favored_type: null,
        favored_document: '',
        observations: '',
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form.process_id', false)) {
          this.selectedProcess = null;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form.favored_type', false)) {
          this.selectedFavoredType = null;
        }
      },
      deep: true
    },

    selectedProcess: function selectedProcess() {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, 'process_id', Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedProcess, 'id', null));
    },
    selectedFavoredType: function selectedFavoredType() {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, 'favored_type', Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedFavoredType, 'id', null));
    }
  },

  computed: {
    ready: function ready() {
      return !(this.locks.processes || this.locks.types);
    }
  },

  methods: {
    get: __WEBPACK_IMPORTED_MODULE_0_lodash__["get"],
    set: __WEBPACK_IMPORTED_MODULE_0_lodash__["set"],

    updateForm: function updateForm(path, value, valuePath) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, path, Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isObject"])(value) ? Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(value || {}, valuePath || 'id', null) : value);
    },
    confirmDeleteFile: function confirmDeleteFile(file) {
      this.deletableFile = file;
      this.showDeleteFileModal = true;
    },
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.showDeleteFileModal = false;

      if (self.deletableFile === null) {
        return null;
      }

      self.processSubmissionsHttp.destroy(self.deletableFile.id).then(function (res) {
        self.$toasted.success('Envio removido com sucess');
        self.deletableFile = null;
        self.$emit('refresh');
      });
    }
  },

  created: function created() {
    var self = this;

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])(self.empty, self.instance));
    } else {
      self.form.withData(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(self.empty)).setInitialValues(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(self.empty));
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = self.form.process_id ? self.processes.find(function (o) {
        return o.id === parseInt(self.form.process_id, 10);
      }) : null;
    });

    self.selectedFavoredType = self.form.favored_type ? self.types.find(function (o) {
      return o.id === parseInt(self.form.favored_type, 10);
    }) : self.types[0];
    self.locks.types = false;
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      answer: '',

      empty: {
        query: '',
        answer: '',
        status: true
      }
    };
  },


  watch: {
    answer: function answer(next) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, 'answer', next);
    }
  },

  created: function created() {
    if (this.instance.id) {
      this.form.withData(this.instance).setInitialValues(this.instance);
      this.answer = this.instance.answer;
    } else {
      this.form.withData(this.empty).setInitialValues(this.empty);
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },

  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },
  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroy(self.instance.id).then(function (res) {
        self.$emit('item-removed', self.instance);
        self.$toasted.success('Tipo de processo removido com sucesso.');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__plugins__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__entities__);










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },
    submitted: {
      type: Boolean,
      default: false
    },
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      locks: {
        types: true
      },
      selectedType: null,
      types: [],
      show: true,
      showDeleteFileModal: false,
      deletableFile: null,
      userEditedSlug: false,

      description: '',

      media: null,

      datepickerOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_4__plugins__["datepickerOptions"], {
        format: 'MM/YYYY'
      }),

      followersFields: {
        name: {
          sortable: true,
          label: 'Nome'
        },
        email: {
          sortable: false
        },
        main_role_name: {
          label: 'Perfil'
        }
      },

      categoryEntity: __WEBPACK_IMPORTED_MODULE_6__entities__["blProcessCategories"],
      categoryHttp: null,

      submissionFilter: '',
      submissionPagination: {
        current: 1,
        perPage: 10,
        total: 0
      },
      submissionDefaultSort: 'created_at',
      submissionFields: [{
        key: 'id',
        sortable: false,
        label: 'Código'
      }, {
        key: 'user_name',
        sortable: true,
        label: 'Enviado por'
      }, {
        key: 'type_name',
        sortable: false,
        label: 'Categoria'
      }, {
        key: 'reference_date',
        sortable: true,
        label: 'Data Referência'
      }, {
        key: 'created_at',
        sortable: true,
        label: 'Recebido em'
      }, {
        key: 'actions',
        label: 'Ações'
      }],

      empty: {
        company_name: '',
        slug: '',
        description: '',
        date: '',
        type_id: '',
        media_ids: [],
        followers: [{
          name: '',
          email: '',
          main_role: {
            name: ''
          }
        }],
        status: true,
        popup_title: '',
        popup_description: '',
        popup_status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(newProps, 'form.type_id', false)) {
          this.selectedType = null;
        }
      },
      deep: true
    },
    description: function description(next) {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, 'description', next);
    }
  },

  computed: {
    ready: function ready() {
      return !this.locks.types;
    },
    mediaUrl: function mediaUrl() {
      return this.http.routes.uploadMedia(this.instance.id);
    },
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.media)) {
        return this.media;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    },
    followers: function followers() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.form, 'followers', []).map(function (follower) {
        follower.main_role_name = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(follower, 'main_role.name', '');

        return follower;
      });
    },
    submissions: function submissions() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.form, 'submissions', []).map(function (submission) {
        submission._showDetails = false;

        return submission;
      });
    },
    nestedCreateRoute: function nestedCreateRoute() {
      return {
        name: 'manageables.nested.create',
        params: {
          entity: 'bl-processes',
          id: this.form.id,
          nestedEntity: 'bl-process-categories'
        }
      };
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_2_lodash__["get"],
    set: __WEBPACK_IMPORTED_MODULE_2_lodash__["set"],

    updateForm: function updateForm(path, value, valuePath) {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, path, Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"])(value) ? Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(value || {}, valuePath || 'id', null) : value);
    },
    updateDate: function updateDate(_ref) {
      var date = _ref.date;

      this.form.date = date ? date.format('MM/YYYY') : null;
    },
    handleUploadMedia: function handleUploadMedia(file, response, progress) {
      this.form.media_ids = [response.id];
      this.media = response;
    },
    confirmDeleteFile: function confirmDeleteFile(file) {
      this.deletableFile = file;
      this.showDeleteFileModal = true;
    },
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.showDeleteFileModal = false;

      if (self.deletableFile === null) {
        return null;
      }

      self.processSubmissionsHttp.destroy(self.deletableFile.id).then(function (res) {
        self.$toasted.success('Envio removido com sucess');
        self.deletableFile = null;
        self.$emit('refresh');
      });
    },
    onFiltered: function onFiltered(filteredItems) {
      this.submissionPagination.total = filteredItems.length;
      this.submissionPagination.current = 1;
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_1_slugify___default()(self.form.company_name, __WEBPACK_IMPORTED_MODULE_4__plugins__["slugifyOptions"]);
      self.$nextTick(function () {
        self.show = true;
      });
    }
  },
  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_5__services_api__["resolveHTTP"])('/bl/process-types').index({ params: { _onepage: true } }).then(function (res) {
      self.types = res.data.collection;
      self.locks.types = false;

      self.selectedType = self.form.type_id ? self.types.find(function (o) {
        return o.id === self.form.type_id;
      }) : null;
    });

    self.processSubmissionsHttp = Object(__WEBPACK_IMPORTED_MODULE_5__services_api__["resolveHTTP"])('/bl/process-submissions');

    if (self.instance.id) {
      self.form.withData(this.instance).setInitialValues(self.instance);
      self.form.type_id = self.instance.type_id || null;
      var m = __WEBPACK_IMPORTED_MODULE_3_moment___default()(self.instance.date, 'YYYY-MM-DD HH:ii:ss');
      self.form.date = m.format('MM/YYYY');
      self.description = self.instance.description;
    } else {
      self.form.withData(this.empty).setInitialValues(this.empty);
    }

    self.categoryHttp = self.categoryEntity.api || Object(__WEBPACK_IMPORTED_MODULE_5__services_api__["resolveHTTP"])(self.categoryEntity.url);
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {
          media: [],
          file: {}
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      userEditedSlug: false,
      confirmRemoveModal: false,

      locks: {
        processes: true,
        categories: true
      },

      media: {},
      file: {},

      selectedProcess: null,
      processes: [],

      selectedCategory: null,


      empty: {
        _attach_files: [],
        name: '',
        source: '',
        slug: '',
        category_id: null,
        process_id: null,
        media_ids: [],
        file: null,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form.process_id', false)) {
          this.selectedProcess = null;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form.category_id', false)) {
          this.selectedCategory = null;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form._attach_files', false))) {
          this.clearFileInput();
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !(this.locks.processes || this.locks.categories);
    },
    categories: function categories() {
      if (this.selectedProcess !== null) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedProcess, 'categories', []);
      }

      return [];
    },
    categoryType: function categoryType() {
      if (this.selectedCategory !== null) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedCategory, 'type_id', []);
      }

      return [];
    },
    uploadUrl: function uploadUrl() {
      return this.http.routes.uploadFile(this.instance.id);
    },
    fileInstance: function fileInstance() {
      var file = {};

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.file)) {
        file = this.file;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.file)) {
        file = this.instance.file;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this._links)) {
        file['_links'] = this._links;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance._links)) {
        file['_links'] = this.instance._links;
      }

      return file;
    },
    mediaUrl: function mediaUrl() {
      return this.http.routes.uploadMedia(this.instance.id);
    },
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.media)) {
        return this.media;
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }
      return {};
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_0_lodash__["get"],

    handleUploadMedia: function handleUploadMedia(file, response, progress) {
      this.form.media_ids = [response.id];
      this.media = response;
    },
    handleUploadFile: function handleUploadFile(file, response, progress) {
      if (this.form._attach_files === undefined) {
        this.form._attach_files = this.form.initial._attach_files || [];
      }
      this.form._attach_files.push(response);
      this.file = response;
    },
    handleRemoveFile: function handleRemoveFile(file) {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }

      this.clearFileInput();
    },
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroyFile(self.instance.id, self.fileInstance.id).then(function (res) {
        self.clearFileInput();
        self.$toasted.success('Arquivo removido com sucesso');
        self.$emit('refresh');
      });
    },
    clearFileInput: function clearFileInput() {
      this.form._attach_files = [];
      this.file = {};
    },
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    slugify: function slugify() {
      if (this.userEditedSlug) {
        return;
      }

      this.form.slug = __WEBPACK_IMPORTED_MODULE_1_slugify___default()(this.form.name);
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true, _with: 'categories' } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = self.form.process_id ? self.processes.find(function (o) {
        return o.id === self.form.process_id;
      }) : null;

      self.selectedCategory = self.form.category_id ? self.categories.find(function (o) {
        return o.id === self.form.category_id;
      }) : null;
    });

    if (self.instance.id) {
      self.form.setInitialValues(self.instance);

      self.form.process_id = self.instance.process_id || null;
      self.form.category_id = self.instance.category_id || null;
    } else {
      self.form.withData(self.empty).setInitialValues(this.empty);
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__plugins__);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      show: true,
      userEditedSlug: false,

      locks: {
        roles: true
      },

      selectedRole: null,
      roles: [],

      empty: {
        name: '',
        slug: '',
        role_id: null,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.role_id', false)) {
          this.selectedRole = null;
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !this.locks.roles;
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_0_slugify___default()(self.form.name, __WEBPACK_IMPORTED_MODULE_3__plugins__["slugifyOptions"]);

      self.$nextTick(function () {
        self.show = true;
      });
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])('/system/roles').index({ params: { _onepage: true } }).then(function (res) {
      self.roles = res.data.collection;
      self.locks.roles = false;

      self.selectedRole = self.form.role_id ? self.roles.find(function (o) {
        return o.id === self.form.role_id;
      }) : null;
    });

    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
      self.form.role_id = self.instance.role_id || null;
    } else {
      self.form.setInitialValues(this.empty);
      self.form.withData(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["clone"])(this.empty));
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__plugins__);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      show: true,
      userEditedSlug: false,

      locks: {
        roles: true
      },

      selectedRole: null,
      roles: [],

      empty: {
        name: '',
        slug: '',
        role_id: null,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(newProps, 'form.role_id', false)) {
          this.selectedRole = null;
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !this.locks.roles;
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_0_slugify___default()(self.form.name, __WEBPACK_IMPORTED_MODULE_3__plugins__["slugifyOptions"]);

      self.$nextTick(function () {
        self.show = true;
      });
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])('/system/roles').index({ params: { _onepage: true } }).then(function (res) {
      self.roles = res.data.collection;
      self.locks.roles = false;

      self.selectedRole = self.form.role_id ? self.roles.find(function (o) {
        return o.id === self.form.role_id;
      }) : null;
    });

    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
      self.form.role_id = self.instance.role_id || null;
    } else {
      self.form.setInitialValues(this.empty);
      self.form.withData(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["clone"])(this.empty));
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },


  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },

  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;

      self.http.destroy(self.instance.id).then(function (res) {
        self.$emit('item-removed', self.instance);
        self.$toasted.success('Banner removido com sucesso');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },

  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },
  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroy(self.instance.id).then(function (res) {
        self.$emit('item-removed', self.instance);
        self.$toasted.success('Dúvida frequente removido com sucesso.');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },

  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },
  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroy(self.instance.id).then(function (res) {
        self.$emit('item-removed', self.instance);
        self.$toasted.success('Tipo de processo removido com sucesso.');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      media: {},

      selectedTarget: null,
      targets: [{ id: 1, text: 'Mesma Janela' }, { id: 2, text: 'Nova Janela' }],

      empty: {
        heading: '',
        subheading: '',
        media_ids: [],
        alignment: 'left',
        anchor_label: '',
        anchor_target: 0,
        anchor_url: '',
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps, oldProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(newProps, 'form.anchor_target', false)) {
          this.selectedTarget = null;
        }
      },
      deep: true
    },

    selectedTarget: function selectedTarget() {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, 'anchor_target', Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedTarget, 'id', null));
    }
  },

  computed: {
    mediaUrl: function mediaUrl() {
      return this.http.routes.uploadMedia(this.instance.id);
    },
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.media)) {
        return this.media;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    handleUploadMedia: function handleUploadMedia(file, response, progress) {
      this.form.media_ids = [response.id];

      this.media = response;
    }
  },

  created: function created() {
    var self = this;

    self.form.withData(self.instance.id ? self.instance : self.empty).setInitialValues(self.instance.id ? self.instance : self.empty);

    self.selectedTarget = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(self.form, 'anchor_target', false) ? self.targets.find(function (o) {
      return parseInt(o.id, 10) === parseInt(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(self.form, 'anchor_target', 0), 10);
    }) : self.targets[0];
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__entities__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {
          roles: [{}],
          avatar: []
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      bankAccountEntity: __WEBPACK_IMPORTED_MODULE_4__entities__["blBankAccounts"],
      bankAccountHttp: __WEBPACK_IMPORTED_MODULE_4__entities__["blBankAccounts"].api || Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])(__WEBPACK_IMPORTED_MODULE_4__entities__["blBankAccounts"].url),

      selectedEntityType: null,
      entityTypes: [{ value: 1, label: 'Pessoa Física' }, { value: 2, label: 'Pessoa Jurídica' }],

      locks: {
        processes: true,
        categories: true
      },

      media: {},

      updatePassword: false,

      empty: {
        name: '',
        email: '',
        password: '',
        document: '',
        phone_number: '',
        role: '',
        password_confirmation: '',
        profile: {},
        address: {},
        roles: [{}],
        media_ids: [],
        _authorized: true
      },

      selectedRole: {},
      roles: [],

      selectedProcess: null,
      processes: [],

      show: false
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps, oldProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(newProps, 'form.role_id', false)) {
          this.selectedRole = null;
          this.form.role = '';
        }

        if (!this.form.role && Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(newProps, 'form.role_id', false)) {
          Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, 'roles', [Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedRole, 'id', null)]);
          this.form.role = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedRole, 'slug', '');
        }

        if (this.selectedProcess && !Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(newProps, 'form.profile.process_id', false)) {
          this.selectedProcess = null;
        }
      },
      deep: true
    },

    selectedProcess: function selectedProcess() {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, 'profile.process_id', Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedProcess, 'id', null));
    },
    selectedRole: function selectedRole() {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, 'roles', [Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedRole, 'id', null)]);
      this.form.role = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedRole, 'slug', '');
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    ready: function ready() {
      return !(this.locks.roles || this.locks.processes);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    loggedUser: 'auth/user'
  }), {
    showAddress: function showAddress() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedRole, 'slug', 'admin') !== 'admin';
    },
    emptyInstance: function emptyInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.instance, 'id', null) === null;
    },
    mediaUrl: function mediaUrl() {
      return this.http.routes.uploadMedia(this.instance.id);
    },
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.media)) {
        return this.media;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.instance.avatar_url)) {
        return { url: this.instance.avatar_url };
      }

      return {};
    },
    profileEntityType: function profileEntityType() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self, 'selectedRole.slug', false) === 'attorney' ? 'client_type' : 'entity_type';
    },
    documentMask: function documentMask() {
      if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.selectedEntityType, 'value', 1) === 1) {
        return '###.###.###-##';
      }

      return '##.###.###/####-##';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    get: __WEBPACK_IMPORTED_MODULE_2_lodash__["get"]

  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    fetchUser: 'auth/fetchUser'
  }), {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    handleUploadMedia: function handleUploadMedia(file, response, progress) {
      this.form.media_ids = [response.id];

      this.media = response;

      if (this.instance.id === this.loggedUser.id) {
        this.fetchUser();
      }
    },
    togglePassword: function togglePassword() {
      this.updatePassword = !this.updatePassword;

      if (!this.updatePassword) {
        this.form.password = '';
        this.form.password_confirmation = '';
      }
    }
  }),

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.show = true;
    });
  },
  created: function created() {
    var self = this;

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(self.empty, self.instance));
      self.selectedRole = self.instance.roles.length ? self.instance.roles[0] : {};
    } else {
      self.updatePassword = true;
      self.form.withData(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.empty)).setInitialValues(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.empty));
    }

    var profile = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.form, 'profile', false);
    if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"])(profile) || !Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"])(profile)) {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(self.form, 'profile', {});
    }

    self.form.roles = [Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.selectedRole, 'id', null)];
    self.form.role_id = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.selectedRole, 'id', null);
    self.form.role = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.selectedRole, 'slug', null);

    Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/system/roles').index({ params: { _onepage: true } }).then(function (res) {
      self.roles = res.data.collection;
      self.locks.roles = false;

      self.selectedRole = self.form.role_id ? self.roles.find(function (o) {
        return o.id === self.form.role_id;
      }) : null;
    });

    Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.form, 'profile.process_id', false) ? self.processes.find(function (o) {
        return o.id === Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.form, 'profile.process_id', false);
      }) : null;
    });
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__plugins__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default: function _default() {
        return {
          media: [],
          friendlyUrls: []
        };
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      show: true,
      userEditedSlug: false,

      locks: {
        processes: true,
        categories: true
      },

      media: {},

      datepickerOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_4__plugins__["datepickerOptions"]),

      selectedCategory: null,
      categories: [],

      selectedProcess: null,
      processes: [],

      empty: {
        slug: '',
        title: '',
        headline: '',
        body: '',
        release_date: '',
        process_id: null,
        category_id: null,
        media_ids: [],
        highlight: false,
        status: true
      }
    };
  },


  watch: {
    '$props': {
      handler: function handler(newProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(newProps, 'form.process_id', false)) {
          this.selectedProcess = null;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(newProps, 'form.category_id', false)) {
          this.selectedCategory = null;
        }
      },
      deep: true
    }
  },

  computed: {
    ready: function ready() {
      return !(this.locks.categories || this.locks.processes);
    },
    friendlyUrls: function friendlyUrls() {
      return this.instance ? Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.instance, 'friendly_urls', []) : [];
    },
    mediaUrl: function mediaUrl() {
      return this.http.routes.uploadMedia(this.instance.id);
    },
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.media)) {
        return this.media;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },

  methods: {
    updateForm: function updateForm(path, value) {
      Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(this.form, path, value ? value.id : null);
    },
    updateReleaseDate: function updateReleaseDate(_ref) {
      var date = _ref.date,
          oldDate = _ref.oldDate;

      this.form.release_date = date ? date.format('YYYY-MM-DD HH:mm:ss') : null;
    },
    handleUploadMedia: function handleUploadMedia(file, response, progress) {
      this.form.media_ids = [response.id];

      this.media = response;
    },
    slugify: function slugify() {
      var self = this;

      if (this.userEditedSlug) {
        return;
      }

      self.show = false;
      self.form.slug = __WEBPACK_IMPORTED_MODULE_1_slugify___default()(self.form.title, __WEBPACK_IMPORTED_MODULE_4__plugins__["slugifyOptions"]);
      self.$nextTick(function () {
        self.show = true;
      });
    }
  },

  created: function created() {
    var self = this;

    Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/bl/story-categories').index({ params: { _onepage: true } }).then(function (res) {
      self.categories = res.data.collection;
      self.locks.categories = false;

      self.selectedCategory = self.form.category_id ? self.categories.find(function (o) {
        return o.id === self.form.category_id;
      }) : null;
    });

    Object(__WEBPACK_IMPORTED_MODULE_3__services_api__["resolveHTTP"])('/bl/processes').index({ params: { _onepage: true } }).then(function (res) {
      self.processes = res.data.collection;
      self.locks.processes = false;

      self.selectedProcess = self.form.process_id ? self.processes.find(function (o) {
        return o.id === self.form.process_id;
      }) : null;
    });

    if (self.instance.id) {
      self.form.setInitialValues(self.instance);
      self.form.category_id = self.instance.category_id || null;
      self.form.process_id = self.instance.process_id || null;
      self.releaseDate = self.instance.release_date || null;
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty);
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datatable_vue__ = __webpack_require__(396);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a57886_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(869)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datatable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a57886_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a57886_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatatableElements_EditElement__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DatatableElements_DeleteElement__ = __webpack_require__(136);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    filter: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    card: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      processing: false,

      collection: [],

      pagination: {},
      emptyPagination: {
        current_page: 1,
        total: 0,
        last_page: null,
        from: 1,
        to: 1,
        per_page: 10
      },

      per_pageOptions: [10, 25, 50],

      input: {},
      emptyInput: {
        page: 1,
        per_page: 10,
        search: '',
        orderBy: { name: 'created_at', direction: 'desc' }
      },

      defaultActions: [{ component: __WEBPACK_IMPORTED_MODULE_3__DatatableElements_EditElement__["default"] }, { component: __WEBPACK_IMPORTED_MODULE_4__DatatableElements_DeleteElement__["default"] }]
    };
  },


  watch: {
    entity: function entity(prev, next) {
      var nextEntity = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(next, 'key', null);
      var previousEntity = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(prev, 'key', null);

      if (nextEntity !== previousEntity) {
        this.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.emptyPagination);
        this.input = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.emptyInput);

        this.firstPageSearch();
      }
    }
  },

  computed: {
    options: function options() {
      return this.entity.tableOptions || { fields: [], actions: [] };
    },
    actions: function actions() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.entity, 'tableOptions.actions', this.defaultActions);
    }
  },

  methods: {
    get: __WEBPACK_IMPORTED_MODULE_2_lodash__["get"],

    firstPageSearch: function firstPageSearch() {
      this.input.page = this.pagination.current_page = 1;

      this.search();
    },
    callDebouncedFirstPageSearch: function callDebouncedFirstPageSearch() {
      this.debouncedFirstPageSearch(this);
    },
    search: function search() {
      var self = this;

      self.$nextTick(function () {
        self.processing = true;
        self.$Progress.start();
        var search = [self.input.search, self.filter];

        self.http.index({ params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.input), { search: search }), {
            with: self.options.with || [],
            orderBy: self.options.orderBy || self.input.orderBy
          }) }).then(function (res, body) {
          self.$Progress.finish();
          self.processing = false;
          self.collection = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(res.data, 'collection', []);
          self.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(res.data, 'pagination', Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.emptyPagination));

          self.pagination.per_page = parseInt(self.pagination.per_page, 10);
        }).catch(function (error) {
          self.$Progress.fail();
          self.error = error;
          self.processing = false;
          self.collection = [];
          self.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.emptyPagination);

          return null;
        });
      });
    },


    debouncedFirstPageSearch: Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (context) {
      context.input.page = context.pagination.current_page = 1;

      context.search();
    }, 1000, { 'maxWait': 8000 }),

    sortCollection: function sortCollection(field) {
      var self = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.input, 'orderBy.name', null) === field.key) {
        Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(self.input, 'orderBy.direction', Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.input, 'orderBy.direction', 'desc') === 'asc' ? 'desc' : 'asc');
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(self.input, 'orderBy.name', field.key);
        Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["set"])(self.input, 'orderBy.direction', 'asc');
      }

      self.firstPageSearch();
    },
    applyFormatters: function applyFormatters(field, value) {
      var result = value;

      if (field.formatters) {
        for (var i = 0; i < field.formatters.length; i++) {
          switch (field.formatters[i]['type']) {
            case 'date':
              result = __WEBPACK_IMPORTED_MODULE_1_moment___default()(result, 'YYYY-MM-DD HH:mm::ss').format(field.formatters[i]['args']);
          }
        }
      }

      return result;
    }
  },

  created: function created() {
    this.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.emptyPagination);
    this.input = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.emptyInput);

    this.firstPageSearch();
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditElement_vue__ = __webpack_require__(398);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4593c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditElement_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(870)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f4593c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4593c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditElement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4593c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditElement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Editar'
    },

    icon: {
      type: String,
      default: 'fa fa-pencil-square-o'
    },

    to: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    route: function route() {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.to)) {
        return {
          name: 'manageables.edit',
          params: {
            entity: this.entity.key,
            id: this.instance.id
          }
        };
      }

      return this.to;
    }
  },

  methods: {
    goToRoute: function goToRoute() {
      this.$router.push(this.route);
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Remover'
    },

    icon: {
      type: String,
      default: 'fa fa-trash-o'
    }
  },

  data: function data() {
    return {
      processing: false,
      showDeleteModal: false
    };
  },

  methods: {
    remove: function remove() {
      var _this = this;

      var self = this;
      self.processing = true;
      this.$Progress.start();
      self.http.destroy(self.instance.id).then(function (res) {
        self.processing = false;
        _this.$Progress.finish();
        self.$toasted.success('Remoção realizada com sucesso');
        self.$emit('refresh');
      }).catch(function () {
        self.processing = false;
        _this.$Progress.fail();
        self.$toasted.info('Houve um erro ao remover o item');
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_sys_activations__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_sys_activations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_api_sys_activations__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Ativar'
    },

    icon: {
      type: String,
      default: 'fa fa-check-circle'
    }
  },

  data: function data() {
    return {
      processing: false,
      showConfirmModal: false,
      activationHttp: null
    };
  },


  methods: {
    activate: function activate() {
      var self = this;

      self.$Progress.start();
      self.processing = true;
      self.showConfirmModal = false;

      self.activationHttp.force(self.instance).then(function (res) {
        self.$Progress.finish();
        self.processing = false;
        self.$toasted.success('Usuário ativado com sucesso');
        self.$emit('refresh');
      }).catch(function () {
        self.$Progress.fail();
        self.processing = false;
        self.$toasted.info('Houve um erro ao tentar ativar o usuário');
      });
    },
    resend: function resend() {
      var self = this;

      self.processing = true;
      self.$Progress.start();
      self.showConfirmModal = false;

      self.activationHttp.resend(self.instance).then(function (res) {
        self.$Progress.finish();
        self.processing = false;
        self.$toasted.success('Um novo email foi enviado para o usuário');
        self.$emit('refresh');
      }).catch(function () {
        self.$Progress.fail();
        self.processing = false;
        self.$toasted.info('Houve um erro ao tentar enviar o email para o usuário');
      });
    }
  },

  created: function created() {
    this.activationHttp = __WEBPACK_IMPORTED_MODULE_0__services_api_sys_activations___default.a;
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'Ordernar'
    },

    icon: {
      type: String,
      default: 'fa fa-sort'
    },

    to: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    route: function route() {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.to)) {
        return {
          path: '/bl-processes-order/?type_id=' + this.instance.id,
          params: {
            entity: this.entity.key,
            id: this.instance.id
          }
        };
      }

      return this.to;
    }
  },

  methods: {
    goToRoute: function goToRoute() {
      this.$router.push(this.route);
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleOptionElement_vue__ = __webpack_require__(403);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a42906_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleOptionElement_vue__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(882)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4a42906"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleOptionElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a42906_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleOptionElement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a42906_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleOptionElement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    instance: {
      type: Object,
      required: true
    },

    field: {
      type: Object,
      required: true
    },

    values: {
      type: Array,
      default: function _default() {
        return [true, false];
      }
    },

    classes: {
      type: Array,
      default: function _default() {
        return ['fa fa-toggle-on', 'fa fa-toggle-off'];
      }
    },

    colors: {
      type: Array,
      default: function _default() {
        return ['green', 'gray'];
      }
    },

    labels: {
      type: Array,
      default: function _default() {
        return ['Ativo', 'Inativo'];
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },

    confirm: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      processing: false,
      showConfirmModal: false
    };
  },


  computed: {
    ready: function ready() {
      return [this.colors.length, this.classes.length, this.values.length].reduce(function (a, b) {
        return a === b ? a : NaN;
      });
    },
    index: function index() {
      return this.values.indexOf(this.instance[this.field.key]);
    },
    currentClass: function currentClass() {
      return this.classes[this.index];
    },
    color: function color() {
      return this.colors[this.index];
    },
    label: function label() {
      return this.labels[this.index];
    },
    nextIndex: function nextIndex() {
      return this.index < this.values.length - 1 ? this.index + 1 : 0;
    },
    nextValue: function nextValue() {
      return this.values[this.nextIndex];
    }
  },

  methods: {
    attemptUpdate: function attemptUpdate() {
      if (!this.disabled) {
        if (this.confirm) {
          this.showConfirmModal = true;
        } else {
          this.update();
        }
      }

      return null;
    },
    update: function update() {
      var self = this;
      var payload = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(self.instance);

      self.processing = true;
      self.$Progress.start();
      self.showConfirmModal = false;

      payload[self.field.key] = self.nextValue;

      self.http.update(self.instance.id, payload).then(function (res) {
        self.$Progress.finish();
        self.processing = false;
        self.instance[self.field.key] = self.nextValue;
        self.$emit('refresh');
        self.$toasted.success('Atualização realizada com sucesso');
      }).catch(function () {
        self.$Progress.fail();
        self.processing = false;
        self.$toasted.error('Atualização não foi realizada. Verifique se a operação é permitida.');
      });
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mailbox_vue__ = __webpack_require__(405);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d288135a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mailbox_vue__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(884)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d288135a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mailbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d288135a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mailbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d288135a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mailbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      instanceToDelete: null,
      processing: false,
      collection: [],
      selected: [],
      selectedContact: null,

      input: {},
      emptyInput: {
        page: 1,
        per_page: 10,
        q: '',
        search: [],
        orderBy: {
          name: null,
          direction: 'asc'
        }
      },

      pagination: {},
      emptyPagination: {
        current_page: 1,
        total: 0,
        last_page: null,
        from: 1,
        to: 1,
        per_page: 10
      }
    };
  },


  watch: {
    entity: function entity(next, prev) {
      var nextEntity = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(next, 'key', null);
      var previousEntity = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(prev, 'key', null);

      if (nextEntity !== previousEntity) {
        this.resetSearch();
      }
    },


    collection: {
      handler: function handler(next, prev) {
        this.selected = this.collection.filter(function (o) {
          return o.selected === true;
        }).map(function (o) {
          return parseInt(o.id);
        });
      },

      deep: true
    },

    selectedContact: function selectedContact(next) {
      if (next && !next.status) {
        var self = this;
        var payload = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["pickBy"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(next, Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.options, 'omit', [])), function (o) {
          return o != null;
        });

        self.http.update(next.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(payload, { status: true })).then(function () {
          self.$nextTick(function () {
            next.status = true;
          });
        });
      }
    }
  },

  computed: {
    options: function options() {
      return this.entity.indexOptions || { filters: [] };
    },
    filters: function filters() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.entity, 'indexOptions.filters', []);
    },
    attachmentsField: function attachmentsField() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.options, 'attachments', 'attachments');
    },
    subjectField: function subjectField() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.options, 'subject', 'subject');
    },
    bodyField: function bodyField() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.options, 'body', 'body');
    },
    allSelected: function allSelected() {
      return this.selected.length === this.collection.length;
    }
  },

  methods: {
    get: __WEBPACK_IMPORTED_MODULE_2_lodash__["get"],

    filterIsActive: function filterIsActive(filter) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["union"])(this.input.search, filter.params).length === this.input.search.length;
    },
    hasAttachments: function hasAttachments(instance) {
      if (instance[this.attachmentsField]) {
        if (instance[this.attachmentsField].constructor === Array) {
          return instance[this.attachmentsField].length > 0;
        }
      }

      return instance[this.attachmentsField] !== null;
    },
    isIntanceSelected: function isIntanceSelected(instance) {
      return this.selected.indexOf(instance.id) !== -1;
    },
    toggleSelected: function toggleSelected(instance) {
      var index = this.selected.indexOf(instance.id);

      if (index !== -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(instance.id);
      }
    },
    toggleSelectedAll: function toggleSelectedAll() {
      var self = this;
      var value = self.selected.length !== self.collection.length;
      self.collection.map(function (o) {
        o.selected = value;
      });
    },
    showDeleteModal: function showDeleteModal(instance) {
      this.instanceToDelete = instance;
    },
    remove: function remove() {
      var self = this;

      self.processing = true;
      self.$Progress.start();

      self.http.destroy(self.instanceToDelete.id).then(function (res) {
        self.$Progress.finish();
        self.instanceToDelete = null;
        self.selectedContact = null;
        self.processing = false;
        self.search();

        self.$toasted.success('Contato removido com sucesso');
      });
    },
    callDebouncedFirstPageSearch: function callDebouncedFirstPageSearch() {
      this.debouncedFirstPageSearch(this);
    },


    debouncedFirstPageSearch: Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (context) {
      context.input.page = context.pagination.current_page = 1;

      context.search();
    }, 1000, { 'maxWait': 8000 }),

    firstPageSearch: function firstPageSearch() {
      this.input.page = this.pagination.current_page = 1;

      this.search();
    },
    resetSearch: function resetSearch() {
      this.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.emptyPagination);
      this.input = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(this.emptyInput);

      this.firstPageSearch();
    },
    searchByFilter: function searchByFilter(filter) {
      if (filter.params) {
        this.input.search = filter.params;
      }

      this.firstPageSearch();
    },
    search: function search() {
      var self = this;

      this.$nextTick(function () {
        self.$Progress.start();
        self.processing = true;
        self.selectedContact = null;

        var cloneInput = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(self.input, {
          with: self.options.with || [],
          orderBy: self.options.orderBy || []
        }));

        if (cloneInput['q']) {
          cloneInput['search'].push(cloneInput['q']);
        }

        delete cloneInput['q'];

        self.http.index({ params: cloneInput }).then(function (res, body) {
          self.processing = false;
          self.$Progress.finish();
          self.collection = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(res.data, 'collection', []);
          self.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(res.data, 'pagination', Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.emptyPagination));

          self.pagination.per_page = parseInt(self.pagination.per_page, 10);
        }).catch(function (error) {
          self.error = error;
          self.$Progress.fail();
          self.processing = false;
          self.collection = [];
          self.pagination = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["clone"])(self.emptyPagination);

          return null;
        });
      });
    },
    applyFormatters: function applyFormatters(field, value) {
      var result = value;

      if (field.formatters) {
        for (var i = 0; i < field.formatters.length; i++) {
          switch (field.formatters[i]['type']) {
            case 'date':
              result = __WEBPACK_IMPORTED_MODULE_1_moment___default()(result, 'YYYY-MM-DD HH:mm').format(field.formatters[i]['args']);
          }
        }
      }

      return result;
    }
  },

  created: function created() {
    this.resetSearch();
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sortable_vue__ = __webpack_require__(407);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6eecbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sortable_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(886)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sortable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6eecbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sortable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6eecbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sortable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    filter: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    card: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      processing: false,

      collection: []
    };
  },


  watch: {
    entity: function entity(prev, next) {
      var nextEntity = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(next, 'key', null);
      var previousEntity = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(prev, 'key', null);

      if (nextEntity !== previousEntity) {
        this.getCollection();
      }
    }
  },

  computed: {
    options: function options() {
      return this.entity.options || {};
    }
  },

  methods: {
    getCollection: function getCollection() {
      var self = this;

      self.$Progress.start();
      self.processing = true;

      self.http.index({ params: {
          _onepage: true,
          search: self.filter,
          '_search[]': self.$route.query.type_id ? 'type_id:' + self.$route.query.type_id : '',
          scopes: self.options.scopes || [],
          with: self.options.with || []
        } }).then(function (res, body) {
        self.$Progress.finish();
        self.processing = false;
        self.collection = res.data.collection;
      });
    },
    removeFromCollection: function removeFromCollection(removedInstance) {
      var self = this;

      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["remove"])(self.collection, function (o) {
        return o.id === removedInstance.id;
      });
      self.$nextTick(function () {
        self.getCollection();
      });
    },
    handleDrop: function handleDrop(_ref) {
      var newIndex = _ref.newIndex,
          oldIndex = _ref.oldIndex;

      var self = this;

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true;
        var previousId = null;

        if (newIndex !== 0) {
          previousId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(self.collection[newIndex - 1], 'id', null);
        }

        var elementId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(self.collection[newIndex], 'id');

        self.http.resource.put(elementId + '/after/' + (previousId || '')).finally(function () {
          self.processing = false;
        });
      }
    }
  },

  created: function created() {
    this.getCollection();
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_bl_bankaccounts__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_bl_bankaccounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_api_bl_bankaccounts__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    entity: {
      type: [Object],
      required: true
    },

    http: {
      type: [Object],
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    exportRoute: function exportRoute() {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_bl_bankaccounts___default.a.exportRoute();
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    instance: {
      type: Object,
      default: function _default() {
        return {
          media: []
        };
      }
    },
    http: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      confirmRemoveModal: false
    };
  },

  computed: {
    mediaInstance: function mediaInstance() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.instance.media)) {
        return this.instance.media[0];
      }

      return {};
    }
  },
  methods: {
    removeFile: function removeFile() {
      var self = this;
      this.$Progress.start();
      self.confirmRemoveModal = false;
      self.http.destroy(self.instance.id).then(function (res) {
        location.reload();
        self.$toasted.success('Item removido com sucesso.');
      });
    },
    handleRemove: function handleRemove() {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      http: null,
      entity: null,
      parentEntity: null
    };
  },


  watch: {
    '$route': function $route(to, from) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(to, 'path', null);
      var prev = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(from, 'path', null);

      if (next !== prev) {
        this.resolveEntity();
      }
    }
  },

  computed: {
    nested: function nested() {
      return !!this.$route.params.nestedEntity && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.$route, 'meta.nested', false);
    }
  },

  methods: {
    resolveEntity: function resolveEntity() {
      var entity = void 0;

      if (this.nested) {
        this.parentEntity = __WEBPACK_IMPORTED_MODULE_1__entities___default.a[this.$route.params.entity];
        entity = __WEBPACK_IMPORTED_MODULE_1__entities___default.a[this.$route.params.nestedEntity];
      } else {
        entity = __WEBPACK_IMPORTED_MODULE_1__entities___default.a[this.$route.params.entity];
      }

      if (!entity) {
        this.$router.replace({ name: '404' });
      }

      if (entity) {
        this.entity = entity;
        if (entity.api) {
          this.http = entity.api;
        } else if (entity.url) {
          this.http = Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])(this.entity.url);
        }
      }

      if (!this.http) {}
    }
  },

  created: function created() {
    this.resolveEntity();
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    http: {
      type: Object,
      required: true
    },

    entity: {
      type: Object,
      required: true
    }
  },

  computed: {
    createRoute: function createRoute() {
      return {
        name: 'manageables.create',
        params: {
          entity: this.entity.key
        }
      };
    },
    orderRoute: function orderRoute() {
      return {
        name: this.entity.order,
        params: {
          entity: this.entity.key
        }
      };
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_form__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    http: {
      type: Object,
      required: true
    },

    entity: {
      type: Object,
      required: true
    },

    nested: {
      type: Boolean,
      default: false
    },

    parentEntity: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      form: new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a({}),
      method: 'post',
      action: '',

      processing: false,
      show: true,
      submitted: false,
      keepCreating: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }), {
    formSubmit: function formSubmit() {
      var self = this;

      self.clearError(['UnprocessableEntity']);

      self.processing = true;
      self.submitted = false;

      self.form.populate(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(self.form.data(), Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.entity, 'formOptions.omit', [])));

      self.form[self.method](self.http.getRoute('store')).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            data = _ref2[0],
            res = _ref2[1];

        self.submitted = true;
        self.processing = false;

        self.$emit('submitted', [data, res]);

        self.$toasted.success('Criação realizada com sucesso');

        if (!self.keepCreating) {
          if (!self.nested) {
            if (self.$route.params.entity === 'bl-process-categories') {
              self.$router.push({
                name: 'manageables.edit',
                params: {
                  entity: self.$route.params.entity,
                  id: res.headers['x-last-inserted-id']
                }
              });
            } else {
              self.$router.push({
                name: 'manageables.index',
                params: { entity: self.$route.params.entity }
              });
            }
          } else {
            self.$router.push({
              name: 'manageables.edit',
              params: {
                entity: self.entity.parent,
                id: self.$route.params.id
              }
            });
          }
        }
      }).catch(function (e) {
        self.submitted = true;
        self.processing = false;
      });
    },
    formReset: function formReset() {
      var _this = this;

      this.form.reset();
      this.processing = false;
      this.submitted = false;

      this.show = false;
      this.$nextTick(function () {
        _this.show = true;
      });
    }
  }),

  created: function created() {
    if (this.entity.create === false) {}
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_form__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    http: {
      type: Object,
      required: true
    },

    entity: {
      type: Object,
      required: true
    },

    nested: {
      type: Boolean,
      default: false
    },

    parentEntity: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      form: new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a({}),
      method: 'put',
      action: '',

      processing: false,
      show: false,
      submitted: false,

      instance: {}
    };
  },


  watch: {
    '$route': function $route(to, from) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(to, 'path', null);
      var prev = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(from, 'path', null);

      if (next !== prev) {
        this.refreshInstance();
      }
    }
  },

  computed: {
    hasChanges: function hasChanges() {
      return !Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEqual"])(this.form.data(), this.form.initial);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }), {
    formSubmit: function formSubmit() {
      var self = this;

      self.clearError(['UnprocessableEntity']);

      self.processing = true;
      self.submitted = false;

      self.form.populate(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(self.form.data(), Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(self.entity, 'formOptions.omit', [])));
      self.form[self.method](self.http.getRoute('update', self.instance.id)).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            data = _ref2[0],
            res = _ref2[1];

        self.submitted = true;
        self.processing = false;

        self.$toasted.success('Atualização realizada com sucesso');

        self.$emit('submitted', [data, res]);
        self.form.setInitialValues(data);

        self.refreshInstance();
      }).catch(function (e) {
        self.submitted = true;
        self.processing = false;
      });
    },
    formReset: function formReset() {
      var _this = this;

      this.form.reset();
      this.processing = false;
      this.submitted = false;

      this.show = false;
      this.$nextTick(function () {
        _this.show = true;
      });
    },
    refreshInstance: function refreshInstance() {
      var self = this;

      self.$Progress.start();
      self.http.show(!self.nested ? self.$route.params.id : self.$route.params.nestedId, (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["has"])(self.entity, 'formOptions') ? self.entity.formOptions.api : {}) || {}).then(function (res) {
        self.instance = res.data;
        self.form = new __WEBPACK_IMPORTED_MODULE_4__services_form___default.a(self.instance, { resetOnSuccess: false });

        self.show = false;
        self.$nextTick(function () {
          self.$Progress.finish();
          self.show = true;
        });
      });
    }
  }),

  created: function created() {
    this.refreshInstance();

    this.action = this.http.getRoute('update', this.$route.params.id);
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-aside'
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_api__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-breadcrumb',

  data: function data() {
    return {
      show: true,
      ready: true,
      crumbs: [],
      locks: {}
    };
  },


  watch: {
    '$route': function $route() {
      this.getCrumbs();
    },


    locks: {
      handler: function handler(nextLocks) {
        var ready = true;
        Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(nextLocks, function (value, key) {
          ready = ready && value;
        });

        this.ready = ready;
      },

      deep: true
    }
  },

  computed: {
    backRoute: function backRoute() {
      var backRoute = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.$route, 'meta.back', null);

      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(backRoute, 'params', this.$route.params);

      return backRoute;
    }
  },

  methods: {
    isLast: function isLast(index) {
      return index === this.crumbs.length - 1;
    },
    showName: function showName(crumb) {
      if (crumb.label) {
        crumb = crumb.label;
      }

      return crumb;
    },
    getEntity: function getEntity(route) {
      if (route.params) {
        if (route.meta && route.meta.entity === false) {
          return null;
        }

        if (route.meta && route.meta.nested) {
          return __WEBPACK_IMPORTED_MODULE_1__entities___default.a[route.params.nestedEntity] || null;
        }

        return __WEBPACK_IMPORTED_MODULE_1__entities___default.a[route.params.entity] || null;
      }

      return null;
    },
    getInstanceId: function getInstanceId(route) {
      if (route.params) {
        if (route.meta && route.meta.nested) {
          return route.params.nestedId;
        }

        return route.params.id;
      }

      return 0;
    },
    hasInstance: function hasInstance(route) {
      return this.getInstanceId(route) > 0;
    },
    getCrumbs: function getCrumbs() {
      var self = this;
      self.crumbs = [];

      function crawlEntity(entity, entityId, index) {
        index = index || 0;

        if (entity) {
          if (entityId > 0) {
            self.crumbs.splice(index, 0, {
              key: entity.key,
              id: parseInt(entityId, 10),
              label: '#' + entityId
            });

            self.show = false;
            self.$set(self.locks, entity.key + entityId, false);
            var entityHTTP = Object(__WEBPACK_IMPORTED_MODULE_2__services_api__["resolveHTTP"])(entity.url);

            entityHTTP.show(entityId).then(function (res) {
              var index = self.crumbs.findIndex(function (o) {
                return parseInt(o.id, 10) === parseInt(entityId, 10) && o.key === entity.key;
              });

              self.crumbs[index] = {
                key: entity.key,
                id: parseInt(entityId, 10),
                label: res.data.name || res.data.title || res.data.slug || '#' + res.data.id,
                route: {
                  name: 'manageables' + (entity.nested ? '.nested' : '') + '.edit',
                  params: {
                    entity: entity.nested ? entity.parent : entity.key,
                    id: entity.nested ? res.data[entity.parentKey] : entityId,
                    nestedEntity: entity.nested ? entity.key : null,
                    nestedId: entity.nested ? entityId : null
                  }
                }
              };

              if (entity.nested && entity.parent && entity.parentKey) {
                crawlEntity(__WEBPACK_IMPORTED_MODULE_1__entities___default.a[entity.parent], res.data[entity.parentKey], index);
              } else {
                self.crumbs.splice(index, 0, {
                  label: entity.name || entity.key,
                  route: {
                    name: 'manageables.index',
                    params: {
                      entity: entity.key
                    }
                  }
                });
              }

              self.$nextTick(function () {
                self.$set(self.locks, entity.key + entityId, true);
                self.show = true;
              });
            });
          } else {
            if (self.$route.meta && self.$route.meta.label) {
              self.crumbs.splice(index || 0, 0, {
                label: self.$route.meta.label
              });
            }

            if (entity.nested && entity.parent && self.$route.params.id) {
              crawlEntity(__WEBPACK_IMPORTED_MODULE_1__entities___default.a[entity.parent], self.$route.params.id, index);
            } else {
              self.crumbs.splice(index, 0, {
                label: entity.name || entity.key,
                route: {
                  name: 'manageables.index',
                  params: {
                    entity: entity.key
                  }
                }
              });
            }
          }
        }
      }

      var entity = self.getEntity(self.$route);
      var entityId = self.getInstanceId(self.$route);
      if (entity) {
        crawlEntity(entity, entityId);
      }

      if (self.$route.matched.length) {
        var firstRoute = self.$route.matched[0];

        self.crumbs.unshift({
          label: firstRoute.meta && firstRoute.meta.label ? firstRoute.meta.label : 'Início',
          route: firstRoute
        });
      }
    }
  },

  mounted: function mounted() {
    this.getCrumbs();
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-callout',

  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-footer'
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-header',

  data: function data() {
    return {
      confirmLogoutModal: false,

      search: '',

      siteUrl: __WEBPACK_IMPORTED_MODULE_1__config___default.a.local.SITE_URL.replace(/"/g, '')
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    isAuthenticated: 'auth/isAuthenticated',
    loggedUser: 'auth/user'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    storeToken: 'auth/storeToken',
    revokeToken: 'auth/revokeToken',
    fetchUser: 'auth/fetchUser'
  }), {
    logout: function logout() {
      var self = this;

      self.confirmLogoutModal = false;

      self.$auth.logout({
        success: function success() {
          self.revokeToken();
        },
        error: function error(e) {},

        redirect: { name: 'auth.login' }
      });
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }),

  created: function created() {
    var self = this;

    if (self.$auth.check() && !self.isAuthenticated) {
      self.storeToken([self.$auth]);
      self.fetchUser();
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(944);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
    SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String | Object,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37005290_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(939)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37005290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37005290_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37005290_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String | Object,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring) {
        if (this.url.substring(0, 4) === 'http') {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["has"])(self.badge, 'entity')) {
      var Api = Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["resolveHTTP"])(self.badge.entity);
      Api.index({
        params: {
          'per_page': 1,
          '_search[]': self.badge.search || null
        }
      }).then(function (res, body) {
        self.badge.text = res.data.pagination.total;
      }).catch(function (error) {
        self.error = error;
        return null;
      });
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a76ed05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a76ed05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a76ed05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(426);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'core-switch',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    label: {
      type: String,
      text: 'Status',
      default: false
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-groups',

  props: {
    options: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      processing: false,
      transmitRef: '',
      singleMediaOptions: {
        acceptedFileTypes: ['image/*'],
        clickable: false
      }
    };
  },


  props: {
    name: {
      type: String,
      default: 'media'
    },

    singleMediaRef: {
      type: String,
      default: 'SingleMediaRef'
    },

    url: {
      type: String,
      required: true
    },

    placeholder: {
      type: String,
      default: ''
    },

    collection: {
      type: String,
      default: 'default'
    },

    fields: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    source: {
      type: Object,
      default: function _default() {}
    },

    alt: {
      type: String,
      default: ''
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getError: 'errors/getError',
    hasError: 'errors/hasError'
  }), {
    options: function options() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["assign"])(this.singleMediaOptions, {
        url: this.url
      });
    },
    params: function params() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["assign"])(this.fields, {
        collection: this.collection
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }), {
    triggerBrowse: function triggerBrowse() {
      if (this.processing === false) {
        this.$refs[this.singleMediaRef].$refs[this.transmitRef].triggerBrowseFiles();
      }
    },
    handleSuccess: function handleSuccess() {
      var _this = this;

      this.$nextTick(function () {
        _this.clearError([_this.name]);
        _this.processing = false;
      });

      this.$emit('success', arguments[0], arguments[1], arguments[2]);
    },
    handleError: function handleError() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.processing = false;
      });

      this.$emit('error', arguments[0], arguments[1], arguments[2]);
    },
    handleProcessing: function handleProcessing() {
      this.processing = true;
      this.clearError([this.name]);

      this.$emit('processing', arguments[0]);
    }
  }),

  created: function created() {
    this.transmitRef = this.singleMediaRef + Math.random().toString(36).substr(2, 5);
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      processing: false,
      success: false,

      transmitRef: '',

      singleFileOptions: {
        dragClass: 'dragging',
        acceptedFileTypes: ['*'],
        clickable: false
      }
    };
  },


  props: {
    url: {
      type: String,
      required: true
    },

    name: {
      type: String,
      default: 'file'
    },

    singleFileRef: {
      type: String,
      default: 'SingleFileRef'
    },

    placeholder: {
      type: Object,
      default: function _default() {}
    },

    collection: {
      type: String,
      default: 'default'
    },

    fields: {
      type: Object,
      default: function _default() {}
    },

    value: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getError: 'errors/getError',
    hasError: 'errors/hasError'
  }), {
    emptyValue: function emptyValue() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.value);
    },
    options: function options() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])(this.singleFileOptions, {
        url: this.url
      });
    },
    params: function params() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])(this.fields, {
        collection: this.collection
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }), {
    triggerBrowse: function triggerBrowse() {
      if (this.processing === false) {
        this.$refs[this.singleFileRef].$refs[this.transmitRef].triggerBrowseFiles();
      }
    },
    handleSuccess: function handleSuccess() {
      var _this = this;

      this.$nextTick(function () {
        _this.clearError([_this.name]);
        _this.processing = false;
        _this.success = true;
      });

      this.$emit('success', arguments[0], arguments[1], arguments[2]);
    },
    handleError: function handleError() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.processing = false;
      });

      this.$emit('error', arguments[0], arguments[1], arguments[2]);
    },
    handleProcessing: function handleProcessing() {
      this.processing = true;
      this.clearError([this.name]);

      this.$emit('processing', arguments[0]);
    }
  }),

  filters: {
    fixed: function fixed(value, n) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(value).toFixed(n || 2);
    }
  },

  created: function created() {
    this.transmitRef = this.singleFileRef + Math.random().toString(36).substr(2, 5);
  }
});

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      processing: false,
      success: false,

      transmitRef: '',

      multiFileOptions: {
        dragClass: 'dragging',
        acceptedFileTypes: ['*'],
        clickable: false
      }
    };
  },


  props: {
    url: {
      type: String,
      required: true
    },

    name: {
      type: String,
      default: 'file'
    },

    multiFileRef: {
      type: String,
      default: 'SingleFileRef'
    },

    placeholder: {
      type: Object,
      default: function _default() {}
    },

    collection: {
      type: String,
      default: 'default'
    },

    fields: {
      type: Object,
      default: function _default() {}
    },

    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])({
    getError: 'errors/getError',
    hasError: 'errors/hasError'
  }), {
    emptyValue: function emptyValue() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.value);
    },
    options: function options() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["assign"])(this.multiFileOptions, {
        url: this.url
      });
    },
    params: function params() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["assign"])(this.fields, {
        collection: this.collection
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }), {
    triggerBrowse: function triggerBrowse() {
      if (this.processing === false) {
        this.$refs[this.multiFileRef].$refs[this.transmitRef].triggerBrowseFiles();
      }
    },
    handleSuccess: function handleSuccess() {
      var _this = this;

      this.$nextTick(function () {
        _this.clearError([_this.name]);
        _this.processing = false;
        _this.success = true;
      });

      this.$emit('success', arguments[0], arguments[1], arguments[2]);
    },
    handleError: function handleError() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.processing = false;
      });

      this.$emit('error', arguments[0], arguments[1], arguments[2]);
    },
    handleProcessing: function handleProcessing() {
      this.processing = true;
      this.clearError([this.name]);

      this.$emit('processing', arguments[0]);
    }
  }),

  filters: {
    fixed: function fixed(value, n) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(value).toFixed(n || 2);
    },
    json: function json(value) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
    }
  },

  created: function created() {
    this.transmitRef = this.multiFileRef + Math.random().toString(36).substr(2, 5);
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: 'media'
    },

    url: {
      type: String,
      required: true
    },

    maxFileSize: {
      type: Number,
      default: 200
    },

    method: {
      type: String,
      default: 'POST'
    },

    single: {
      type: Boolean,
      default: true
    },

    transmitRef: {
      type: String,
      default: 'TransmitRef'
    },

    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    transmitOptions: {
      type: Object,
      default: function _default() {
        return {
          withCredentials: true,
          clickable: false
        };
      }
    }
  },

  data: function data() {
    return {
      headers: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    token: 'auth/token'
  }), {
    options: function options() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])(this.transmitOptions, {
        url: this.url,
        method: this.method,
        headers: {
          Authorization: 'Bearer ' + (this.token || null)
        }
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    setError: 'errors/setError',
    pushGlobalError: 'errors/pushGlobalError'
  }), {
    handleError: function handleError(file, message, xhr) {
      if (file.status === 'error') {
        this.pushGlobalError([{ message: message }]);
      } else if (xhr && xhr.status === 422) {
        try {
          var error = JSON.parse(xhr.response);

          this.setError([this.name, error]);
        } catch (e) {
          console.error(e);

          this.pushGlobalError([{ message: 'Houve um erro ao identificar o problema com o upload' }]);
        }
      }

      this.$emit('error', arguments[0], arguments[1], arguments[2]);
    }
  }),

  filters: {
    json: function json(value) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: {
      type: Boolean,
      default: true
    },

    label: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox',

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    value: {
      default: true
    },

    uncheckedValue: {
      default: false
    },

    checked: {
      default: false
    }
  },

  computed: {
    isChecked: function isChecked() {
      return this.checked === this.value;
    }
  },

  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["a"] = ({
  replace: true,
  inherit: false,

  props: {
    value: {
      required: true
    },

    language: {
      type: String,
      required: false,
      default: 'pt-BR'
    },

    height: {
      type: Number,
      required: false,
      default: 350
    },

    minHeight: {
      type: Number,
      required: false,
      default: 160
    },

    maxHeight: {
      type: Number,
      required: false,
      default: 800
    },

    name: {
      type: String,
      required: false,
      default: ''
    },

    toolbar: {
      type: Array,
      required: false,
      default: function _default() {
        return [['font', ['bold', 'italic', 'underline', 'clear']], ['para', ['ul', 'ol', 'paragraph']], ['color', ['color']], ['insert', ['link', 'hr']]];
      }
    }
  },

  methods: {
    cleanPastedHTML: function cleanPastedHTML(input) {
      var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
      var output = input.replace(stringStripper, ' ');

      var commentSripper = new RegExp('<!--(.*?)-->', 'g');
      output = output.replace(commentSripper, '');
      var tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>', 'gi');

      output = output.replace(tagStripper, '');

      var badTags = ['style', 'script', 'applet', 'embed', 'noframes', 'noscript'];

      for (var i = 0; i < badTags.length; i++) {
        tagStripper = new RegExp('<' + badTags[i] + '.*?' + badTags[i] + '(.*?)>', 'gi');
        output = output.replace(tagStripper, '');
      }

      var badAttributes = ['style', 'start'];
      for (var _i = 0; _i < badAttributes.length; _i++) {
        var attributeStripper = new RegExp(' ' + badAttributes[_i] + '="(.*?)"', 'gi');
        output = output.replace(attributeStripper, '');
      }
      return output;
    }
  },

  created: function created() {
    this.isChanging = false;
    this.control = null;
  },
  mounted: function mounted() {
    if (this.minHeight > this.height) {
      this.minHeight = this.height;
    }
    if (this.maxHeight < this.height) {
      this.maxHeight = this.height;
    }

    var me = this;

    this.control = $(this.$el);

    this.control.summernote({
      lang: this.language,
      height: this.height,
      minHeight: this.minHeight,
      maxHeight: this.maxHeight,
      toolbar: this.toolbar,
      callbacks: {
        onInit: function onInit() {
          me.control.summernote('code', me.value);
        },
        onChange: function onChange() {
          if (!me.isChanging) {
            me.isChanging = true;
            var code = me.control.summernote('code');
            me.$emit('input', code === null || code.length === 0 ? null : code);

            me.$nextTick(function () {
              me.isChanging = false;
            });
          }
        },
        onPaste: function onPaste(e) {
          var updatePastedText = function updatePastedText() {
            me.isChanging = true;
            var original = me.control.summernote('code');


            var cleaned = me.cleanPastedHTML(original);

            var code = cleaned === null ? '' : cleaned;
            me.control.summernote('code', code);
            me.isChanging = false;

            me.control.summernote('code', code);
          };

          setTimeout(function () {
            updatePastedText();
            me.isChanging = false;
          }, 50);
        }
      }
    });
  },


  watch: {
    model: function model(val) {
      if (!this.isChanging) {
        this.isChanging = true;

        var code = val === null ? '' : val;
        this.control.summernote('code', code);
        this.isChanging = false;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    card: {
      type: Object,
      required: true
    },

    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    total: function total() {
      return this.data.reduce(function (c, o) {
        return c + (o.value || 0);
      }, 0);
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])('errors', {
    errors: function errors(state) {
      return state.all;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    'getErrors': 'errors/getErrors'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    clearError: 'errors/clearError'
  }))
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__entities__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    category: {
      required: true,
      type: Object
    }
  },

  data: function data() {
    return {
      entity: null,
      http: null,

      options: {
        acceptedFileTypes: ['image/*'],
        clickable: false,
        adapterOptions: {
          url: './upload.php'
        }
      },

      item: null,
      removeModal: false,

      collection: []
    };
  },


  methods: {
    triggerBrowse: function triggerBrowse() {
      this.$refs.uploader.triggerBrowseFiles();
    },
    refreshCollection: function refreshCollection() {
      var self = this;

      self.$Progress.start();

      self.http.index({ params: {
          search: { 'category.id': self.category.id },
          _with: 'file',
          _onepage: true
        } }).then(function (res) {
        self.$Progress.finish();
        self.collection = res.data.collection;
      }).catch(function (e) {
        self.$Progress.finish();

        console.error(e);
      });
    },
    handleUploadFile: function handleUploadFile(file, response, progress) {
      if (this.form._attach_files === undefined) {
        this.form._attach_files = this.form.initial._attach_files || [];
      }
      this.form._attach_files.push(response);
      this.file = response;
    },
    handleRemoveFile: function handleRemoveFile(file) {
      if (this.instance.id) {
        this.confirmRemoveModal = true;
        return null;
      }

      this.clearFileInput();
    },
    clearFileInput: function clearFileInput() {
      this.form._attach_files = [];
      this.file = {};
    }
  },

  created: function created() {
    this.entity = __WEBPACK_IMPORTED_MODULE_0__entities__["processItems"];
    this.http = __WEBPACK_IMPORTED_MODULE_0__entities__["processItems"].api || Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["resolveHTTP"])(__WEBPACK_IMPORTED_MODULE_0__entities__["processItems"].url);

    this.uploadUrl = this.http.storeByFileRoute();

    this.refreshCollection();
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_form__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_seo_friendly_urls__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_seo_friendly_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_api_seo_friendly_urls__);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    slugable: {
      type: String,
      default: ''
    },

    showUrls: {
      type: Boolean,
      default: false
    },

    form: {
      type: [Object],
      required: true
    },

    urls: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      empty: {
        title: '',
        description: ''
      },

      newUrl: '',

      urlForm: new __WEBPACK_IMPORTED_MODULE_2__services_form___default.a({
        url: ''
      })
    };
  },


  watch: {
    slugable: function slugable(newSlugable) {
      if (!this.form.frindly_url) {
        this.newUrl = this.slugify(newSlugable);
      }
    }
  },

  computed: {
    seo: function seo() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.form, 'seo', null) || this.empty;
    },
    friendlyUrl: function friendlyUrl() {
      return this.newUrl || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.form, 'friendly_url', '');
    }
  },

  methods: {
    slugify: __WEBPACK_IMPORTED_MODULE_1_slugify___default.a,

    updateSeo: function updateSeo(field, value) {
      var seo = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(this.seo);

      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(seo, field, value);

      this.form.seo = seo;
    },
    updateUrl: function updateUrl(value) {
      this.newUrl = value.toLowerCase();

      if (!this.form.friendlyUrls) {
        this.form.initial.friendlyUrls = [];
        this.form.friendlyUrls = [];
      }

      this.form.friendlyUrls[0] = { url: value.toLowerCase() };
    },
    checkUrl: function checkUrl() {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_3__services_api_seo_friendly_urls___default.a.check(self.form.id || null, self.friendlyUrl).then(function (res) {
        self.$toasted.success('Url checada. Não esqueça de salvar!');
        self.newUrl = res.data.url || self.friendlyUrl;
      });
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_api__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    form: {
      type: [Object],
      required: true
    }
  },

  data: function data() {
    return {
      address: {},
      processingCities: false,
      selectedCity: null,
      citiesApi: null,
      cities: [],

      empty: {
        id: null,
        zipcode: '',
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        city_id: null,
        status: true
      }
    };
  },


  watch: {
    form: {
      handler: function handler(nextForm) {
        var self = this;

        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(nextForm.address)) {
          self.$nextTick(function () {
            self.address = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(self.empty);
            self.form.address = self.address;
            self.selectedCity = null;
          });
        }
      },

      deep: true
    }
  },

  computed: {
    city: {
      get: function get() {
        return this.selectedCity || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.form, 'address.city', null);
      },
      set: function set(value) {
        this.selectedCity = value;
        this.updateForm('city_id', Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(value, 'id', null));
      }
    }
  },

  methods: {
    updateForm: function updateForm(field, value) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.address, field, value);
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["set"])(this.form, 'address.' + field, value);
    },
    searchCities: function searchCities(searchQuery) {
      return this.debouncedSearchCities(searchQuery, this);
    },


    debouncedSearchCities: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function (searchQuery, context) {
      var self = context;

      if (searchQuery) {
        self.processingCities = true;

        self.citiesApi.index({ params: { search: searchQuery } }).then(function (res) {
          self.processingCities = false;
          self.cities = res.data.collection;
        });
      }
    }, 500, { 'maxWait': 1000 }),

    clearCity: function clearCity(search) {
      this.city = null;
    }
  },

  created: function created() {
    this.selectedCity = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.form, 'address.city', null);
    this.citiesApi = Object(__WEBPACK_IMPORTED_MODULE_1__services_api__["resolveHTTP"])('/geo/cities');
  }
});

/***/ }),
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(88);

var _stringify2 = _interopRequireDefault(_stringify);

var _vuexRouterSync = __webpack_require__(451);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(11);

var _vuex2 = _interopRequireDefault(_vuex);

var _App = __webpack_require__(454);

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__(65);

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__(606);

var _router2 = _interopRequireDefault(_router);

var _plugins = __webpack_require__(20);

var _plugins2 = _interopRequireDefault(_plugins);

var _components = __webpack_require__(903);

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.router = _router2.default;
_vue2.default.use(_vuex2.default);
(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_vue2.default.use(_plugins2.default);
_vue2.default.use(_components2.default);

_vue2.default.use(__webpack_require__(990), {
  router: __webpack_require__(994),
  http: __webpack_require__(995),

  auth: {
    request: function request(req, token) {
      token = JSON.parse(token) || {};

      var accessToken = token.access_token;

      if (accessToken) {
        this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + accessToken });
      }

      return null;
    },
    response: function response(res) {
      var headers = this.options.http._getHeaders.call(this, res);
      var token = headers.Authorization || headers.authorization;

      if (token) {
        token = token.split(/Bearer:?\s?/i);
        return token[token.length > 1 ? 1 : 0].trim();
      }

      return (res.data || {}).access_token ? (0, _stringify2.default)(res.data) : null;
    }
  },

  authRedirect: { name: 'auth.login' },

  loginData: { url: 'login', method: 'POST', redirect: { name: 'index' }, fetchUser: false },
  refreshData: {
    url: 'refresh',
    method: 'POST',
    fetchUser: false,
    interval: 10080,
    error: function error() {
      _store2.default.dispatch('errors/pushGlobalError', [{
        message: 'Ocorreu um problema. Por favor faça o login.'
      }]);
      _store2.default.dispatch('auth/revokeToken');
      _router2.default.push({ name: 'auth.login' });
    }
  },
  fetchData: { url: 'whoami', method: 'GET', enabled: true }
});

_vue2.default.config.productionTip = true;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(137);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b045a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(455)
  __webpack_require__(458)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b045a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b045a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTH_CLEAR_USER = exports.AUTH_STORE_USER = exports.AUTH_SUCCESS = exports.AUTH_LOGOUT = exports.AUTH_REFRESH_TOKEN = exports.AUTH_REQUEST_TOKEN = undefined;

var _defineProperty2 = __webpack_require__(461);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(67);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(54);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _mutations;

var _auth = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTH_REQUEST_TOKEN = exports.AUTH_REQUEST_TOKEN = 'AUTH_REQUEST_TOKEN';
var AUTH_REFRESH_TOKEN = exports.AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
var AUTH_LOGOUT = exports.AUTH_LOGOUT = 'AUTH_LOGOUT';
var AUTH_SUCCESS = exports.AUTH_SUCCESS = 'AUTH_SUCCESS';

var AUTH_STORE_USER = exports.AUTH_STORE_USER = 'AUTH_STORE_USER';
var AUTH_CLEAR_USER = exports.AUTH_CLEAR_USER = 'AUTH_CLEAR_USER';

exports.default = {
  namespaced: true,

  state: {
    user: null,
    token: '',
    expires_in: null,
    type: null,
    status: false
  },

  getters: {
    isAuthenticated: function isAuthenticated(state) {
      return !!state.token;
    },

    user: function user(state) {
      return state.user || {};
    },

    token: function token(state) {
      return state.token || '';
    }
  },

  actions: {
    refreshTokenAndUser: function refreshTokenAndUser(_ref, _ref2) {
      var dispatch = _ref.dispatch;

      var _ref3 = (0, _slicedToArray3.default)(_ref2, 1),
          auth = _ref3[0];

      return new _promise2.default(function (resolve, reject) {
        dispatch('storeToken', [auth]);
        dispatch('fetchUser').then(function () {
          resolve();
        });
      });
    },
    storeToken: function storeToken(_ref4, _ref5) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var _ref6 = (0, _slicedToArray3.default)(_ref5, 1),
          auth = _ref6[0];

      commit(AUTH_SUCCESS, [auth]);
      dispatch('fetchUser');
    },
    revokeToken: function revokeToken(_ref7) {
      var commit = _ref7.commit;

      commit(AUTH_LOGOUT);
    },
    fetchUser: function fetchUser(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      return new _promise2.default(function (resolve, reject) {
        (0, _auth.fetchUser)().then(function (res) {
          commit(AUTH_STORE_USER, [res.data]);
          resolve();
        }).catch(function (e) {
          commit(AUTH_LOGOUT);

          if (e.response) {
            dispatch('errors/pushGlobalError', [e.response.data], { root: true });
          }

          reject(e);
        });
      });
    }
  },

  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, AUTH_REQUEST_TOKEN, function (state) {
    state.status = state.status;
  }), (0, _defineProperty3.default)(_mutations, AUTH_SUCCESS, function (state, _ref9) {
    var _ref10 = (0, _slicedToArray3.default)(_ref9, 1),
        auth = _ref10[0];

    var data = JSON.parse(auth.token());

    state.token = data.access_token;
    state.expires_in = data.expires_in;
    state.type = data.token_type;

    state.status = true;
  }), (0, _defineProperty3.default)(_mutations, AUTH_LOGOUT, function (state) {
    localStorage.removeItem('default_auth_token');

    state.user = null;
    state.token = '';
    state.expires_in = null;
    state.type = null;
    state.status = false;
  }), (0, _defineProperty3.default)(_mutations, AUTH_STORE_USER, function (state, _ref11) {
    var _ref12 = (0, _slicedToArray3.default)(_ref11, 1),
        user = _ref12[0];

    state.user = user;
  }), _mutations)
};

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

const merge = __webpack_require__(162)
const prodEnv = __webpack_require__(161)
const localEnv = __webpack_require__(123)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_URL: '"development_api_url"',
  SITE_URL: '"development_site_url"',
}, localEnv)


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERRORS_SET = exports.ERRORS_CLEAR = exports.ERRORS_SET_GLOBAL = exports.ERRORS_CLEAR_GLOBAL = undefined;

var _slicedToArray2 = __webpack_require__(54);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _lodash = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ERRORS_CLEAR_GLOBAL = exports.ERRORS_CLEAR_GLOBAL = 'ERRORS_CLEAR_GLOBAL';
var ERRORS_SET_GLOBAL = exports.ERRORS_SET_GLOBAL = 'ERRORS_SET_GLOBAL';
var ERRORS_CLEAR = exports.ERRORS_CLEAR = 'ERRORS_CLEAR';
var ERRORS_SET = exports.ERRORS_SET = 'ERRORS_SET';

exports.default = {
  namespaced: true,

  state: {
    all: [],
    global: []
  },

  getters: {
    hasGlobalErrors: function hasGlobalErrors(state) {
      return state.global.length > 0;
    },

    getError: function getError(state) {
      return function (field) {
        return state.all.find(function (o) {
          return field === o.name;
        });
      };
    },
    hasError: function hasError(state, getters) {
      return function (field) {
        return getters.getError(field) !== undefined;
      };
    },
    getErrors: function getErrors(state) {
      return function (fields) {
        return state.all.filter(function (o) {
          return fields.indexOf(o.name) !== -1;
        });
      };
    },
    hasAnyErrors: function hasAnyErrors(state) {
      return function (fields) {
        return (0, _lodash.intersection)(fields, (0, _lodash.keys)(state.all)).length > 0;
      };
    },
    getFirstGlobal: function getFirstGlobal(state) {
      if (state.global.length > 0) {
        return (0, _lodash.first)(state.global, null);
      }

      return null;
    },
    getFirstGlobalError: function getFirstGlobalError(state) {
      return function (field) {
        if (state.global.length === 0) {
          return undefined;
        }

        return (0, _lodash.first)((0, _lodash.get)((0, _lodash.first)(state.global, {}), 'errors.' + field, []));
      };
    }
  },

  actions: {
    setError: function setError(_ref, _ref2) {
      var commit = _ref.commit;

      var _ref3 = (0, _slicedToArray3.default)(_ref2, 3),
          name = _ref3[0],
          error = _ref3[1],
          important = _ref3[2];

      commit(ERRORS_SET, [name, error, important]);
    },
    clearError: function clearError(_ref4, _ref5) {
      var commit = _ref4.commit;

      var _ref6 = (0, _slicedToArray3.default)(_ref5, 1),
          name = _ref6[0];

      commit(ERRORS_CLEAR, [name]);
    },
    pushGlobalError: function pushGlobalError(_ref7, _ref8) {
      var commit = _ref7.commit;

      var _ref9 = (0, _slicedToArray3.default)(_ref8, 1),
          error = _ref9[0];

      commit(ERRORS_SET_GLOBAL, [error]);
    },
    clearGlobalErrors: function clearGlobalErrors(_ref10) {
      var commit = _ref10.commit;

      commit(ERRORS_CLEAR_GLOBAL);
    }
  },

  mutations: {
    ERRORS_SET: function ERRORS_SET(state, _ref11) {
      var _ref12 = (0, _slicedToArray3.default)(_ref11, 3),
          name = _ref12[0],
          error = _ref12[1],
          important = _ref12[2];

      state.all.push({
        name: name,
        important: important || false,
        data: error
      });
    },

    ERRORS_CLEAR: function ERRORS_CLEAR(state, _ref13) {
      var _ref14 = (0, _slicedToArray3.default)(_ref13, 1),
          name = _ref14[0];

      (0, _lodash.remove)(state.all, function (o) {
        return o.name === name;
      });

      state.all.splice(state.all.length, 0);
    },

    ERRORS_CLEAR_GLOBAL: function ERRORS_CLEAR_GLOBAL(state) {
      state.global = [];
    },

    ERRORS_SET_GLOBAL: function ERRORS_SET_GLOBAL(state, _ref15) {
      var _ref16 = (0, _slicedToArray3.default)(_ref15, 1),
          error = _ref16[0];

      state.global.push(error);
    }
  }
};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(607);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(65);

var _store2 = _interopRequireDefault(_store);

var _containers = __webpack_require__(193);

var _containers2 = _interopRequireDefault(_containers);

var _auth = __webpack_require__(616);

var _auth2 = _interopRequireDefault(_auth);

var _Dashboard = __webpack_require__(624);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Settings = __webpack_require__(774);

var _Settings2 = _interopRequireDefault(_Settings);

var _Profile = __webpack_require__(805);

var _Profile2 = _interopRequireDefault(_Profile);

var _ = __webpack_require__(807);

var _2 = _interopRequireDefault(_);

var _3 = __webpack_require__(809);

var _4 = _interopRequireDefault(_3);

var _AuthorizationIndex = __webpack_require__(811);

var _AuthorizationIndex2 = _interopRequireDefault(_AuthorizationIndex);

var _Handler = __webpack_require__(895);

var _Handler2 = _interopRequireDefault(_Handler);

var _Index = __webpack_require__(897);

var _Index2 = _interopRequireDefault(_Index);

var _Create = __webpack_require__(899);

var _Create2 = _interopRequireDefault(_Create);

var _Edit = __webpack_require__(901);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'auth',
    redirect: { name: 'auth.login' },
    component: _containers2.default.ContainerFull,
    meta: { auth: false },
    children: [{
      path: 'login',
      name: 'auth.login',
      component: _auth2.default.Login
    }, {
      path: 'forgot-password',
      name: 'auth.forgot-password',
      component: _auth2.default.ForgotPassword
    }]
  }, {
    path: '/',
    redirect: { name: 'app.dashboard' },
    name: 'index',
    component: _containers2.default.ContainerDefault,
    meta: {
      label: 'Home',
      auth: true,
      entity: false
    },
    children: [{
      path: '',
      name: 'app.dashboard',
      component: _Dashboard2.default,
      meta: {
        label: 'Dashboard',
        entity: false
      }
    }, {
      path: 'settings',
      name: 'app.settings',
      component: _Settings2.default,
      meta: {
        back: { name: 'app.dashboard' },
        label: 'Configurações',
        entity: false
      }
    }, {
      path: 'profile',
      name: 'app.profile',
      component: _Profile2.default,
      meta: {
        back: { name: 'app.dashboard' },
        label: 'Perfil',
        entity: false
      }
    }, {
      path: '/bl-authorizations',
      name: 'bl-authorizations.index',
      component: _AuthorizationIndex2.default,
      meta: {
        back: { name: 'app.dashboard' },
        label: 'Autorizações',
        entity: false
      }
    }, {
      path: ':entity([\\a-zA-Z-]+)',
      name: 'entity.handler',
      redirect: { name: 'manageables.index' },
      component: _Handler2.default,
      meta: {
        entity: true
      },
      children: [{
        path: '',
        name: 'manageables.index',
        component: _Index2.default,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Listagem'
        }
      }, {
        path: 'new',
        name: 'manageables.create',
        component: _Create2.default,
        meta: {
          back: { name: 'manageables.index' },
          label: 'Criar'
        }
      }, {
        path: ':id([0-9+]+)',
        name: 'manageables.edit',
        component: _Edit2.default,
        meta: {
          back: { name: 'manageables.index' },
          label: 'Editar'
        }
      }]
    }, {
      path: ':entity([\\a-zA-Z-]+)/:id([0-9+]+)/:nestedEntity([\\a-zA-Z-]+)',
      name: 'entity.handler',
      redirect: { name: 'manageables.edit' },
      component: _Handler2.default,
      meta: {
        entity: true
      },
      children: [{
        path: 'new',
        name: 'manageables.nested.create',
        component: _Create2.default,
        meta: {
          nested: true,
          back: { name: 'manageables.edit' },
          label: 'Criar'
        }
      }, {
        path: ':nestedId([0-9+]+)',
        name: 'manageables.nested.edit',
        component: _Edit2.default,
        meta: {
          nested: true,
          back: { name: 'manageables.edit' },
          label: 'Editar'
        }
      }]
    }]
  }, {
    path: '404',
    name: '404',
    component: _2.default
  }, {
    path: '500',
    name: '500',
    component: _4.default
  }, {
    path: '*',
    redirect: { name: 'index' }
  }]
});

router.beforeEach(function (to, from, next) {
  _store2.default.dispatch('errors/clearError', ['UnprocessableEntity']);

  next();
});

exports.default = router;

/***/ }),
/* 607 */,
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerFull_vue__ = __webpack_require__(194);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_033d95f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerFull_vue__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(609)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerFull_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_033d95f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerFull_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_033d95f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerFull_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-container"},[_c('div',{staticClass:"banner-container",staticStyle:{"background":"url('../../../static/img/banner.png') center/cover no-repeat"}}),_vm._v(" "),_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-row row justify-content-center align-items-center"},[_c('div',{staticClass:"col-xl-10 login-box"},[_vm._m(0),_vm._v(" "),_c('router-view')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"fadeInUp animation-delay1",staticStyle:{"font-weight":"bold"}},[_c('img',{attrs:{"src":__webpack_require__(611)}})])])}]


/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "../../static/img/logo.062f25d.png";

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerDefault_vue__ = __webpack_require__(195);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ef0e87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerDefault_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(613)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainerDefault_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ef0e87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerDefault_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ef0e87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainerDefault_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  items: [{
    title: true,
    name: 'Geral',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Banners',
    url: {
      name: 'manageables.index',
      params: { entity: 'bl-banners' }
    },
    icon: 'icon-picture'
  }, {
    name: 'Dúvidas Frequentes',
    url: {
      name: 'manageables.index',
      params: { entity: 'bl-questions' }
    },
    icon: 'icon-question'
  }, {
    name: 'Currículos',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-resumes'
      }
    },
    icon: 'fa fa-user-circle'
  }, {
    title: true,
    name: 'Processos',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Tipos de processo',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-process-types'
      }
    },
    icon: 'icon-list'
  }, {
    name: 'Processos',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-processes'
      }
    },
    icon: 'icon-drawer'
  }, {
    name: 'Categorias',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-process-categories'
      }
    },
    icon: 'fa fa-tags'
  }, {
    name: 'Arquivos',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-process-items'
      }
    },
    icon: 'fa fa-list-alt'
  }, {
    title: true,
    name: 'Jurisprudência',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Categorias',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-jurisprudence-categories'
      }
    },
    icon: 'fa fa-tags'
  }, {
    name: 'Arquivos',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-jurisprudence-files'
      }
    },
    icon: 'icon-docs'
  }, {
    title: true,
    name: 'Notícias',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Categorias',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-story-categories'
      }
    },
    icon: 'fa fa-tags'
  }, {
    name: 'Notícias',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-stories'
      }
    },
    icon: 'icon-list'
  }, {
    title: true,
    name: 'Contatos',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Contatos',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-contacts'
      }
    },
    icon: 'icon-envelope-letter',
    badge: {
      variant: 'success',
      text: null,
      entity: '/bl/contacts',
      search: 'status:0'
    }
  }, {
    name: 'Trabalhe Conosco',
    url: {
      name: 'manageables.index',
      params: {
        entity: 'bl-career-contacts'
      }
    },
    icon: 'fa fa-address-book-o'
  }, {
    title: true,
    name: 'Usuários e Permissões',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Usuários',
    url: {
      name: 'manageables.index',
      params: { entity: 'sys-users' }
    },
    icon: 'icon-user'
  }, {
    name: 'Autorizações',
    url: {
      name: 'bl-authorizations.index'
    },
    icon: 'icon-lock-open',
    badge: {
      variant: 'warning',
      text: null,
      entity: '/bl/authorizations',
      search: 'status:0'
    }
  }]
};

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('vue-progress-bar'),_vm._v(" "),_c('core-header'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('core-sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('core-breadcrumb'),_vm._v(" "),_c('div',{staticClass:"container-fluid alpha omega"},[_c('router-view')],1)],1),_vm._v(" "),_c('core-aside')],1)],1)}
var staticRenderFns = []


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(617);

var _Login2 = _interopRequireDefault(_Login);

var _ForgotPassword = __webpack_require__(620);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Login: _Login2.default,
  ForgotPassword: _ForgotPassword2.default
};

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(196);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a35fac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(618)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38a35fac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a35fac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a35fac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.error.message)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{},[_c('form',{staticClass:"needs-validation",attrs:{"autocomplete":"off","method":"POST","novalidate":""},on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"username"}},[_vm._v("\n          E-mail\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.username),expression:"credentials.username"}],class:{ 'form-control': true, 'is-invalid': _vm.usernameError },attrs:{"type":"email","id":"username","name":"username","placeholder":"Insira seu email","required":""},domProps:{"value":(_vm.credentials.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "username", $event.target.value)}}}),_vm._v(" "),(_vm.usernameError)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v("\n            "+_vm._s(_vm.usernameError)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("\n          Senha\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],class:{ 'form-control': true, 'is-invalid': _vm.passwordError },attrs:{"type":"password","id":"password","placeholder":"Digite sua senha","required":""},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),(_vm.passwordError)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v("\n            "+_vm._s(_vm.passwordError)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('button',{class:{
          'btn btn-primary btn-block btn-flat': true,
          'btn-loading': _vm.processing
        },attrs:{"type":"submit","disabled":_vm.processing}},[_vm._v("\n        \n        Entrar\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-group text-center auth-link"},[_c('router-link',{attrs:{"to":{ name: 'auth.forgot-password' }}},[_c('small',[_vm._v("\n            Esqueci minha senha\n          ")])])],1)])])])}
var staticRenderFns = []


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(197);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61edcdda_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(621)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61edcdda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61edcdda_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61edcdda_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */,
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.error.message)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v("\n      "+_vm._s(_vm.success)+"\n  ")]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"needs-validation",attrs:{"method":"POST","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();_vm.requestPasswordReset($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"username"}},[_vm._v("\n        E-mail\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],class:{ 'form-control': true, 'is-invalid': _vm.usernameError },attrs:{"type":"email","id":"username","name":"username","placeholder":"Insira o email para redefirnir sua senha","required":""},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),(_vm.usernameError)?_c('span',{staticClass:"invalid-feedback auth-link"},[_c('strong',[_vm._v("\n          "+_vm._s(_vm.usernameError)+"\n        ")])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block btn-flat",attrs:{"type":"submit"}},[_vm._v("\n      Redefinir Senha\n    ")]),_vm._v(" "),_c('div',{staticClass:"form-group text-center auth-link"},[_c('router-link',{attrs:{"to":{ name: 'auth.login' }}},[_c('small',[_vm._v("\n          Voltar para o Login\n        ")])])],1)])])}
var staticRenderFns = []


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(198);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f9347c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f9347c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f9347c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(626);

var _User2 = _interopRequireDefault(_User);

var _CareerContacts = __webpack_require__(762);

var _CareerContacts2 = _interopRequireDefault(_CareerContacts);

var _ProcessFiles = __webpack_require__(764);

var _ProcessFiles2 = _interopRequireDefault(_ProcessFiles);

var _Authorizations = __webpack_require__(767);

var _Authorizations2 = _interopRequireDefault(_Authorizations);

var _Contacts = __webpack_require__(770);

var _Contacts2 = _interopRequireDefault(_Contacts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  System: {
    User: _User2.default
  },

  Bl: {
    Authorizations: _Authorizations2.default,
    CareerContacts: _CareerContacts2.default,
    ProcessFiles: _ProcessFiles2.default,
    Contacts: _Contacts2.default
  }
};

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(199);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782b7af7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(627)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-782b7af7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782b7af7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782b7af7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 201,
	"./af.js": 201,
	"./ar": 202,
	"./ar-dz": 203,
	"./ar-dz.js": 203,
	"./ar-kw": 204,
	"./ar-kw.js": 204,
	"./ar-ly": 205,
	"./ar-ly.js": 205,
	"./ar-ma": 206,
	"./ar-ma.js": 206,
	"./ar-sa": 207,
	"./ar-sa.js": 207,
	"./ar-tn": 208,
	"./ar-tn.js": 208,
	"./ar.js": 202,
	"./az": 209,
	"./az.js": 209,
	"./be": 210,
	"./be.js": 210,
	"./bg": 211,
	"./bg.js": 211,
	"./bm": 212,
	"./bm.js": 212,
	"./bn": 213,
	"./bn.js": 213,
	"./bo": 214,
	"./bo.js": 214,
	"./br": 215,
	"./br.js": 215,
	"./bs": 216,
	"./bs.js": 216,
	"./ca": 217,
	"./ca.js": 217,
	"./cs": 218,
	"./cs.js": 218,
	"./cv": 219,
	"./cv.js": 219,
	"./cy": 220,
	"./cy.js": 220,
	"./da": 221,
	"./da.js": 221,
	"./de": 222,
	"./de-at": 223,
	"./de-at.js": 223,
	"./de-ch": 224,
	"./de-ch.js": 224,
	"./de.js": 222,
	"./dv": 225,
	"./dv.js": 225,
	"./el": 226,
	"./el.js": 226,
	"./en-au": 227,
	"./en-au.js": 227,
	"./en-ca": 228,
	"./en-ca.js": 228,
	"./en-gb": 229,
	"./en-gb.js": 229,
	"./en-ie": 230,
	"./en-ie.js": 230,
	"./en-il": 231,
	"./en-il.js": 231,
	"./en-nz": 232,
	"./en-nz.js": 232,
	"./eo": 233,
	"./eo.js": 233,
	"./es": 234,
	"./es-do": 235,
	"./es-do.js": 235,
	"./es-us": 236,
	"./es-us.js": 236,
	"./es.js": 234,
	"./et": 237,
	"./et.js": 237,
	"./eu": 238,
	"./eu.js": 238,
	"./fa": 239,
	"./fa.js": 239,
	"./fi": 240,
	"./fi.js": 240,
	"./fo": 241,
	"./fo.js": 241,
	"./fr": 242,
	"./fr-ca": 243,
	"./fr-ca.js": 243,
	"./fr-ch": 244,
	"./fr-ch.js": 244,
	"./fr.js": 242,
	"./fy": 245,
	"./fy.js": 245,
	"./gd": 246,
	"./gd.js": 246,
	"./gl": 247,
	"./gl.js": 247,
	"./gom-latn": 248,
	"./gom-latn.js": 248,
	"./gu": 249,
	"./gu.js": 249,
	"./he": 250,
	"./he.js": 250,
	"./hi": 251,
	"./hi.js": 251,
	"./hr": 252,
	"./hr.js": 252,
	"./hu": 253,
	"./hu.js": 253,
	"./hy-am": 254,
	"./hy-am.js": 254,
	"./id": 255,
	"./id.js": 255,
	"./is": 256,
	"./is.js": 256,
	"./it": 257,
	"./it.js": 257,
	"./ja": 258,
	"./ja.js": 258,
	"./jv": 259,
	"./jv.js": 259,
	"./ka": 260,
	"./ka.js": 260,
	"./kk": 261,
	"./kk.js": 261,
	"./km": 262,
	"./km.js": 262,
	"./kn": 263,
	"./kn.js": 263,
	"./ko": 264,
	"./ko.js": 264,
	"./ky": 265,
	"./ky.js": 265,
	"./lb": 266,
	"./lb.js": 266,
	"./lo": 267,
	"./lo.js": 267,
	"./lt": 268,
	"./lt.js": 268,
	"./lv": 269,
	"./lv.js": 269,
	"./me": 270,
	"./me.js": 270,
	"./mi": 271,
	"./mi.js": 271,
	"./mk": 272,
	"./mk.js": 272,
	"./ml": 273,
	"./ml.js": 273,
	"./mn": 274,
	"./mn.js": 274,
	"./mr": 275,
	"./mr.js": 275,
	"./ms": 276,
	"./ms-my": 277,
	"./ms-my.js": 277,
	"./ms.js": 276,
	"./mt": 278,
	"./mt.js": 278,
	"./my": 279,
	"./my.js": 279,
	"./nb": 280,
	"./nb.js": 280,
	"./ne": 281,
	"./ne.js": 281,
	"./nl": 282,
	"./nl-be": 283,
	"./nl-be.js": 283,
	"./nl.js": 282,
	"./nn": 284,
	"./nn.js": 284,
	"./pa-in": 285,
	"./pa-in.js": 285,
	"./pl": 286,
	"./pl.js": 286,
	"./pt": 287,
	"./pt-br": 288,
	"./pt-br.js": 288,
	"./pt.js": 287,
	"./ro": 289,
	"./ro.js": 289,
	"./ru": 290,
	"./ru.js": 290,
	"./sd": 291,
	"./sd.js": 291,
	"./se": 292,
	"./se.js": 292,
	"./si": 293,
	"./si.js": 293,
	"./sk": 294,
	"./sk.js": 294,
	"./sl": 295,
	"./sl.js": 295,
	"./sq": 296,
	"./sq.js": 296,
	"./sr": 297,
	"./sr-cyrl": 298,
	"./sr-cyrl.js": 298,
	"./sr.js": 297,
	"./ss": 299,
	"./ss.js": 299,
	"./sv": 300,
	"./sv.js": 300,
	"./sw": 301,
	"./sw.js": 301,
	"./ta": 302,
	"./ta.js": 302,
	"./te": 303,
	"./te.js": 303,
	"./tet": 304,
	"./tet.js": 304,
	"./tg": 305,
	"./tg.js": 305,
	"./th": 306,
	"./th.js": 306,
	"./tl-ph": 307,
	"./tl-ph.js": 307,
	"./tlh": 308,
	"./tlh.js": 308,
	"./tr": 309,
	"./tr.js": 309,
	"./tzl": 310,
	"./tzl.js": 310,
	"./tzm": 311,
	"./tzm-latn": 312,
	"./tzm-latn.js": 312,
	"./tzm.js": 311,
	"./ug-cn": 313,
	"./ug-cn.js": 313,
	"./uk": 314,
	"./uk.js": 314,
	"./ur": 315,
	"./ur.js": 315,
	"./uz": 316,
	"./uz-latn": 317,
	"./uz-latn.js": 317,
	"./uz.js": 316,
	"./vi": 318,
	"./vi.js": 318,
	"./x-pseudo": 319,
	"./x-pseudo.js": 319,
	"./yo": 320,
	"./yo.js": 320,
	"./zh-cn": 321,
	"./zh-cn.js": 321,
	"./zh-hk": 322,
	"./zh-hk.js": 322,
	"./zh-tw": 323,
	"./zh-tw.js": 323
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 631;

/***/ }),
/* 632 */,
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(634);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(48)("7b128651", content, true, {});

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(47)(true);
// imports


// module
exports.push([module.i, "/*!\n * Datetimepicker for Bootstrap 3\n * version : 4.17.47\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */.bootstrap-datetimepicker-widget{list-style:none}.bootstrap-datetimepicker-widget.dropdown-menu{display:block;margin:2px 0;padding:4px;width:19em}@media (min-width:768px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:992px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}@media (min-width:1200px){.bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs{width:38em}}.bootstrap-datetimepicker-widget.dropdown-menu:after,.bootstrap-datetimepicker-widget.dropdown-menu:before{content:\"\";display:inline-block;position:absolute}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);top:-7px;left:7px}.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after{border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;top:-6px;left:8px}.bootstrap-datetimepicker-widget.dropdown-menu.top:before{border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #ccc;border-top-color:rgba(0,0,0,.2);bottom:-7px;left:6px}.bootstrap-datetimepicker-widget.dropdown-menu.top:after{border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid #fff;bottom:-6px;left:7px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before{left:auto;right:6px}.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after{left:auto;right:7px}.bootstrap-datetimepicker-widget .list-unstyled{margin:0}.bootstrap-datetimepicker-widget a[data-action]{padding:6px 0}.bootstrap-datetimepicker-widget a[data-action]:active{box-shadow:none}.bootstrap-datetimepicker-widget .timepicker-hour,.bootstrap-datetimepicker-widget .timepicker-minute,.bootstrap-datetimepicker-widget .timepicker-second{width:54px;font-weight:700;font-size:1.2em;margin:0}.bootstrap-datetimepicker-widget button[data-action]{padding:6px}.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Increment Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Increment Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Decrement Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Decrement Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=showHours]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Show Hours\"}.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Show Minutes\"}.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Toggle AM/PM\"}.bootstrap-datetimepicker-widget .btn[data-action=clear]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Clear the picker\"}.bootstrap-datetimepicker-widget .btn[data-action=today]:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Set the date to today\"}.bootstrap-datetimepicker-widget .picker-switch{text-align:center}.bootstrap-datetimepicker-widget .picker-switch:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Toggle Date and Time Screens\"}.bootstrap-datetimepicker-widget .picker-switch td{padding:0;margin:0;height:auto;width:auto;line-height:inherit}.bootstrap-datetimepicker-widget .picker-switch td span{line-height:2.5;height:2.5em;width:100%}.bootstrap-datetimepicker-widget table{width:100%;margin:0}.bootstrap-datetimepicker-widget table td,.bootstrap-datetimepicker-widget table th{text-align:center;border-radius:4px}.bootstrap-datetimepicker-widget table th{height:20px;line-height:20px;width:20px}.bootstrap-datetimepicker-widget table th.picker-switch{width:145px}.bootstrap-datetimepicker-widget table th.disabled,.bootstrap-datetimepicker-widget table th.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget table th.prev:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Previous Month\"}.bootstrap-datetimepicker-widget table th.next:after{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;content:\"Next Month\"}.bootstrap-datetimepicker-widget table thead tr:first-child th{cursor:pointer}.bootstrap-datetimepicker-widget table thead tr:first-child th:hover{background:#eee}.bootstrap-datetimepicker-widget table td{height:54px;line-height:54px;width:54px}.bootstrap-datetimepicker-widget table td.cw{font-size:.8em;height:20px;line-height:20px;color:#777}.bootstrap-datetimepicker-widget table td.day{height:20px;line-height:20px;width:20px}.bootstrap-datetimepicker-widget table td.day:hover,.bootstrap-datetimepicker-widget table td.hour:hover,.bootstrap-datetimepicker-widget table td.minute:hover,.bootstrap-datetimepicker-widget table td.second:hover{background:#eee;cursor:pointer}.bootstrap-datetimepicker-widget table td.new,.bootstrap-datetimepicker-widget table td.old{color:#777}.bootstrap-datetimepicker-widget table td.today{position:relative}.bootstrap-datetimepicker-widget table td.today:before{content:\"\";display:inline-block;border:solid transparent;border-width:0 0 7px 7px;border-bottom-color:#337ab7;border-top-color:rgba(0,0,0,.2);position:absolute;bottom:4px;right:4px}.bootstrap-datetimepicker-widget table td.active,.bootstrap-datetimepicker-widget table td.active:hover{background-color:#337ab7;color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.bootstrap-datetimepicker-widget table td.active.today:before{border-bottom-color:#fff}.bootstrap-datetimepicker-widget table td.disabled,.bootstrap-datetimepicker-widget table td.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget table td span{display:inline-block;width:54px;height:54px;line-height:54px;margin:2px 1.5px;cursor:pointer;border-radius:4px}.bootstrap-datetimepicker-widget table td span:hover{background:#eee}.bootstrap-datetimepicker-widget table td span.active{background-color:#337ab7;color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.bootstrap-datetimepicker-widget table td span.old{color:#777}.bootstrap-datetimepicker-widget table td span.disabled,.bootstrap-datetimepicker-widget table td span.disabled:hover{background:none;color:#777;cursor:not-allowed}.bootstrap-datetimepicker-widget.usetwentyfour td.hour{height:27px;line-height:27px}.bootstrap-datetimepicker-widget.wider{width:21em}.bootstrap-datetimepicker-widget .datepicker-decades .decade{line-height:1.8em!important}.input-group.date .input-group-addon{cursor:pointer}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}", "", {"version":3,"sources":["/usr/share/nginx/html/bladmjudicial.com.br/manager/node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css"],"names":[],"mappings":"AAAA;;;;GAIG,AACH,iCACE,eAAiB,CAClB,AACD,+CACE,cAAe,AACf,aAAc,AACd,YAAa,AACb,UAAY,CACb,AACD,yBACE,8DACE,UAAY,CACb,CACF,AACD,yBACE,8DACE,UAAY,CACb,CACF,AACD,0BACE,8DACE,UAAY,CACb,CACF,AACD,2GAEE,WAAY,AACZ,qBAAsB,AACtB,iBAAmB,CACpB,AACD,6DACE,kCAAmC,AACnC,mCAAoC,AACpC,6BAA8B,AAC9B,mCAAwC,AACxC,SAAU,AACV,QAAU,CACX,AACD,4DACE,kCAAmC,AACnC,mCAAoC,AACpC,6BAA+B,AAC/B,SAAU,AACV,QAAU,CACX,AACD,0DACE,kCAAmC,AACnC,mCAAoC,AACpC,0BAA2B,AAC3B,gCAAqC,AACrC,YAAa,AACb,QAAU,CACX,AACD,yDACE,kCAAmC,AACnC,mCAAoC,AACpC,0BAA4B,AAC5B,YAAa,AACb,QAAU,CACX,AACD,iEACE,UAAW,AACX,SAAW,CACZ,AACD,gEACE,UAAW,AACX,SAAW,CACZ,AACD,gDACE,QAAU,CACX,AACD,gDACE,aAAe,CAChB,AACD,uDACE,eAAiB,CAClB,AACD,0JAGE,WAAY,AACZ,gBAAkB,AAClB,gBAAiB,AACjB,QAAU,CACX,AACD,qDACE,WAAa,CACd,AACD,wEACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,yBAA2B,CAC5B,AACD,0EACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,2BAA6B,CAC9B,AACD,wEACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,yBAA2B,CAC5B,AACD,0EACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,2BAA6B,CAC9B,AACD,mEACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,oBAAsB,CACvB,AACD,qEACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,sBAAwB,CACzB,AACD,sEACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,sBAAwB,CACzB,AACD,+DACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,0BAA4B,CAC7B,AACD,+DACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,+BAAiC,CAClC,AACD,gDACE,iBAAmB,CACpB,AACD,sDACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,sCAAwC,CACzC,AACD,mDACE,UAAW,AACX,SAAU,AACV,YAAa,AACb,WAAY,AACZ,mBAAqB,CACtB,AACD,wDACE,gBAAiB,AACjB,aAAc,AACd,UAAY,CACb,AACD,uCACE,WAAY,AACZ,QAAU,CACX,AACD,oFAEE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,0CACE,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AACD,wDACE,WAAa,CACd,AACD,4GAEE,gBAAiB,AACjB,WAAe,AACf,kBAAoB,CACrB,AACD,qDACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,wBAA0B,CAC3B,AACD,qDACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,SAAU,AACV,oBAAsB,CACvB,AACD,+DACE,cAAgB,CACjB,AACD,qEACE,eAAoB,CACrB,AACD,0CACE,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AACD,6CACE,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,UAAe,CAChB,AACD,8CACE,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AACD,uNAIE,gBAAoB,AACpB,cAAgB,CACjB,AACD,4FAEE,UAAe,CAChB,AACD,gDACE,iBAAmB,CACpB,AACD,uDACE,WAAY,AACZ,qBAAsB,AACtB,yBAA0B,AAC1B,yBAA0B,AAC1B,4BAA6B,AAC7B,gCAAqC,AACrC,kBAAmB,AACnB,WAAY,AACZ,SAAW,CACZ,AACD,wGAEE,yBAA0B,AAC1B,WAAY,AACZ,oCAA0C,CAC3C,AACD,8DACE,wBAA0B,CAC3B,AACD,4GAEE,gBAAiB,AACjB,WAAe,AACf,kBAAoB,CACrB,AACD,+CACE,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,iBAAkB,AAClB,eAAgB,AAChB,iBAAmB,CACpB,AACD,qDACE,eAAoB,CACrB,AACD,sDACE,yBAA0B,AAC1B,WAAY,AACZ,oCAA0C,CAC3C,AACD,mDACE,UAAe,CAChB,AACD,sHAEE,gBAAiB,AACjB,WAAe,AACf,kBAAoB,CACrB,AACD,uDACE,YAAa,AACb,gBAAkB,CACnB,AACD,uCACE,UAAY,CACb,AACD,6DACE,2BAA8B,CAC/B,AACD,qCACE,cAAgB,CACjB,AACD,SACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,gBAAiB,AACjB,mBAAuB,AACvB,QAAU,CACX","file":"bootstrap-datetimepicker.css","sourcesContent":["/*!\n * Datetimepicker for Bootstrap 3\n * version : 4.17.47\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n.bootstrap-datetimepicker-widget {\n  list-style: none;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu {\n  display: block;\n  margin: 2px 0;\n  padding: 4px;\n  width: 19em;\n}\n@media (min-width: 768px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 992px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 1200px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n.bootstrap-datetimepicker-widget.dropdown-menu:before,\n.bootstrap-datetimepicker-widget.dropdown-menu:after {\n  content: '';\n  display: inline-block;\n  position: absolute;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  top: -7px;\n  left: 7px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  top: -6px;\n  left: 8px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top:before {\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #ccc;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  bottom: -7px;\n  left: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top:after {\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid white;\n  bottom: -6px;\n  left: 7px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n  left: auto;\n  right: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n  left: auto;\n  right: 7px;\n}\n.bootstrap-datetimepicker-widget .list-unstyled {\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget a[data-action] {\n  padding: 6px 0;\n}\n.bootstrap-datetimepicker-widget a[data-action]:active {\n  box-shadow: none;\n}\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n  width: 54px;\n  font-weight: bold;\n  font-size: 1.2em;\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget button[data-action] {\n  padding: 6px;\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Increment Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Increment Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Decrement Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Decrement Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Show Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Show Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Toggle AM/PM\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Clear the picker\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Set the date to today\";\n}\n.bootstrap-datetimepicker-widget .picker-switch {\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget .picker-switch::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Toggle Date and Time Screens\";\n}\n.bootstrap-datetimepicker-widget .picker-switch td {\n  padding: 0;\n  margin: 0;\n  height: auto;\n  width: auto;\n  line-height: inherit;\n}\n.bootstrap-datetimepicker-widget .picker-switch td span {\n  line-height: 2.5;\n  height: 2.5em;\n  width: 100%;\n}\n.bootstrap-datetimepicker-widget table {\n  width: 100%;\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget table td,\n.bootstrap-datetimepicker-widget table th {\n  text-align: center;\n  border-radius: 4px;\n}\n.bootstrap-datetimepicker-widget table th {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n}\n.bootstrap-datetimepicker-widget table th.picker-switch {\n  width: 145px;\n}\n.bootstrap-datetimepicker-widget table th.disabled,\n.bootstrap-datetimepicker-widget table th.disabled:hover {\n  background: none;\n  color: #777777;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table th.prev::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Previous Month\";\n}\n.bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n  content: \"Next Month\";\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n.bootstrap-datetimepicker-widget table td {\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n}\n.bootstrap-datetimepicker-widget table td.cw {\n  font-size: .8em;\n  height: 20px;\n  line-height: 20px;\n  color: #777777;\n}\n.bootstrap-datetimepicker-widget table td.day {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n}\n.bootstrap-datetimepicker-widget table td.day:hover,\n.bootstrap-datetimepicker-widget table td.hour:hover,\n.bootstrap-datetimepicker-widget table td.minute:hover,\n.bootstrap-datetimepicker-widget table td.second:hover {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table td.old,\n.bootstrap-datetimepicker-widget table td.new {\n  color: #777777;\n}\n.bootstrap-datetimepicker-widget table td.today {\n  position: relative;\n}\n.bootstrap-datetimepicker-widget table td.today:before {\n  content: '';\n  display: inline-block;\n  border: solid transparent;\n  border-width: 0 0 7px 7px;\n  border-bottom-color: #337ab7;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n.bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n  background-color: #337ab7;\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.bootstrap-datetimepicker-widget table td.active.today:before {\n  border-bottom-color: #fff;\n}\n.bootstrap-datetimepicker-widget table td.disabled,\n.bootstrap-datetimepicker-widget table td.disabled:hover {\n  background: none;\n  color: #777777;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table td span {\n  display: inline-block;\n  width: 54px;\n  height: 54px;\n  line-height: 54px;\n  margin: 2px 1.5px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n.bootstrap-datetimepicker-widget table td span:hover {\n  background: #eeeeee;\n}\n.bootstrap-datetimepicker-widget table td span.active {\n  background-color: #337ab7;\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.bootstrap-datetimepicker-widget table td span.old {\n  color: #777777;\n}\n.bootstrap-datetimepicker-widget table td span.disabled,\n.bootstrap-datetimepicker-widget table td span.disabled:hover {\n  background: none;\n  color: #777777;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n  height: 27px;\n  line-height: 27px;\n}\n.bootstrap-datetimepicker-widget.wider {\n  width: 21em;\n}\n.bootstrap-datetimepicker-widget .datepicker-decades .decade {\n  line-height: 1.8em !important;\n}\n.input-group.date .input-group-addon {\n  cursor: pointer;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(48)("4380881e", content, true, {});

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(456);
exports = module.exports = __webpack_require__(47)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:summernote;font-style:normal;font-weight:400;src:url(" + escape(__webpack_require__(637)) + ");src:url(" + escape(__webpack_require__(638)) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(639)) + ") format(\"woff\"),url(" + escape(__webpack_require__(640)) + ") format(\"truetype\")}[class*=\" note-icon-\"]:before,[class^=note-icon-]:before{display:inline-block;font:normal normal normal 14px summernote;font-size:inherit;-webkit-font-smoothing:antialiased;text-decoration:inherit;text-rendering:auto;text-transform:none;vertical-align:middle;speak:none;-moz-osx-font-smoothing:grayscale}.note-icon-align-center:before,.note-icon-align-indent:before,.note-icon-align-justify:before,.note-icon-align-left:before,.note-icon-align-outdent:before,.note-icon-align-right:before,.note-icon-align:before,.note-icon-arrow-circle-down:before,.note-icon-arrow-circle-left:before,.note-icon-arrow-circle-right:before,.note-icon-arrow-circle-up:before,.note-icon-arrows-alt:before,.note-icon-arrows-h:before,.note-icon-arrows-v:before,.note-icon-bold:before,.note-icon-caret:before,.note-icon-chain-broken:before,.note-icon-circle:before,.note-icon-close:before,.note-icon-code:before,.note-icon-col-after:before,.note-icon-col-before:before,.note-icon-col-remove:before,.note-icon-eraser:before,.note-icon-font:before,.note-icon-frame:before,.note-icon-italic:before,.note-icon-link:before,.note-icon-magic:before,.note-icon-menu-check:before,.note-icon-minus:before,.note-icon-orderedlist:before,.note-icon-pencil:before,.note-icon-picture:before,.note-icon-question:before,.note-icon-redo:before,.note-icon-row-above:before,.note-icon-row-below:before,.note-icon-row-remove:before,.note-icon-special-character:before,.note-icon-square:before,.note-icon-strikethrough:before,.note-icon-subscript:before,.note-icon-summernote:before,.note-icon-superscript:before,.note-icon-table:before,.note-icon-text-height:before,.note-icon-trash:before,.note-icon-underline:before,.note-icon-undo:before,.note-icon-unorderedlist:before,.note-icon-video:before{display:inline-block;font-family:summernote;font-style:normal;font-weight:400;text-decoration:inherit}.note-icon-align-center:before{content:\"\\F101\"}.note-icon-align-indent:before{content:\"\\F102\"}.note-icon-align-justify:before{content:\"\\F103\"}.note-icon-align-left:before{content:\"\\F104\"}.note-icon-align-outdent:before{content:\"\\F105\"}.note-icon-align-right:before{content:\"\\F106\"}.note-icon-align:before{content:\"\\F107\"}.note-icon-arrow-circle-down:before{content:\"\\F108\"}.note-icon-arrow-circle-left:before{content:\"\\F109\"}.note-icon-arrow-circle-right:before{content:\"\\F10A\"}.note-icon-arrow-circle-up:before{content:\"\\F10B\"}.note-icon-arrows-alt:before{content:\"\\F10C\"}.note-icon-arrows-h:before{content:\"\\F10D\"}.note-icon-arrows-v:before{content:\"\\F10E\"}.note-icon-bold:before{content:\"\\F10F\"}.note-icon-caret:before{content:\"\\F110\"}.note-icon-chain-broken:before{content:\"\\F111\"}.note-icon-circle:before{content:\"\\F112\"}.note-icon-close:before{content:\"\\F113\"}.note-icon-code:before{content:\"\\F114\"}.note-icon-col-after:before{content:\"\\F115\"}.note-icon-col-before:before{content:\"\\F116\"}.note-icon-col-remove:before{content:\"\\F117\"}.note-icon-eraser:before{content:\"\\F118\"}.note-icon-font:before{content:\"\\F119\"}.note-icon-frame:before{content:\"\\F11A\"}.note-icon-italic:before{content:\"\\F11B\"}.note-icon-link:before{content:\"\\F11C\"}.note-icon-magic:before{content:\"\\F11D\"}.note-icon-menu-check:before{content:\"\\F11E\"}.note-icon-minus:before{content:\"\\F11F\"}.note-icon-orderedlist:before{content:\"\\F120\"}.note-icon-pencil:before{content:\"\\F121\"}.note-icon-picture:before{content:\"\\F122\"}.note-icon-question:before{content:\"\\F123\"}.note-icon-redo:before{content:\"\\F124\"}.note-icon-row-above:before{content:\"\\F125\"}.note-icon-row-below:before{content:\"\\F126\"}.note-icon-row-remove:before{content:\"\\F127\"}.note-icon-special-character:before{content:\"\\F128\"}.note-icon-square:before{content:\"\\F129\"}.note-icon-strikethrough:before{content:\"\\F12A\"}.note-icon-subscript:before{content:\"\\F12B\"}.note-icon-summernote:before{content:\"\\F12C\"}.note-icon-superscript:before{content:\"\\F12D\"}.note-icon-table:before{content:\"\\F12E\"}.note-icon-text-height:before{content:\"\\F12F\"}.note-icon-trash:before{content:\"\\F130\"}.note-icon-underline:before{content:\"\\F131\"}.note-icon-undo:before{content:\"\\F132\"}.note-icon-unorderedlist:before{content:\"\\F133\"}.note-icon-video:before{content:\"\\F134\"}.note-editor{position:relative}.note-editor .note-dropzone{position:absolute;z-index:100;display:none;color:#87cefa;background-color:#fff;opacity:.95}.note-editor .note-dropzone .note-dropzone-message{display:table-cell;font-size:28px;font-weight:700;text-align:center;vertical-align:middle}.note-editor .note-dropzone.hover{color:#098ddf}.note-editor.dragover .note-dropzone{display:table}.note-editor .note-editing-area{position:relative}.note-editor .note-editing-area .note-editable{outline:0}.note-editor .note-editing-area .note-editable sup{vertical-align:super}.note-editor .note-editing-area .note-editable sub{vertical-align:sub}.note-editor .note-editing-area img.note-float-left{margin-right:10px}.note-editor .note-editing-area img.note-float-right{margin-left:10px}.note-editor.note-frame{border:1px solid #a9a9a9}.note-editor.note-frame.codeview .note-editing-area .note-editable{display:none}.note-editor.note-frame.codeview .note-editing-area .note-codable{display:block}.note-editor.note-frame .note-editing-area{overflow:hidden}.note-editor.note-frame .note-editing-area .note-editable{padding:10px;overflow:auto;color:#000;word-wrap:break-word;background-color:#fff}.note-editor.note-frame .note-editing-area .note-editable[contenteditable=false]{background-color:#e5e5e5}.note-editor.note-frame .note-editing-area .note-codable{display:none;width:100%;padding:10px;margin-bottom:0;font-family:Menlo,Monaco,monospace,sans-serif;font-size:14px;color:#ccc;background-color:#222;border:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;box-shadow:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;-ms-box-sizing:border-box;box-sizing:border-box;resize:none}.note-editor.note-frame.fullscreen{position:fixed;top:0;left:0;z-index:1050;width:100%!important}.note-editor.note-frame.fullscreen .note-editable{background-color:#fff}.note-editor.note-frame.fullscreen .note-resizebar{display:none}.note-editor.note-frame .note-status-output{display:block;width:100%;height:20px;margin-bottom:0;font-size:14px;line-height:1.42857143;color:#000;border:0;border-top:1px solid #e2e2e2}.note-editor.note-frame .note-status-output:empty{height:0;border-top:0 solid transparent}.note-editor.note-frame .note-status-output .pull-right{float:right!important}.note-editor.note-frame .note-status-output .text-muted{color:#777}.note-editor.note-frame .note-status-output .text-primary{color:#286090}.note-editor.note-frame .note-status-output .text-success{color:#3c763d}.note-editor.note-frame .note-status-output .text-info{color:#31708f}.note-editor.note-frame .note-status-output .text-warning{color:#8a6d3b}.note-editor.note-frame .note-status-output .text-danger{color:#a94442}.note-editor.note-frame .note-status-output .alert{padding:7px 10px 2px;margin:-7px 0 0;color:#000;background-color:#f5f5f5;border-radius:0}.note-editor.note-frame .note-status-output .alert .note-icon{margin-right:5px}.note-editor.note-frame .note-status-output .alert-success{color:#3c763d!important;background-color:#dff0d8!important}.note-editor.note-frame .note-status-output .alert-info{color:#31708f!important;background-color:#d9edf7!important}.note-editor.note-frame .note-status-output .alert-warning{color:#8a6d3b!important;background-color:#fcf8e3!important}.note-editor.note-frame .note-status-output .alert-danger{color:#a94442!important;background-color:#f2dede!important}.note-editor.note-frame .note-statusbar{background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.note-editor.note-frame .note-statusbar .note-resizebar{width:100%;height:9px;padding-top:1px;cursor:ns-resize}.note-editor.note-frame .note-statusbar .note-resizebar .note-icon-bar{width:20px;margin:1px auto;border-top:1px solid #a9a9a9}.note-editor.note-frame .note-statusbar.locked .note-resizebar{cursor:default}.note-editor.note-frame .note-statusbar.locked .note-resizebar .note-icon-bar{display:none}.note-editor.note-frame .note-placeholder{padding:10px}.note-popover.popover{display:none;max-width:none}.note-popover.popover .popover-content a{display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle}.note-popover.popover .arrow{left:20px!important}.note-toolbar{position:relative;z-index:500}.card-header.note-toolbar,.note-popover .popover-content{padding:0 0 5px 5px;margin:0}.card-header.note-toolbar>.btn-group,.note-popover .popover-content>.btn-group{margin-top:5px;margin-right:5px;margin-left:0}.card-header.note-toolbar .btn-group .note-table,.note-popover .popover-content .btn-group .note-table{min-width:0;padding:5px}.card-header.note-toolbar .btn-group .note-table .note-dimension-picker,.note-popover .popover-content .btn-group .note-table .note-dimension-picker{font-size:18px}.card-header.note-toolbar .btn-group .note-table .note-dimension-picker .note-dimension-picker-mousecatcher,.note-popover .popover-content .btn-group .note-table .note-dimension-picker .note-dimension-picker-mousecatcher{position:absolute!important;z-index:3;width:10em;height:10em;cursor:pointer}.card-header.note-toolbar .btn-group .note-table .note-dimension-picker .note-dimension-picker-unhighlighted,.note-popover .popover-content .btn-group .note-table .note-dimension-picker .note-dimension-picker-unhighlighted{position:relative!important;z-index:1;width:5em;height:5em;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASAgMAAAAroGbEAAAACVBMVEUAAIj4+Pjp6ekKlAqjAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfYAR0BKhmnaJzPAAAAG0lEQVQI12NgAAOtVatWMTCohoaGUY+EmIkEAEruEzK2J7tvAAAAAElFTkSuQmCC\") repeat}.card-header.note-toolbar .btn-group .note-table .note-dimension-picker .note-dimension-picker-highlighted,.note-popover .popover-content .btn-group .note-table .note-dimension-picker .note-dimension-picker-highlighted{position:absolute!important;z-index:2;width:1em;height:1em;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASAgMAAAAroGbEAAAACVBMVEUAAIjd6vvD2f9LKLW+AAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfYAR0BKwNDEVT0AAAAG0lEQVQI12NgAAOtVatWMTCohoaGUY+EmIkEAEruEzK2J7tvAAAAAElFTkSuQmCC\") repeat}.card-header.note-toolbar .note-style .dropdown-style blockquote,.card-header.note-toolbar .note-style .dropdown-style pre,.note-popover .popover-content .note-style .dropdown-style blockquote,.note-popover .popover-content .note-style .dropdown-style pre{padding:5px 10px;margin:0}.card-header.note-toolbar .note-style .dropdown-style h1,.card-header.note-toolbar .note-style .dropdown-style h2,.card-header.note-toolbar .note-style .dropdown-style h3,.card-header.note-toolbar .note-style .dropdown-style h4,.card-header.note-toolbar .note-style .dropdown-style h5,.card-header.note-toolbar .note-style .dropdown-style h6,.card-header.note-toolbar .note-style .dropdown-style p,.note-popover .popover-content .note-style .dropdown-style h1,.note-popover .popover-content .note-style .dropdown-style h2,.note-popover .popover-content .note-style .dropdown-style h3,.note-popover .popover-content .note-style .dropdown-style h4,.note-popover .popover-content .note-style .dropdown-style h5,.note-popover .popover-content .note-style .dropdown-style h6,.note-popover .popover-content .note-style .dropdown-style p{padding:0;margin:0}.card-header.note-toolbar .note-color .dropdown-toggle,.note-popover .popover-content .note-color .dropdown-toggle{width:20px;padding-left:5px}.card-header.note-toolbar .note-color .dropdown-menu,.note-popover .popover-content .note-color .dropdown-menu{min-width:337px}.card-header.note-toolbar .note-color .dropdown-menu .note-palette,.note-popover .popover-content .note-color .dropdown-menu .note-palette{display:inline-block;width:160px;margin:0}.card-header.note-toolbar .note-color .dropdown-menu .note-palette:first-child,.note-popover .popover-content .note-color .dropdown-menu .note-palette:first-child{margin:0 5px}.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-palette-title,.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-palette-title{margin:2px 7px;font-size:12px;text-align:center;border-bottom:1px solid #eee}.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-color-reset,.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-color-reset{width:100%;padding:0 3px;margin:3px;font-size:11px;cursor:pointer;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-color-row,.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-color-row{height:20px}.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-color-reset:hover,.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-color-reset:hover{background:#eee}.card-header.note-toolbar .note-para .dropdown-menu,.note-popover .popover-content .note-para .dropdown-menu{min-width:216px;padding:5px}.card-header.note-toolbar .note-para .dropdown-menu>div:first-child,.note-popover .popover-content .note-para .dropdown-menu>div:first-child{margin-right:5px}.card-header.note-toolbar .dropdown-menu,.note-popover .popover-content .dropdown-menu{min-width:90px}.card-header.note-toolbar .dropdown-menu.right,.note-popover .popover-content .dropdown-menu.right{right:0;left:auto}.card-header.note-toolbar .dropdown-menu.right:before,.note-popover .popover-content .dropdown-menu.right:before{right:9px;left:auto!important}.card-header.note-toolbar .dropdown-menu.right:after,.note-popover .popover-content .dropdown-menu.right:after{right:10px;left:auto!important}.card-header.note-toolbar .dropdown-menu.note-check a i,.note-popover .popover-content .dropdown-menu.note-check a i{color:#00bfff;visibility:hidden}.card-header.note-toolbar .dropdown-menu.note-check a.checked i,.note-popover .popover-content .dropdown-menu.note-check a.checked i{visibility:visible}.card-header.note-toolbar .note-fontsize-10,.note-popover .popover-content .note-fontsize-10{font-size:10px}.card-header.note-toolbar .note-color-palette,.note-popover .popover-content .note-color-palette{line-height:1}.card-header.note-toolbar .note-color-palette div .note-color-btn,.note-popover .popover-content .note-color-palette div .note-color-btn{width:20px;height:20px;padding:0;margin:0;border:1px solid #fff}.card-header.note-toolbar .note-color-palette div .note-color-btn:hover,.note-popover .popover-content .note-color-palette div .note-color-btn:hover{border:1px solid #000}.note-dialog>div{display:none}.note-dialog .form-group{margin-right:0;margin-left:0}.note-dialog .note-modal-form{margin:0}.note-dialog .note-image-dialog .note-dropzone{min-height:100px;margin-bottom:10px;font-size:30px;line-height:4;color:#d3d3d3;text-align:center;border:4px dashed #d3d3d3}@-moz-document url-prefix(){.note-image-input{height:auto}}.note-placeholder{position:absolute;display:none;color:gray}.note-handle .note-control-selection{position:absolute;display:none;border:1px solid #000}.note-handle .note-control-selection>div{position:absolute}.note-handle .note-control-selection .note-control-selection-bg{width:100%;height:100%;background-color:#000;-webkit-opacity:.3;-khtml-opacity:.3;-moz-opacity:.3;opacity:.3;-ms-filter:alpha(opacity=30);filter:alpha(opacity=30)}.note-handle .note-control-selection .note-control-handle,.note-handle .note-control-selection .note-control-holder{width:7px;height:7px;border:1px solid #000}.note-handle .note-control-selection .note-control-sizing{width:7px;height:7px;background-color:#fff;border:1px solid #000}.note-handle .note-control-selection .note-control-nw{top:-5px;left:-5px;border-right:0;border-bottom:0}.note-handle .note-control-selection .note-control-ne{top:-5px;right:-5px;border-bottom:0;border-left:none}.note-handle .note-control-selection .note-control-sw{bottom:-5px;left:-5px;border-top:0;border-right:0}.note-handle .note-control-selection .note-control-se{right:-5px;bottom:-5px;cursor:se-resize}.note-handle .note-control-selection .note-control-se.note-control-holder{cursor:default;border-top:0;border-left:none}.note-handle .note-control-selection .note-control-selection-info{right:0;bottom:0;padding:5px;margin:5px;font-size:12px;color:#fff;background-color:#000;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;-webkit-opacity:.7;-khtml-opacity:.7;-moz-opacity:.7;opacity:.7;-ms-filter:alpha(opacity=70);filter:alpha(opacity=70)}.note-hint-popover{min-width:100px;padding:2px}.note-hint-popover .popover-content{max-height:150px;padding:3px;overflow:auto}.note-hint-popover .popover-content .note-hint-group .note-hint-item{display:block!important;padding:3px}.note-hint-popover .popover-content .note-hint-group .note-hint-item.active,.note-hint-popover .popover-content .note-hint-group .note-hint-item:hover{display:block;clear:both;font-weight:400;line-height:1.4;color:#fff;text-decoration:none;white-space:nowrap;cursor:pointer;background-color:#428bca;outline:0}", "", {"version":3,"sources":["/usr/share/nginx/html/bladmjudicial.com.br/manager/node_modules/summernote/dist/summernote-bs4.css"],"names":[],"mappings":"AAAA,WAAW,uBAAyB,kBAAkB,gBAAmB,kCAAkE,2JAAkO,CAAC,yDAA2D,qBAAqB,0CAA0C,kBAAkB,mCAAmC,wBAAwB,oBAAoB,oBAAoB,sBAAsB,WAAW,iCAAiC,CAAC,y6CAAy6C,qBAAqB,uBAAyB,kBAAkB,gBAAmB,uBAAuB,CAAC,+BAA+B,eAAe,CAAC,+BAA+B,eAAe,CAAC,gCAAgC,eAAe,CAAC,6BAA6B,eAAe,CAAC,gCAAgC,eAAe,CAAC,8BAA8B,eAAe,CAAC,wBAAwB,eAAe,CAAC,oCAAoC,eAAe,CAAC,oCAAoC,eAAe,CAAC,qCAAqC,eAAe,CAAC,kCAAkC,eAAe,CAAC,6BAA6B,eAAe,CAAC,2BAA2B,eAAe,CAAC,2BAA2B,eAAe,CAAC,uBAAuB,eAAe,CAAC,wBAAwB,eAAe,CAAC,+BAA+B,eAAe,CAAC,yBAAyB,eAAe,CAAC,wBAAwB,eAAe,CAAC,uBAAuB,eAAe,CAAC,4BAA4B,eAAe,CAAC,6BAA6B,eAAe,CAAC,6BAA6B,eAAe,CAAC,yBAAyB,eAAe,CAAC,uBAAuB,eAAe,CAAC,wBAAwB,eAAe,CAAC,yBAAyB,eAAe,CAAC,uBAAuB,eAAe,CAAC,wBAAwB,eAAe,CAAC,6BAA6B,eAAe,CAAC,wBAAwB,eAAe,CAAC,8BAA8B,eAAe,CAAC,yBAAyB,eAAe,CAAC,0BAA0B,eAAe,CAAC,2BAA2B,eAAe,CAAC,uBAAuB,eAAe,CAAC,4BAA4B,eAAe,CAAC,4BAA4B,eAAe,CAAC,6BAA6B,eAAe,CAAC,oCAAoC,eAAe,CAAC,yBAAyB,eAAe,CAAC,gCAAgC,eAAe,CAAC,4BAA4B,eAAe,CAAC,6BAA6B,eAAe,CAAC,8BAA8B,eAAe,CAAC,wBAAwB,eAAe,CAAC,8BAA8B,eAAe,CAAC,wBAAwB,eAAe,CAAC,4BAA4B,eAAe,CAAC,uBAAuB,eAAe,CAAC,gCAAgC,eAAe,CAAC,wBAAwB,eAAe,CAAC,aAAa,iBAAiB,CAAC,4BAA4B,kBAAkB,YAAY,aAAa,cAAc,sBAAsB,WAAW,CAAC,mDAAmD,mBAAmB,eAAe,gBAAgB,kBAAkB,qBAAqB,CAAC,kCAAkC,aAAa,CAAC,qCAAqC,aAAa,CAAC,gCAAgC,iBAAiB,CAAC,+CAA+C,SAAS,CAAC,mDAAmD,oBAAoB,CAAC,mDAAmD,kBAAkB,CAAC,oDAAoD,iBAAiB,CAAC,qDAAqD,gBAAgB,CAAC,wBAAwB,wBAAwB,CAAC,mEAAmE,YAAY,CAAC,kEAAkE,aAAa,CAAC,2CAA2C,eAAe,CAAC,0DAA0D,aAAa,cAAc,WAAW,qBAAqB,qBAAqB,CAAC,iFAAmF,wBAAwB,CAAC,yDAAyD,aAAa,WAAW,aAAa,gBAAgB,8CAA8C,eAAe,WAAW,sBAAsB,SAAS,wBAAwB,qBAAqB,gBAAgB,gBAAgB,8BAA8B,2BAA2B,0BAA0B,sBAAsB,WAAW,CAAC,mCAAmC,eAAe,MAAM,OAAO,aAAa,oBAAoB,CAAC,kDAAkD,qBAAqB,CAAC,mDAAmD,YAAY,CAAC,4CAA4C,cAAc,WAAW,YAAY,gBAAgB,eAAe,uBAAuB,WAAW,SAAS,4BAA4B,CAAC,kDAAkD,SAAS,8BAA8B,CAAC,wDAAwD,qBAAqB,CAAC,wDAAwD,UAAU,CAAC,0DAA0D,aAAa,CAAC,0DAA0D,aAAa,CAAC,uDAAuD,aAAa,CAAC,0DAA0D,aAAa,CAAC,yDAAyD,aAAa,CAAC,mDAAmD,qBAA0B,gBAAkB,WAAW,yBAAyB,eAAe,CAAC,8DAA8D,gBAAgB,CAAC,2DAA2D,wBAAwB,kCAAkC,CAAC,wDAAwD,wBAAwB,kCAAkC,CAAC,2DAA2D,wBAAwB,kCAAkC,CAAC,0DAA0D,wBAAwB,kCAAkC,CAAC,wCAAwC,yBAAyB,0BAA0B,+BAA+B,6BAA6B,CAAC,wDAAwD,WAAW,WAAW,gBAAgB,gBAAgB,CAAC,uEAAuE,WAAW,gBAAgB,4BAA4B,CAAC,+DAA+D,cAAc,CAAC,8EAA8E,YAAY,CAAC,0CAA0C,YAAY,CAAC,sBAAsB,aAAa,cAAc,CAAC,yCAAyC,qBAAqB,gBAAgB,gBAAgB,uBAAuB,mBAAmB,qBAAqB,CAAC,6BAA6B,mBAAmB,CAAC,cAAc,kBAAkB,WAAW,CAAC,yDAAyD,oBAAoB,QAAQ,CAAC,+EAA+E,eAAe,iBAAiB,aAAa,CAAC,uGAAuG,YAAY,WAAW,CAAC,qJAAqJ,cAAc,CAAC,6NAA6N,4BAA4B,UAAU,WAAW,YAAY,cAAc,CAAC,+NAA+N,4BAA4B,UAAU,UAAU,WAAW,mRAAmR,CAAC,2NAA2N,4BAA4B,UAAU,UAAU,WAAW,mRAAmR,CAAC,gQAAgQ,iBAAiB,QAAQ,CAAC,+zBAA+zB,UAAU,QAAQ,CAAC,mHAAmH,WAAW,gBAAgB,CAAC,+GAA+G,eAAe,CAAC,2IAA2I,qBAAqB,YAAY,QAAQ,CAAC,mKAAmK,YAAY,CAAC,mLAAmL,eAAe,eAAe,kBAAkB,4BAA4B,CAAC,+KAA+K,WAAW,cAAc,WAAW,eAAe,eAAe,0BAA0B,uBAAuB,iBAAiB,CAAC,2KAA2K,WAAW,CAAC,2LAA2L,eAAe,CAAC,6GAA6G,gBAAgB,WAAW,CAAC,6IAA6I,gBAAgB,CAAC,uFAAuF,cAAc,CAAC,mGAAmG,QAAQ,SAAS,CAAC,iHAAmH,UAAU,mBAAmB,CAAC,+GAAiH,WAAW,mBAAmB,CAAC,qHAAqH,cAAkB,iBAAiB,CAAC,qIAAqI,kBAAkB,CAAC,6FAA6F,cAAc,CAAC,iGAAiG,aAAa,CAAC,yIAAyI,WAAW,YAAY,UAAU,SAAS,qBAAqB,CAAC,qJAAqJ,qBAAqB,CAAC,iBAAiB,YAAY,CAAC,yBAAyB,eAAe,aAAa,CAAC,8BAA8B,QAAQ,CAAC,+CAA+C,iBAAiB,mBAAmB,eAAe,cAAc,cAAgB,kBAAkB,yBAA2B,CAAC,4BAA4B,kBAAkB,WAAW,CAAC,CAAC,kBAAkB,kBAAkB,aAAa,UAAU,CAAC,qCAAqC,kBAAkB,aAAa,qBAAsB,CAAC,yCAAyC,iBAAiB,CAAC,gEAAgE,WAAW,YAAY,sBAAuB,mBAAmB,kBAAkB,gBAAgB,WAAW,6BAA6B,wBAAwB,CAAC,AAAsG,oHAA0D,UAAU,WAAW,qBAAsB,CAAC,0DAA0D,UAAU,WAAW,sBAAuB,qBAAsB,CAAC,sDAAsD,SAAS,UAAU,eAAe,eAAe,CAAC,sDAAsD,SAAS,WAAW,gBAAgB,gBAAgB,CAAC,sDAAsD,YAAY,UAAU,aAAa,cAAc,CAAC,sDAAsD,WAAW,YAAY,gBAAgB,CAAC,0EAA0E,eAAe,aAAa,gBAAgB,CAAC,kEAAkE,QAAQ,SAAS,YAAY,WAAW,eAAe,WAAW,sBAAsB,0BAA0B,uBAAuB,kBAAkB,mBAAmB,kBAAkB,gBAAgB,WAAW,6BAA6B,wBAAwB,CAAC,mBAAmB,gBAAgB,WAAW,CAAC,oCAAoC,iBAAiB,YAAY,aAAa,CAAC,qEAAqE,wBAAwB,WAAW,CAAC,uJAAuJ,cAAc,WAAW,gBAAgB,gBAAgB,WAAW,qBAAqB,mBAAmB,eAAe,yBAAyB,SAAS,CAAC","file":"summernote-bs4.css","sourcesContent":["@font-face{font-family:\"summernote\";font-style:normal;font-weight:normal;src:url(\"./font/summernote.eot?dbafe969167589eda84514394d126413\");src:url(\"./font/summernote.eot?#iefix\") format(\"embedded-opentype\"),url(\"./font/summernote.woff?dbafe969167589eda84514394d126413\") format(\"woff\"),url(\"./font/summernote.ttf?dbafe969167589eda84514394d126413\") format(\"truetype\")}[class^=\"note-icon-\"]:before,[class*=\" note-icon-\"]:before{display:inline-block;font:normal normal normal 14px summernote;font-size:inherit;-webkit-font-smoothing:antialiased;text-decoration:inherit;text-rendering:auto;text-transform:none;vertical-align:middle;speak:none;-moz-osx-font-smoothing:grayscale}.note-icon-align-center:before,.note-icon-align-indent:before,.note-icon-align-justify:before,.note-icon-align-left:before,.note-icon-align-outdent:before,.note-icon-align-right:before,.note-icon-align:before,.note-icon-arrow-circle-down:before,.note-icon-arrow-circle-left:before,.note-icon-arrow-circle-right:before,.note-icon-arrow-circle-up:before,.note-icon-arrows-alt:before,.note-icon-arrows-h:before,.note-icon-arrows-v:before,.note-icon-bold:before,.note-icon-caret:before,.note-icon-chain-broken:before,.note-icon-circle:before,.note-icon-close:before,.note-icon-code:before,.note-icon-col-after:before,.note-icon-col-before:before,.note-icon-col-remove:before,.note-icon-eraser:before,.note-icon-font:before,.note-icon-frame:before,.note-icon-italic:before,.note-icon-link:before,.note-icon-magic:before,.note-icon-menu-check:before,.note-icon-minus:before,.note-icon-orderedlist:before,.note-icon-pencil:before,.note-icon-picture:before,.note-icon-question:before,.note-icon-redo:before,.note-icon-row-above:before,.note-icon-row-below:before,.note-icon-row-remove:before,.note-icon-special-character:before,.note-icon-square:before,.note-icon-strikethrough:before,.note-icon-subscript:before,.note-icon-summernote:before,.note-icon-superscript:before,.note-icon-table:before,.note-icon-text-height:before,.note-icon-trash:before,.note-icon-underline:before,.note-icon-undo:before,.note-icon-unorderedlist:before,.note-icon-video:before{display:inline-block;font-family:\"summernote\";font-style:normal;font-weight:normal;text-decoration:inherit}.note-icon-align-center:before{content:\"\\f101\"}.note-icon-align-indent:before{content:\"\\f102\"}.note-icon-align-justify:before{content:\"\\f103\"}.note-icon-align-left:before{content:\"\\f104\"}.note-icon-align-outdent:before{content:\"\\f105\"}.note-icon-align-right:before{content:\"\\f106\"}.note-icon-align:before{content:\"\\f107\"}.note-icon-arrow-circle-down:before{content:\"\\f108\"}.note-icon-arrow-circle-left:before{content:\"\\f109\"}.note-icon-arrow-circle-right:before{content:\"\\f10a\"}.note-icon-arrow-circle-up:before{content:\"\\f10b\"}.note-icon-arrows-alt:before{content:\"\\f10c\"}.note-icon-arrows-h:before{content:\"\\f10d\"}.note-icon-arrows-v:before{content:\"\\f10e\"}.note-icon-bold:before{content:\"\\f10f\"}.note-icon-caret:before{content:\"\\f110\"}.note-icon-chain-broken:before{content:\"\\f111\"}.note-icon-circle:before{content:\"\\f112\"}.note-icon-close:before{content:\"\\f113\"}.note-icon-code:before{content:\"\\f114\"}.note-icon-col-after:before{content:\"\\f115\"}.note-icon-col-before:before{content:\"\\f116\"}.note-icon-col-remove:before{content:\"\\f117\"}.note-icon-eraser:before{content:\"\\f118\"}.note-icon-font:before{content:\"\\f119\"}.note-icon-frame:before{content:\"\\f11a\"}.note-icon-italic:before{content:\"\\f11b\"}.note-icon-link:before{content:\"\\f11c\"}.note-icon-magic:before{content:\"\\f11d\"}.note-icon-menu-check:before{content:\"\\f11e\"}.note-icon-minus:before{content:\"\\f11f\"}.note-icon-orderedlist:before{content:\"\\f120\"}.note-icon-pencil:before{content:\"\\f121\"}.note-icon-picture:before{content:\"\\f122\"}.note-icon-question:before{content:\"\\f123\"}.note-icon-redo:before{content:\"\\f124\"}.note-icon-row-above:before{content:\"\\f125\"}.note-icon-row-below:before{content:\"\\f126\"}.note-icon-row-remove:before{content:\"\\f127\"}.note-icon-special-character:before{content:\"\\f128\"}.note-icon-square:before{content:\"\\f129\"}.note-icon-strikethrough:before{content:\"\\f12a\"}.note-icon-subscript:before{content:\"\\f12b\"}.note-icon-summernote:before{content:\"\\f12c\"}.note-icon-superscript:before{content:\"\\f12d\"}.note-icon-table:before{content:\"\\f12e\"}.note-icon-text-height:before{content:\"\\f12f\"}.note-icon-trash:before{content:\"\\f130\"}.note-icon-underline:before{content:\"\\f131\"}.note-icon-undo:before{content:\"\\f132\"}.note-icon-unorderedlist:before{content:\"\\f133\"}.note-icon-video:before{content:\"\\f134\"}.note-editor{position:relative}.note-editor .note-dropzone{position:absolute;z-index:100;display:none;color:#87cefa;background-color:#fff;opacity:.95}.note-editor .note-dropzone .note-dropzone-message{display:table-cell;font-size:28px;font-weight:700;text-align:center;vertical-align:middle}.note-editor .note-dropzone.hover{color:#098ddf}.note-editor.dragover .note-dropzone{display:table}.note-editor .note-editing-area{position:relative}.note-editor .note-editing-area .note-editable{outline:0}.note-editor .note-editing-area .note-editable sup{vertical-align:super}.note-editor .note-editing-area .note-editable sub{vertical-align:sub}.note-editor .note-editing-area img.note-float-left{margin-right:10px}.note-editor .note-editing-area img.note-float-right{margin-left:10px}.note-editor.note-frame{border:1px solid #a9a9a9}.note-editor.note-frame.codeview .note-editing-area .note-editable{display:none}.note-editor.note-frame.codeview .note-editing-area .note-codable{display:block}.note-editor.note-frame .note-editing-area{overflow:hidden}.note-editor.note-frame .note-editing-area .note-editable{padding:10px;overflow:auto;color:#000;word-wrap:break-word;background-color:#fff}.note-editor.note-frame .note-editing-area .note-editable[contenteditable=\"false\"]{background-color:#e5e5e5}.note-editor.note-frame .note-editing-area .note-codable{display:none;width:100%;padding:10px;margin-bottom:0;font-family:Menlo,Monaco,monospace,sans-serif;font-size:14px;color:#ccc;background-color:#222;border:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;box-shadow:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;-ms-box-sizing:border-box;box-sizing:border-box;resize:none}.note-editor.note-frame.fullscreen{position:fixed;top:0;left:0;z-index:1050;width:100%!important}.note-editor.note-frame.fullscreen .note-editable{background-color:#fff}.note-editor.note-frame.fullscreen .note-resizebar{display:none}.note-editor.note-frame .note-status-output{display:block;width:100%;height:20px;margin-bottom:0;font-size:14px;line-height:1.42857143;color:#000;border:0;border-top:1px solid #e2e2e2}.note-editor.note-frame .note-status-output:empty{height:0;border-top:0 solid transparent}.note-editor.note-frame .note-status-output .pull-right{float:right!important}.note-editor.note-frame .note-status-output .text-muted{color:#777}.note-editor.note-frame .note-status-output .text-primary{color:#286090}.note-editor.note-frame .note-status-output .text-success{color:#3c763d}.note-editor.note-frame .note-status-output .text-info{color:#31708f}.note-editor.note-frame .note-status-output .text-warning{color:#8a6d3b}.note-editor.note-frame .note-status-output .text-danger{color:#a94442}.note-editor.note-frame .note-status-output .alert{padding:7px 10px 2px 10px;margin:-7px 0 0 0;color:#000;background-color:#f5f5f5;border-radius:0}.note-editor.note-frame .note-status-output .alert .note-icon{margin-right:5px}.note-editor.note-frame .note-status-output .alert-success{color:#3c763d!important;background-color:#dff0d8!important}.note-editor.note-frame .note-status-output .alert-info{color:#31708f!important;background-color:#d9edf7!important}.note-editor.note-frame .note-status-output .alert-warning{color:#8a6d3b!important;background-color:#fcf8e3!important}.note-editor.note-frame .note-status-output .alert-danger{color:#a94442!important;background-color:#f2dede!important}.note-editor.note-frame .note-statusbar{background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.note-editor.note-frame .note-statusbar .note-resizebar{width:100%;height:9px;padding-top:1px;cursor:ns-resize}.note-editor.note-frame .note-statusbar .note-resizebar .note-icon-bar{width:20px;margin:1px auto;border-top:1px solid #a9a9a9}.note-editor.note-frame .note-statusbar.locked .note-resizebar{cursor:default}.note-editor.note-frame .note-statusbar.locked .note-resizebar .note-icon-bar{display:none}.note-editor.note-frame .note-placeholder{padding:10px}.note-popover.popover{display:none;max-width:none}.note-popover.popover .popover-content a{display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle}.note-popover.popover .arrow{left:20px!important}.note-toolbar{position:relative;z-index:500}.note-popover .popover-content,.card-header.note-toolbar{padding:0 0 5px 5px;margin:0}.note-popover .popover-content>.btn-group,.card-header.note-toolbar>.btn-group{margin-top:5px;margin-right:5px;margin-left:0}.note-popover .popover-content .btn-group .note-table,.card-header.note-toolbar .btn-group .note-table{min-width:0;padding:5px}.note-popover .popover-content .btn-group .note-table .note-dimension-picker,.card-header.note-toolbar .btn-group .note-table .note-dimension-picker{font-size:18px}.note-popover .popover-content .btn-group .note-table .note-dimension-picker .note-dimension-picker-mousecatcher,.card-header.note-toolbar .btn-group .note-table .note-dimension-picker .note-dimension-picker-mousecatcher{position:absolute!important;z-index:3;width:10em;height:10em;cursor:pointer}.note-popover .popover-content .btn-group .note-table .note-dimension-picker .note-dimension-picker-unhighlighted,.card-header.note-toolbar .btn-group .note-table .note-dimension-picker .note-dimension-picker-unhighlighted{position:relative!important;z-index:1;width:5em;height:5em;background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASAgMAAAAroGbEAAAACVBMVEUAAIj4+Pjp6ekKlAqjAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfYAR0BKhmnaJzPAAAAG0lEQVQI12NgAAOtVatWMTCohoaGUY+EmIkEAEruEzK2J7tvAAAAAElFTkSuQmCC') repeat}.note-popover .popover-content .btn-group .note-table .note-dimension-picker .note-dimension-picker-highlighted,.card-header.note-toolbar .btn-group .note-table .note-dimension-picker .note-dimension-picker-highlighted{position:absolute!important;z-index:2;width:1em;height:1em;background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASAgMAAAAroGbEAAAACVBMVEUAAIjd6vvD2f9LKLW+AAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfYAR0BKwNDEVT0AAAAG0lEQVQI12NgAAOtVatWMTCohoaGUY+EmIkEAEruEzK2J7tvAAAAAElFTkSuQmCC') repeat}.note-popover .popover-content .note-style .dropdown-style blockquote,.card-header.note-toolbar .note-style .dropdown-style blockquote,.note-popover .popover-content .note-style .dropdown-style pre,.card-header.note-toolbar .note-style .dropdown-style pre{padding:5px 10px;margin:0}.note-popover .popover-content .note-style .dropdown-style h1,.card-header.note-toolbar .note-style .dropdown-style h1,.note-popover .popover-content .note-style .dropdown-style h2,.card-header.note-toolbar .note-style .dropdown-style h2,.note-popover .popover-content .note-style .dropdown-style h3,.card-header.note-toolbar .note-style .dropdown-style h3,.note-popover .popover-content .note-style .dropdown-style h4,.card-header.note-toolbar .note-style .dropdown-style h4,.note-popover .popover-content .note-style .dropdown-style h5,.card-header.note-toolbar .note-style .dropdown-style h5,.note-popover .popover-content .note-style .dropdown-style h6,.card-header.note-toolbar .note-style .dropdown-style h6,.note-popover .popover-content .note-style .dropdown-style p,.card-header.note-toolbar .note-style .dropdown-style p{padding:0;margin:0}.note-popover .popover-content .note-color .dropdown-toggle,.card-header.note-toolbar .note-color .dropdown-toggle{width:20px;padding-left:5px}.note-popover .popover-content .note-color .dropdown-menu,.card-header.note-toolbar .note-color .dropdown-menu{min-width:337px}.note-popover .popover-content .note-color .dropdown-menu .note-palette,.card-header.note-toolbar .note-color .dropdown-menu .note-palette{display:inline-block;width:160px;margin:0}.note-popover .popover-content .note-color .dropdown-menu .note-palette:first-child,.card-header.note-toolbar .note-color .dropdown-menu .note-palette:first-child{margin:0 5px}.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-palette-title,.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-palette-title{margin:2px 7px;font-size:12px;text-align:center;border-bottom:1px solid #eee}.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-color-reset,.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-color-reset{width:100%;padding:0 3px;margin:3px;font-size:11px;cursor:pointer;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-color-row,.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-color-row{height:20px}.note-popover .popover-content .note-color .dropdown-menu .note-palette .note-color-reset:hover,.card-header.note-toolbar .note-color .dropdown-menu .note-palette .note-color-reset:hover{background:#eee}.note-popover .popover-content .note-para .dropdown-menu,.card-header.note-toolbar .note-para .dropdown-menu{min-width:216px;padding:5px}.note-popover .popover-content .note-para .dropdown-menu>div:first-child,.card-header.note-toolbar .note-para .dropdown-menu>div:first-child{margin-right:5px}.note-popover .popover-content .dropdown-menu,.card-header.note-toolbar .dropdown-menu{min-width:90px}.note-popover .popover-content .dropdown-menu.right,.card-header.note-toolbar .dropdown-menu.right{right:0;left:auto}.note-popover .popover-content .dropdown-menu.right::before,.card-header.note-toolbar .dropdown-menu.right::before{right:9px;left:auto!important}.note-popover .popover-content .dropdown-menu.right::after,.card-header.note-toolbar .dropdown-menu.right::after{right:10px;left:auto!important}.note-popover .popover-content .dropdown-menu.note-check a i,.card-header.note-toolbar .dropdown-menu.note-check a i{color:deepskyblue;visibility:hidden}.note-popover .popover-content .dropdown-menu.note-check a.checked i,.card-header.note-toolbar .dropdown-menu.note-check a.checked i{visibility:visible}.note-popover .popover-content .note-fontsize-10,.card-header.note-toolbar .note-fontsize-10{font-size:10px}.note-popover .popover-content .note-color-palette,.card-header.note-toolbar .note-color-palette{line-height:1}.note-popover .popover-content .note-color-palette div .note-color-btn,.card-header.note-toolbar .note-color-palette div .note-color-btn{width:20px;height:20px;padding:0;margin:0;border:1px solid #fff}.note-popover .popover-content .note-color-palette div .note-color-btn:hover,.card-header.note-toolbar .note-color-palette div .note-color-btn:hover{border:1px solid #000}.note-dialog>div{display:none}.note-dialog .form-group{margin-right:0;margin-left:0}.note-dialog .note-modal-form{margin:0}.note-dialog .note-image-dialog .note-dropzone{min-height:100px;margin-bottom:10px;font-size:30px;line-height:4;color:lightgray;text-align:center;border:4px dashed lightgray}@-moz-document url-prefix(){.note-image-input{height:auto}}.note-placeholder{position:absolute;display:none;color:gray}.note-handle .note-control-selection{position:absolute;display:none;border:1px solid black}.note-handle .note-control-selection>div{position:absolute}.note-handle .note-control-selection .note-control-selection-bg{width:100%;height:100%;background-color:black;-webkit-opacity:.3;-khtml-opacity:.3;-moz-opacity:.3;opacity:.3;-ms-filter:alpha(opacity=30);filter:alpha(opacity=30)}.note-handle .note-control-selection .note-control-handle{width:7px;height:7px;border:1px solid black}.note-handle .note-control-selection .note-control-holder{width:7px;height:7px;border:1px solid black}.note-handle .note-control-selection .note-control-sizing{width:7px;height:7px;background-color:white;border:1px solid black}.note-handle .note-control-selection .note-control-nw{top:-5px;left:-5px;border-right:0;border-bottom:0}.note-handle .note-control-selection .note-control-ne{top:-5px;right:-5px;border-bottom:0;border-left:none}.note-handle .note-control-selection .note-control-sw{bottom:-5px;left:-5px;border-top:0;border-right:0}.note-handle .note-control-selection .note-control-se{right:-5px;bottom:-5px;cursor:se-resize}.note-handle .note-control-selection .note-control-se.note-control-holder{cursor:default;border-top:0;border-left:none}.note-handle .note-control-selection .note-control-selection-info{right:0;bottom:0;padding:5px;margin:5px;font-size:12px;color:#fff;background-color:#000;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;-webkit-opacity:.7;-khtml-opacity:.7;-moz-opacity:.7;opacity:.7;-ms-filter:alpha(opacity=70);filter:alpha(opacity=70)}.note-hint-popover{min-width:100px;padding:2px}.note-hint-popover .popover-content{max-height:150px;padding:3px;overflow:auto}.note-hint-popover .popover-content .note-hint-group .note-hint-item{display:block!important;padding:3px}.note-hint-popover .popover-content .note-hint-group .note-hint-item.active,.note-hint-popover .popover-content .note-hint-group .note-hint-item:hover{display:block;clear:both;font-weight:400;line-height:1.4;color:#fff;text-decoration:none;white-space:nowrap;cursor:pointer;background-color:#428bca;outline:0}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/summernote.a52b483.eot";

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/summernote.a52b483.eot";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/summernote.f9b5d83.woff";

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/summernote.ad2ecd4.ttf";

/***/ }),
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(678);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(48)("562e0480", content, true, {});

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(47)(true);
// imports


// module
exports.push([module.i, ".input-group>.input-group-append:last-child>.b-dropdown:not(:last-child):not(.dropdown-toggle)>.btn,.input-group>.input-group-append:not(:last-child)>.b-dropdown>.btn,.input-group>.input-group-prepend>.b-dropdown>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.b-dropdown>.btn,.input-group>.input-group-prepend:first-child>.b-dropdown:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.b-dropdown>.btn{border-top-left-radius:0;border-bottom-left-radius:0}", "", {"version":3,"sources":["/usr/share/nginx/html/bladmjudicial.com.br/manager/node_modules/bootstrap-vue/es/components/dropdown/dropdown.css"],"names":[],"mappings":"AAGA,0NAGI,0BAA2B,AAC3B,4BAA8B,CACjC,AAED,wMAGI,yBAA0B,AAC1B,2BAA6B,CAChC","file":"dropdown.css","sourcesContent":["/* workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1560 */\n/* source: _input-group.scss */\n\n.input-group > .input-group-prepend > .b-dropdown > .btn,\n.input-group > .input-group-append:not(:last-child) > .b-dropdown > .btn,\n.input-group > .input-group-append:last-child > .b-dropdown:not(:last-child):not(.dropdown-toggle) > .btn {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .b-dropdown > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .b-dropdown > .btn,\n.input-group > .input-group-prepend:first-child > .b-dropdown:not(:first-child) > .btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(48)("c5c6b460", content, true, {});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(47)(true);
// imports


// module
exports.push([module.i, "input.form-control[type=color],input.form-control[type=range]{height:2.25rem}input.form-control.form-control-sm[type=color],input.form-control.form-control-sm[type=range]{height:1.9375rem}input.form-control.form-control-lg[type=color],input.form-control.form-control-lg[type=range]{height:3rem}input.form-control[type=color]{padding:.25rem}input.form-control.form-control-sm[type=color]{padding:.125rem}", "", {"version":3,"sources":["/usr/share/nginx/html/bladmjudicial.com.br/manager/node_modules/bootstrap-vue/es/components/form-input/form-input.css"],"names":[],"mappings":"AACA,8DAEI,cAAgB,CACnB,AACD,8FAEI,gBAAkB,CACrB,AACD,8FAEI,WAAa,CAChB,AAGD,+BACI,cAAyB,CAC5B,AACD,+CACI,eAA2B,CAC9B","file":"form-input.css","sourcesContent":["/* Special styling for type=range and type=color input */\ninput.form-control[type=\"range\"],\ninput.form-control[type=\"color\"] {\n    height: 2.25rem;\n}\ninput.form-control.form-control-sm[type=\"range\"],\ninput.form-control.form-control-sm[type=\"color\"] {\n    height: 1.9375rem;\n}\ninput.form-control.form-control-lg[type=\"range\"],\ninput.form-control.form-control-lg[type=\"color\"] {\n    height: 3rem;\n}\n\n/* Less padding on type=color */\ninput.form-control[type=\"color\"] {\n    padding: 0.25rem 0.25rem;\n}\ninput.form-control.form-control-sm[type=\"color\"] {\n    padding: 0.125rem 0.125rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(740);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(48)("1825563a", content, true, {});

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(47)(true);
// imports


// module
exports.push([module.i, "table.b-table.b-table-fixed{table-layout:fixed}table.b-table[aria-busy=false]{opacity:1}table.b-table[aria-busy=true]{opacity:.6}table.b-table>tfoot>tr>th,table.b-table>thead>tr>th{position:relative}table.b-table>tfoot>tr>th.sorting,table.b-table>thead>tr>th.sorting{padding-right:1.5em;cursor:pointer}table.b-table>tfoot>tr>th.sorting:after,table.b-table>tfoot>tr>th.sorting:before,table.b-table>thead>tr>th.sorting:after,table.b-table>thead>tr>th.sorting:before{position:absolute;bottom:0;display:block;opacity:.4;padding-bottom:inherit;font-size:inherit;line-height:180%}table.b-table>tfoot>tr>th.sorting:before,table.b-table>thead>tr>th.sorting:before{right:.75em;content:\"\\2191\"}table.b-table>tfoot>tr>th.sorting:after,table.b-table>thead>tr>th.sorting:after{right:.25em;content:\"\\2193\"}table.b-table>tfoot>tr>th.sorting_asc:after,table.b-table>tfoot>tr>th.sorting_desc:before,table.b-table>thead>tr>th.sorting_asc:after,table.b-table>thead>tr>th.sorting_desc:before{opacity:1}table.b-table.b-table-stacked{width:100%}table.b-table.b-table-stacked,table.b-table.b-table-stacked>caption,table.b-table.b-table-stacked>tbody,table.b-table.b-table-stacked>tbody>tr,table.b-table.b-table-stacked>tbody>tr>td,table.b-table.b-table-stacked>tbody>tr>th{display:block}table.b-table.b-table-stacked>tbody>tr.b-table-bottom-row,table.b-table.b-table-stacked>tbody>tr.b-table-top-row,table.b-table.b-table-stacked>tfoot,table.b-table.b-table-stacked>thead{display:none}table.b-table.b-table-stacked>tbody>tr>:first-child{border-top-width:.4rem}table.b-table.b-table-stacked>tbody>tr>[data-label]{display:grid;grid-template-columns:40% auto;grid-gap:.25rem 1rem}table.b-table.b-table-stacked>tbody>tr>[data-label]:before{content:attr(data-label);display:inline;text-align:right;overflow-wrap:break-word;font-weight:700;font-style:normal}@media (max-width:575.99px){table.b-table.b-table-stacked-sm{width:100%}table.b-table.b-table-stacked-sm,table.b-table.b-table-stacked-sm>caption,table.b-table.b-table-stacked-sm>tbody,table.b-table.b-table-stacked-sm>tbody>tr,table.b-table.b-table-stacked-sm>tbody>tr>td,table.b-table.b-table-stacked-sm>tbody>tr>th{display:block}table.b-table.b-table-stacked-sm>tbody>tr.b-table-bottom-row,table.b-table.b-table-stacked-sm>tbody>tr.b-table-top-row,table.b-table.b-table-stacked-sm>tfoot,table.b-table.b-table-stacked-sm>thead{display:none}table.b-table.b-table-stacked-sm>tbody>tr>:first-child{border-top-width:.4rem}table.b-table.b-table-stacked-sm>tbody>tr>[data-label]{display:grid;grid-template-columns:40% auto;grid-gap:.25rem 1rem}table.b-table.b-table-stacked-sm>tbody>tr>[data-label]:before{content:attr(data-label);display:inline;text-align:right;overflow-wrap:break-word;font-weight:700;font-style:normal}}@media (max-width:767.99px){table.b-table.b-table-stacked-md{width:100%}table.b-table.b-table-stacked-md,table.b-table.b-table-stacked-md>caption,table.b-table.b-table-stacked-md>tbody,table.b-table.b-table-stacked-md>tbody>tr,table.b-table.b-table-stacked-md>tbody>tr>td,table.b-table.b-table-stacked-md>tbody>tr>th{display:block}table.b-table.b-table-stacked-md>tbody>tr.b-table-bottom-row,table.b-table.b-table-stacked-md>tbody>tr.b-table-top-row,table.b-table.b-table-stacked-md>tfoot,table.b-table.b-table-stacked-md>thead{display:none}table.b-table.b-table-stacked-md>tbody>tr>:first-child{border-top-width:.4rem}table.b-table.b-table-stacked-md>tbody>tr>[data-label]{display:grid;grid-template-columns:40% auto;grid-gap:.25rem 1rem}table.b-table.b-table-stacked-md>tbody>tr>[data-label]:before{content:attr(data-label);display:inline;text-align:right;overflow-wrap:break-word;font-weight:700;font-style:normal}}@media (max-width:991.99px){table.b-table.b-table-stacked-lg{width:100%}table.b-table.b-table-stacked-lg,table.b-table.b-table-stacked-lg>caption,table.b-table.b-table-stacked-lg>tbody,table.b-table.b-table-stacked-lg>tbody>tr,table.b-table.b-table-stacked-lg>tbody>tr>td,table.b-table.b-table-stacked-lg>tbody>tr>th{display:block}table.b-table.b-table-stacked-lg>tbody>tr.b-table-bottom-row,table.b-table.b-table-stacked-lg>tbody>tr.b-table-top-row,table.b-table.b-table-stacked-lg>tfoot,table.b-table.b-table-stacked-lg>thead{display:none}table.b-table.b-table-stacked-lg>tbody>tr>:first-child{border-top-width:.4rem}table.b-table.b-table-stacked-lg>tbody>tr>[data-label]{display:grid;grid-template-columns:40% auto;grid-gap:.25rem 1rem}table.b-table.b-table-stacked-lg>tbody>tr>[data-label]:before{content:attr(data-label);display:inline;text-align:right;overflow-wrap:break-word;font-weight:700;font-style:normal}}@media (max-width:1199.99px){table.b-table.b-table-stacked-xl{width:100%}table.b-table.b-table-stacked-xl,table.b-table.b-table-stacked-xl>caption,table.b-table.b-table-stacked-xl>tbody,table.b-table.b-table-stacked-xl>tbody>tr,table.b-table.b-table-stacked-xl>tbody>tr>td,table.b-table.b-table-stacked-xl>tbody>tr>th{display:block}table.b-table.b-table-stacked-xl>tbody>tr.b-table-bottom-row,table.b-table.b-table-stacked-xl>tbody>tr.b-table-top-row,table.b-table.b-table-stacked-xl>tfoot,table.b-table.b-table-stacked-xl>thead{display:none}table.b-table.b-table-stacked-xl>tbody>tr>:first-child{border-top-width:.4rem}table.b-table.b-table-stacked-xl>tbody>tr>[data-label]{display:grid;grid-template-columns:40% auto;grid-gap:.25rem 1rem}table.b-table.b-table-stacked-xl>tbody>tr>[data-label]:before{content:attr(data-label);display:inline;text-align:right;overflow-wrap:break-word;font-weight:700;font-style:normal}}table.b-table>tbody>tr.b-table-details>td{border-top:none}", "", {"version":3,"sources":["/usr/share/nginx/html/bladmjudicial.com.br/manager/node_modules/bootstrap-vue/es/components/table/table.css"],"names":[],"mappings":"AACA,4BACI,kBAAoB,CACvB,AAGD,+BACI,SAAW,CACd,AACD,8BACI,UAAa,CAChB,AAGD,oDAEI,iBAAmB,CACtB,AACD,oEAEI,oBAAqB,AACrB,cAAgB,CACnB,AACD,kKAII,kBAAmB,AACnB,SAAU,AACV,cAAe,AACf,WAAa,AACb,uBAAwB,AACxB,kBAAmB,AACnB,gBAAkB,CACrB,AACD,kFAEI,YAAc,AACd,eAAiB,CACpB,AACD,gFAEI,YAAc,AACd,eAAiB,CACpB,AACD,oLAII,SAAW,CACd,AAKD,8BACI,UAAY,CACf,AACD,mOAMI,aAAe,CAClB,AAGD,yLAII,YAAc,CACjB,AAGD,oDACI,sBAAyB,CAC5B,AAGD,oDACI,aAAc,AACd,+BAAgC,AAChC,oBAAuB,CAC1B,AAGD,2DACI,yBAA0B,AAC1B,eAAgB,AAChB,iBAAkB,AAClB,yBAA0B,AAC1B,gBAAkB,AAClB,iBAAmB,CACtB,AAED,4BAEI,iCACI,UAAY,CACf,AACD,qPAMI,aAAe,CAClB,AAED,qMAII,YAAc,CACjB,AAED,uDACI,sBAAyB,CAC5B,AAED,uDACI,aAAc,AACd,+BAAgC,AAChC,oBAAuB,CAC1B,AAED,8DACI,yBAA0B,AAC1B,eAAgB,AAChB,iBAAkB,AAClB,yBAA0B,AAC1B,gBAAkB,AAClB,iBAAmB,CACtB,CACJ,AAED,4BAEI,iCACI,UAAY,CACf,AACD,qPAMI,aAAe,CAClB,AAED,qMAII,YAAc,CACjB,AAED,uDACI,sBAAyB,CAC5B,AAED,uDACI,aAAc,AACd,+BAAgC,AAChC,oBAAuB,CAC1B,AAED,8DACI,yBAA0B,AAC1B,eAAgB,AAChB,iBAAkB,AAClB,yBAA0B,AAC1B,gBAAkB,AAClB,iBAAmB,CACtB,CACJ,AAED,4BAEI,iCACI,UAAY,CACf,AACD,qPAMI,aAAe,CAClB,AAED,qMAII,YAAc,CACjB,AAED,uDACI,sBAAyB,CAC5B,AAED,uDACI,aAAc,AACd,+BAAgC,AAChC,oBAAuB,CAC1B,AAED,8DACI,yBAA0B,AAC1B,eAAgB,AAChB,iBAAkB,AAClB,yBAA0B,AAC1B,gBAAkB,AAClB,iBAAmB,CACtB,CACJ,AAED,6BAEI,iCACI,UAAY,CACf,AACD,qPAMI,aAAe,CAClB,AAED,qMAII,YAAc,CACjB,AAED,uDACI,sBAAyB,CAC5B,AAED,uDACI,aAAc,AACd,+BAAgC,AAChC,oBAAuB,CAC1B,AAED,8DACI,yBAA0B,AAC1B,eAAgB,AAChB,iBAAkB,AAClB,yBAA0B,AAC1B,gBAAkB,AAClB,iBAAmB,CACtB,CACJ,AAGD,0CACI,eAAiB,CACpB","file":"table.css","sourcesContent":["/* Add support for fixed layout table */\ntable.b-table.b-table-fixed {\n    table-layout: fixed;\n}\n\n/* Busy table styling */\ntable.b-table[aria-busy='false'] {\n    opacity: 1;\n}\ntable.b-table[aria-busy='true'] {\n    opacity: 0.6;\n}\n\n/* Sort styling */\ntable.b-table > thead > tr > th,\ntable.b-table > tfoot > tr > th {\n    position: relative;\n}\ntable.b-table > thead > tr > th.sorting,\ntable.b-table > tfoot > tr > th.sorting {\n    padding-right: 1.5em;\n    cursor: pointer;\n}\ntable.b-table > thead > tr > th.sorting::before,\ntable.b-table > thead > tr > th.sorting::after,\ntable.b-table > tfoot > tr > th.sorting::before,\ntable.b-table > tfoot > tr > th.sorting::after {\n    position: absolute;\n    bottom: 0;\n    display: block;\n    opacity: 0.4;\n    padding-bottom: inherit;\n    font-size: inherit;\n    line-height: 180%;\n}\ntable.b-table > thead > tr > th.sorting::before,\ntable.b-table > tfoot > tr > th.sorting::before {\n    right: 0.75em;\n    content: '\\2191';\n}\ntable.b-table > thead > tr > th.sorting::after,\ntable.b-table > tfoot > tr > th.sorting::after {\n    right: 0.25em;\n    content: '\\2193';\n}\ntable.b-table > thead > tr > th.sorting_asc::after,\ntable.b-table > thead > tr > th.sorting_desc::before,\ntable.b-table > tfoot > tr > th.sorting_asc::after,\ntable.b-table > tfoot > tr > th.sorting_desc::before {\n    opacity: 1;\n}\n\n/* Stacked table layout */\n/* Derived from http://blog.adrianroselli.com/2017/11/a-responsive-accessible-table.html */\n/* Always stacked */\ntable.b-table.b-table-stacked {\n    width: 100%;\n}\ntable.b-table.b-table-stacked,\ntable.b-table.b-table-stacked > tbody,\ntable.b-table.b-table-stacked > tbody > tr,\ntable.b-table.b-table-stacked > tbody > tr > td,\ntable.b-table.b-table-stacked > tbody > tr > th,\ntable.b-table.b-table-stacked > caption {\n    display: block;\n}\n\n/* Hide stuff we can't deal with, or shouldn't show */\ntable.b-table.b-table-stacked > thead,\ntable.b-table.b-table-stacked > tfoot,\ntable.b-table.b-table-stacked > tbody > tr.b-table-top-row,\ntable.b-table.b-table-stacked > tbody > tr.b-table-bottom-row {\n    display: none;\n}\n\n/* inter-row top border */\ntable.b-table.b-table-stacked > tbody > tr > :first-child {\n    border-top-width: 0.4rem;\n}\n\n/* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\ntable.b-table.b-table-stacked > tbody > tr > [data-label] {\n    display: grid;\n    grid-template-columns: 40% auto;\n    grid-gap: 0.25rem 1rem;\n}\n\n/* generate row cell \"heading\" */\ntable.b-table.b-table-stacked > tbody > tr > [data-label]::before {\n    content: attr(data-label);\n    display: inline;\n    text-align: right;\n    overflow-wrap: break-word;\n    font-weight: bold;\n    font-style: normal;\n}\n\n@media all and (max-width: 575.99px) {\n    /* Under SM */\n    table.b-table.b-table-stacked-sm {\n        width: 100%;\n    }\n    table.b-table.b-table-stacked-sm,\n    table.b-table.b-table-stacked-sm > tbody,\n    table.b-table.b-table-stacked-sm > tbody > tr,\n    table.b-table.b-table-stacked-sm > tbody > tr > td,\n    table.b-table.b-table-stacked-sm > tbody > tr > th,\n    table.b-table.b-table-stacked-sm > caption {\n        display: block;\n    }\n    /* hide stuff we can't deal with, or shouldn't show */\n    table.b-table.b-table-stacked-sm > thead,\n    table.b-table.b-table-stacked-sm > tfoot,\n    table.b-table.b-table-stacked-sm > tbody > tr.b-table-top-row,\n    table.b-table.b-table-stacked-sm > tbody > tr.b-table-bottom-row {\n        display: none;\n    }\n    /* inter-row top border */\n    table.b-table.b-table-stacked-sm > tbody > tr > :first-child {\n        border-top-width: 0.4rem;\n    }\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\n    table.b-table.b-table-stacked-sm > tbody > tr > [data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: 0.25rem 1rem;\n    }\n    /* generate row cell \"heading\" */\n    table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n    }\n}\n\n@media all and (max-width: 767.99px) {\n    /* under MD  */\n    table.b-table.b-table-stacked-md {\n        width: 100%;\n    }\n    table.b-table.b-table-stacked-md,\n    table.b-table.b-table-stacked-md > tbody,\n    table.b-table.b-table-stacked-md > tbody > tr,\n    table.b-table.b-table-stacked-md > tbody > tr > td,\n    table.b-table.b-table-stacked-md > tbody > tr > th,\n    table.b-table.b-table-stacked-md > caption {\n        display: block;\n    }\n    /* hide stuff we can't deal with, or shouldn't show */\n    table.b-table.b-table-stacked-md > thead,\n    table.b-table.b-table-stacked-md > tfoot,\n    table.b-table.b-table-stacked-md > tbody > tr.b-table-top-row,\n    table.b-table.b-table-stacked-md > tbody > tr.b-table-bottom-row {\n        display: none;\n    }\n    /* inter-row top border */\n    table.b-table.b-table-stacked-md > tbody > tr > :first-child {\n        border-top-width: 0.4rem;\n    }\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\n    table.b-table.b-table-stacked-md > tbody > tr > [data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: 0.25rem 1rem;\n    }\n    /* generate row cell \"heading\" */\n    table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n    }\n}\n\n@media all and (max-width: 991.99px) {\n    /* under LG  */\n    table.b-table.b-table-stacked-lg {\n        width: 100%;\n    }\n    table.b-table.b-table-stacked-lg,\n    table.b-table.b-table-stacked-lg > tbody,\n    table.b-table.b-table-stacked-lg > tbody > tr,\n    table.b-table.b-table-stacked-lg > tbody > tr > td,\n    table.b-table.b-table-stacked-lg > tbody > tr > th,\n    table.b-table.b-table-stacked-lg > caption {\n        display: block;\n    }\n    /* hide stuff we can't deal with, or shouldn't show */\n    table.b-table.b-table-stacked-lg > thead,\n    table.b-table.b-table-stacked-lg > tfoot,\n    table.b-table.b-table-stacked-lg > tbody > tr.b-table-top-row,\n    table.b-table.b-table-stacked-lg > tbody > tr.b-table-bottom-row {\n        display: none;\n    }\n    /* inter-row top border */\n    table.b-table.b-table-stacked-lg > tbody > tr > :first-child {\n        border-top-width: 0.4rem;\n    }\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\n    table.b-table.b-table-stacked-lg > tbody > tr > [data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: 0.25rem 1rem;\n    }\n    /* generate row cell \"heading\" */\n    table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n    }\n}\n\n@media all and (max-width: 1199.99px) {\n    /* under XL  */\n    table.b-table.b-table-stacked-xl {\n        width: 100%;\n    }\n    table.b-table.b-table-stacked-xl,\n    table.b-table.b-table-stacked-xl > tbody,\n    table.b-table.b-table-stacked-xl > tbody > tr,\n    table.b-table.b-table-stacked-xl > tbody > tr > td,\n    table.b-table.b-table-stacked-xl > tbody > tr > th,\n    table.b-table.b-table-stacked-xl > caption {\n        display: block;\n    }\n    /* hide stuff we can't deal with, or shouldn't show */\n    table.b-table.b-table-stacked-xl > thead,\n    table.b-table.b-table-stacked-xl > tfoot,\n    table.b-table.b-table-stacked-xl > tbody > tr.b-table-top-row,\n    table.b-table.b-table-stacked-xl > tbody > tr.b-table-bottom-row {\n        display: none;\n    }\n    /* inter-row top border */\n    table.b-table.b-table-stacked-xl > tbody > tr > :first-child {\n        border-top-width: 0.4rem;\n    }\n    /* convert TD/TH contents to \"cells\". Caveat: child elements become cells! */\n    table.b-table.b-table-stacked-xl > tbody > tr > [data-label] {\n        display: grid;\n        grid-template-columns: 40% auto;\n        grid-gap: 0.25rem 1rem;\n    }\n    /* generate row cell \"heading\" */\n    table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {\n        content: attr(data-label);\n        display: inline;\n        text-align: right;\n        overflow-wrap: break-word;\n        font-weight: bold;\n        font-style: normal;\n    }\n}\n\n/* Details row styling */\ntable.b-table > tbody > tr.b-table-details > td {\n    border-top: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("quick-access col-lg-" + (_vm.options.colSize || 6))},[_c('list-groups',{attrs:{"options":_vm.options}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"action"},slot:"action"},[_vm._v("\n          "+_vm._s(_vm.pagination.total)+"\n        ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-list-group-item',{key:item.id,staticClass:"flex-column align-items-start quick-access",attrs:{"slot":"card","href":_vm.options.link.href + item.id || '#!',"target":_vm.options.link.target || '_self'},slot:"card"},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[(item.name)?_c('h5',{staticClass:"col-lg-8 alpha no-margin"},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")]):_vm._e(),_vm._v(" "),(item.created_at)?_c('small',{staticClass:"col-lg-4 omega text-right",staticStyle:{"padding-top":"4px"}},[_c('b',[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm._f("moment")(item.created_at,'DD/MM/YYYY HH:mm')))])]):_vm._e()])])})],2)],1)}
var staticRenderFns = []


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CareerContacts_vue__ = __webpack_require__(356);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ddb6e90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareerContacts_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CareerContacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ddb6e90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareerContacts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ddb6e90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareerContacts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length>0)?_c('div',{staticClass:"quick-access col-lg-6 alpha omega"},[_c('list-groups',{attrs:{"options":_vm.options}},[_c('small',{staticClass:"text-muted",attrs:{"slot":"action"},slot:"action"},[_vm._v("\n      "+_vm._s(_vm.pagination.total)+"\n    ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-list-group-item',{key:item.id,staticClass:"flex-column align-items-start",attrs:{"slot":"card","href":_vm.options.link.href + item.id || '#!',"target":_vm.options.link.target || '_self'},slot:"card"},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"mb-1"},[_vm._v("\n          "+_vm._s(item.name || 'Anónimo')+"\n        ")]),_vm._v(" "),(item.created_at)?_c('small',[_vm._v("\n          "+_vm._s(_vm._f("moment")(item.created_at,'DD/MM/YYYY HH:mm'))+"\n        ")]):_vm._e()]),_vm._v(" "),(item.presentation)?_c('p',{staticClass:"mb-1"},[_vm._v("\n        "+_vm._s(item.career || 'Sem Carreira')),_c('br'),_vm._v("\n        "+_vm._s(_vm._f("truncate")(item.presentation,100))+"\n      ")]):_vm._e(),_vm._v(" "),(item.city && item.city.representation)?_c('small',[_vm._v("\n        "+_vm._s(item.city.representation)+"\n      ")]):_vm._e(),_vm._v(" "),(item.file.length > 0)?_c('div',[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Currículo Anexado\n      ")]):_vm._e()])})],2)],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessFiles_vue__ = __webpack_require__(357);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e05f853_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessFiles_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(765)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e05f853"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e05f853_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessFiles_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e05f853_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessFiles_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("quick-access list-process-files col-lg-" + (_vm.options.colSize || 6))},[_c('list-groups',{attrs:{"options":_vm.options}},[_c('small',{staticClass:"label label-success",attrs:{"slot":"action"},slot:"action"},[_vm._v("\n      "+_vm._s(_vm.pagination.total)+"\n    ")]),_vm._v(" "),_vm._l((_vm.items.slice(0, 3)),function(item){return _c('b-list-group-item',{key:item.id,staticClass:"align-items-start col-lg-6",attrs:{"slot":"card","href":_vm.options.link.href + item.process.id || '#!',"target":_vm.options.link.target || '_self'},slot:"card"},[_c('div',{staticClass:"list-group-item-card"},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[(item.process.company_name)?_c('h5',{staticClass:"col-lg-7 alpha"},[_vm._v("\n            "+_vm._s(item.process.company_name)+" \n\n  ")]):_vm._e(),_vm._v(" "),(item.created_at)?_c('small',{staticClass:"col-lg-5 omega text-right"},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}}),_vm._v("  Enviado em "+_vm._s(_vm._f("moment")(item.created_at,'DD/MM/YYYY HH:mm'))+"\n          ")]):_vm._e()]),_vm._v(" "),(item.attachments.length > 0)?_c('small',[_c('fieldset',{staticClass:"attachments"},[_c('legend',{attrs:{"align":"left"}},[_vm._v("\n              Downloads\n            ")]),_vm._v(" "),_vm._l((item.attachments),function(attachment,index){return _c('span',{key:attachment.id},[(index < 2)?[_c('a',{attrs:{"href":_vm.get(attachment, '_links.download', '#!')}},[_vm._v("\n                  "+_vm._s(attachment.file.original_name)+"\n                ")]),_vm._v(" "),(index == item.attachments.length - 1 && _vm.get(item, '_links', false))?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"item-attachments-btn",attrs:{"href":_vm.get(item, '_links.download', '#!'),"title":"Download"}},[_c('i',{staticClass:"fa fa-download"})]):_vm._e()]:_vm._e()],2)})],2)]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list list-content alpha"},[_c('li',[_c('p',{staticClass:"mb-1"},[_c('b',[_vm._v("Enviado por:")]),_vm._v(" \n\n              "),(_vm.get(item, 'user.name', false))?_c('span',[_vm._v("\n                "+_vm._s(_vm.get(item, 'user.name', ''))+" "),_c('small',[_vm._v("("+_vm._s(_vm.get(item, 'user.main_role.name', ''))+")")])]):_c('span',[_vm._v("\n                Usuário não encontrado\n              ")])])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mb-1"},[_c('b',[_vm._v("Tipo:")]),_vm._v(" "+_vm._s(_vm.get(item, 'type.name', 'Sem categoria'))+"\n            ")])]),_vm._v(" "),_c('li',[(item.reference_date)?_c('p',{staticClass:"mb-1"},[_c('b',[_vm._v("Referência:")]),_vm._v(" "+_vm._s(_vm._f("moment")(item.reference_date,'MM/YYYY'))+"\n            ")]):_vm._e()])])])])})],2)],1)}
var staticRenderFns = []


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authorizations_vue__ = __webpack_require__(358);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a45042_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authorizations_vue__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(768)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a45042"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authorizations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a45042_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authorizations_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a45042_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authorizations_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:("quick-access col-lg-" + (_vm.options.colSize || 6))},[(_vm.authorization)?_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Recusar Acesso"},on:{"ok":_vm.decline},model:{value:(_vm.declineModal),callback:function ($$v) {_vm.declineModal=$$v},expression:"declineModal"}},[_vm._v("\n\n      Deseja realmente negar o acesso ao usuário "+_vm._s(_vm.authorization.user.email)+" ao sistema?"),_c('br'),_vm._v("\n      O usuário será removido e deverá se cadastrar novamente.\n    ")]):_vm._e(),_vm._v(" "),_c('list-groups',{attrs:{"options":_vm.options}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"action"},slot:"action"},[_vm._v("\n        "+_vm._s(_vm.pagination.total)+"\n      ")]),_vm._v(" "),(_vm.collection.length > 0)?_c('template',{slot:"card"},_vm._l((_vm.collection),function(item,index){return _c('b-list-group-item',{key:("card-authorizaitons-" + index),staticClass:"flex-column align-items-start quick-access",attrs:{"route":_vm.options.route,"href":_vm.href(item),"target":"_self"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_c('h5',[_vm._v("\n                "+_vm._s(item.user.name)+" \n                ("+_vm._s(item.user.main_role ? item.user.main_role.name : '')+")\n              ")]),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(item.user.email || '')+" "+_vm._s(item.user.document || '')+"\n              ")])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"actions d-flex w-100 justify-content-end"},[_c('b-button',{attrs:{"variant":"success","disabled":_vm.processingAuthorizations.indexOf(item.id) > -1},on:{"click":function($event){$event.stopPropagation();_vm.approve(item)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Aprovar\n                ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"secondary","disabled":_vm.processingAuthorizations.indexOf(item.id) > -1},on:{"click":function($event){$event.stopPropagation();_vm.showDeclineModal(item)}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Recusar\n                ")])],1)])],1)],1)})):_c('b-list-group-item',{attrs:{"slot":"card"},slot:"card"},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"actions d-flex w-100 justify-content-center"},[_vm._v("\n              Nenhuma autorização pendente foi encontrada\n            ")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('router-link',{attrs:{"to":{ name: 'bl-authorizations.index' }}},[_c('small',{staticClass:"btn pull-right"},[_vm._v("\n            Visualizar todas\n          ")])])],1)],2)],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__(360);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99750b88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(771)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99750b88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99750b88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99750b88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("quick-access col-lg-" + (_vm.options.colSize || 6))},[_c('list-groups',{attrs:{"options":_vm.options}},[_c('small',{staticClass:"text-muted label label-success",attrs:{"slot":"action"},slot:"action"},[_vm._v("\n      "+_vm._s(_vm.pagination.total)+"\n    ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('b-list-group-item',{key:item.id,staticClass:"flex-column align-items-start",attrs:{"slot":"card","href":_vm.options.link.href + item.id || '#!',"target":_vm.options.link.target || '_self'},slot:"card"},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"mb-1"},[_vm._v("\n          "+_vm._s(item.name || 'Anónimo')+"\n        ")]),_vm._v(" "),(item.created_at)?_c('small',[_vm._v("\n          "+_vm._s(_vm._f("moment")(item.created_at,'DD/MM/YYYY HH:mm'))+"\n        ")]):_vm._e()]),_vm._v(" "),(item.body)?_c('p',{staticClass:"mb-1"},[_vm._v("\n        "+_vm._s(item.subject || 'Sem Assunto')),_c('br'),_vm._v("\n        "+_vm._s(_vm._f("truncate")(item.body,100))+"\n      ")]):_vm._e(),_vm._v(" "),(item.city && item.city.representation)?_c('small',[_vm._v("\n        "+_vm._s(item.city.representation)+"\n      ")]):_vm._e(),_vm._v(" "),(item.attachments.length > 0)?_c('div',[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" "+_vm._s(item.attachments.length)+" Anexos\n      ")]):_vm._e()])})],2)],1)}
var staticRenderFns = []


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticStyle:{"width":"100%"}},_vm._l((_vm.cards),function(card,index){return _c('b-col',{key:("dashboard-card-" + index)},[_c('simple-card',{attrs:{"card":card,"data":_vm.get(_vm.data, card.key, [])}})],1)})),_vm._v(" "),_c('b-row',{staticStyle:{"width":"100%"}},_vm._l((_vm.widgets),function(item,index){return _c(item,{key:'dashboard-widget-' + index,tag:"component"})}))],1)}
var staticRenderFns = []


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(361);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a36d92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a36d92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a36d92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"animated fadeIn card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body w-100",staticStyle:{"margin-top":"20px"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)},"reset":function($event){$event.preventDefault();_vm.onReset($event)}}},[_c('div',{staticClass:"card-box"},[_c('div',{staticClass:"w-100 mb-4"},[_c('h3',[_vm._v("Endereços de email")]),_vm._v(" "),_c('p',[_vm._v("\n            Informe os emails para cada contexto inserindo até cinco endereçoes de email separados por \";\". Caso os nenhum email seja informado, todos os usuários admin receberão emails.\n          ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Contatos","label-for":"contact_receivers","description":"Os endereços de email inseridos aqui receberão os contatos realizados pelo site."}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('contact_receivers'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('contact_receivers')
                },attrs:{"id":"contact_receivers","type":"text","placeholder":""},model:{value:(_vm.form.contact_receivers),callback:function ($$v) {_vm.$set(_vm.form, "contact_receivers", $$v)},expression:"form.contact_receivers"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Trabalhe Conosco","label-for":"career_contact_receivers","description":"Os endereços de email inseridos aqui receberão notificações dos currículos recebidos pelo site."}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('career_contact_receivers'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('career_contact_receivers')
                },attrs:{"id":"career_contact_receivers","type":"text","placeholder":""},model:{value:(_vm.form.career_contact_receivers),callback:function ($$v) {_vm.$set(_vm.form, "career_contact_receivers", $$v)},expression:"form.career_contact_receivers"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Recebimento das notificações de novos usuários para autorizar","label-for":"authorization_receivers","description":"Os endereços de email inseridos aqui receberão notificações de usuarios que precisam de autorização para acessaro sistema."}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('authorization_receivers'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('authorization_receivers')
                },attrs:{"id":"authorization_receivers","type":"text","placeholder":""},model:{value:(_vm.form.authorization_receivers),callback:function ($$v) {_vm.$set(_vm.form, "authorization_receivers", $$v)},expression:"form.authorization_receivers"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"w-100 mb-4"},[_c('h3',[_vm._v("Endereços")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_vm._v("\n            Informe os dados para cada endereço.\n          ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Cidade 1","label-for":"rao_title","description":""}},[_c('b-form-input',{class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('rao_title'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('rao_title')
                    },attrs:{"id":"rao_title","type":"text","placeholder":""},model:{value:(_vm.form.rao_title),callback:function ($$v) {_vm.$set(_vm.form, "rao_title", $$v)},expression:"form.rao_title"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Telefone","label-for":"rao_phone","description":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(['(##) ####-####', '(##) #####-####']),expression:"['(##) ####-####', '(##) #####-####']"}],class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('rao_phone'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('rao_phone')
                    },attrs:{"id":"rao_phone","type":"text","placeholder":""},model:{value:(_vm.form.rao_phone),callback:function ($$v) {_vm.$set(_vm.form, "rao_phone", $$v)},expression:"form.rao_phone"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Endereço","label-for":"rao_address","description":""}},[_c('rich-textarea',{attrs:{"height":200,"name":"rao_address","toolbar":[
                      ['font', ['bold', 'italic', 'underline', 'clear']],
                      ['insert', ['link']]
                    ]},model:{value:(_vm.form.rao_address),callback:function ($$v) {_vm.$set(_vm.form, "rao_address", $$v)},expression:"form.rao_address"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-lg-6",attrs:{"id":"group","label":"Latitude","label-for":"rao_latitude","description":""}},[_c('b-form-input',{class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('rao_latitude'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('rao_latitude')
                    },attrs:{"id":"rao_latitude","type":"text","placeholder":""},model:{value:(_vm.form.rao_latitude),callback:function ($$v) {_vm.$set(_vm.form, "rao_latitude", $$v)},expression:"form.rao_latitude"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-lg-6",attrs:{"id":"group","label":"Longitude","label-for":"rao_longitude","description":""}},[_c('b-form-input',{class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('rao_longitude'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('rao_longitude')
                    },attrs:{"id":"rao_longitude","type":"text","placeholder":""},model:{value:(_vm.form.rao_longitude),callback:function ($$v) {_vm.$set(_vm.form, "rao_longitude", $$v)},expression:"form.rao_longitude"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Cidade 2","label-for":"sap_title","description":""}},[_c('b-form-input',{class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('sap_title'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('sap_title')
                    },attrs:{"id":"sap_title","type":"text","placeholder":""},model:{value:(_vm.form.sap_title),callback:function ($$v) {_vm.$set(_vm.form, "sap_title", $$v)},expression:"form.sap_title"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Telefone","label-for":"sap_phone","description":""}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(['(##) ####-####', '(##) #####-####']),expression:"['(##) ####-####', '(##) #####-####']"}],class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('sap_phone'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('sap_phone')
                    },attrs:{"id":"sap_phone","type":"text","placeholder":""},model:{value:(_vm.form.sap_phone),callback:function ($$v) {_vm.$set(_vm.form, "sap_phone", $$v)},expression:"form.sap_phone"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Endereço","label-for":"sap_address","description":""}},[_c('rich-textarea',{attrs:{"height":200,"name":"sap_address","toolbar":[
                      ['font', ['bold', 'italic', 'underline', 'clear']],
                      ['insert', ['link']]
                    ]},model:{value:(_vm.form.sap_address),callback:function ($$v) {_vm.$set(_vm.form, "sap_address", $$v)},expression:"form.sap_address"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-lg-6",attrs:{"id":"group","label":"Latitude","label-for":"sap_latitude","description":""}},[_c('b-form-input',{class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('sap_latitude'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('sap_latitude')
                    },attrs:{"id":"sap_latitude","type":"text","placeholder":""},model:{value:(_vm.form.sap_latitude),callback:function ($$v) {_vm.$set(_vm.form, "sap_latitude", $$v)},expression:"form.sap_latitude"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-lg-6",attrs:{"id":"group","label":"Longitude","label-for":"sap_longitude","description":""}},[_c('b-form-input',{class:{
                      'is-invalid': _vm.submitted && _vm.form.errors.has('sap_longitude'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('sap_longitude')
                    },attrs:{"id":"sap_longitude","type":"text","placeholder":""},model:{value:(_vm.form.sap_longitude),callback:function ($$v) {_vm.$set(_vm.form, "sap_longitude", $$v)},expression:"form.sap_longitude"}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"w-100 mb-4"},[_c('h3',[_vm._v("LGPD")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_vm._v("\n            Informe o textos sobre a política e cookies.\n          ")]),_vm._v(" "),_c('h5',{staticClass:"my-3"},[_vm._v("Políticas de privacidade")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"10px","margin-bottom":"20px"}},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.privacy_policy_status),callback:function ($$v) {_vm.$set(_vm.form, "privacy_policy_status", $$v)},expression:"form.privacy_policy_status"}})],1)]),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Texto","label-for":"privacy_policy_text","description":""}},[_c('rich-textarea',{attrs:{"height":200,"name":"privacy_policy_text","toolbar":[
                  ['font', ['bold', 'italic', 'underline', 'clear']],
                  ['insert', ['link']]
                ]},model:{value:(_vm.form.privacy_policy_text),callback:function ($$v) {_vm.$set(_vm.form, "privacy_policy_text", $$v)},expression:"form.privacy_policy_text"}})],1)],1),_vm._v(" "),_c('h5',{staticClass:"my-3"},[_vm._v("Alerta Cookies")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"10px","margin-bottom":"20px"}},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.cookies_status),callback:function ($$v) {_vm.$set(_vm.form, "cookies_status", $$v)},expression:"form.cookies_status"}})],1)]),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"id":"group","label":"Texto","label-for":"cookies_text","description":""}},[_c('rich-textarea',{attrs:{"height":200,"name":"cookies_text","toolbar":[
                  ['font', ['bold', 'italic', 'underline', 'clear']],
                  ['insert', ['link']]
                ]},model:{value:(_vm.form.cookies_text),callback:function ($$v) {_vm.$set(_vm.form, "cookies_text", $$v)},expression:"form.cookies_text"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('b-button',{attrs:{"type":"submit","variant":"success"}},[_vm._v("\n            Atualizar\n          ")])],1)])])],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h1',[_vm._v("Configurações")])])}]


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(367);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd890324_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd890324_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd890324_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn card"},[_c('flash',{attrs:{"fields":['avatarMedia', 'UnprocessableEntity']}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.show && _vm.ready)?_c('b-form',{on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();_vm.onSubmit($event)},"reset":function($event){$event.preventDefault();_vm.onReset($event)}}},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-6 is-valid",attrs:{"label":"Nome Completo","label-for":"name","description":""}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('name')
              },attrs:{"id":"name","type":"text","required":"","placeholder":"Nome Completo"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Email","label-for":"email","description":""}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('email'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('email')
              },attrs:{"id":"email","type":"text","required":"","placeholder":"Email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-right"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.togglePassword($event)}}},[_c('small',[_vm._v(_vm._s(_vm.updatePassword ? 'Ocultar' : 'Alterar Senha'))])])]),_vm._v(" "),(_vm.updatePassword)?[_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Senha","label-for":"password","description":"Apenas preencha os campos de senha se você quiser atualiza-la"}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('password'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('password')
                },attrs:{"id":"password","type":"password","placeholder":"***"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Confirmação Senha","label-for":"password_confirmation","description":""}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('password'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('password')
                },attrs:{"id":"password_confirmation","type":"password","placeholder":"***"},model:{value:(_vm.form.password_confirmation),callback:function ($$v) {_vm.$set(_vm.form, "password_confirmation", $$v)},expression:"form.password_confirmation"}})],1)]:_vm._e()],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('b-button',{attrs:{"type":"submit","variant":"success"}},[_vm._v("\n          Atualizar\n        ")])],1)]):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h1',[_vm._v("Perfil do usuário")])])}]


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(369);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08275630_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08275630_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08275630_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Opa! Você está perdido.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("A página que você está procurando não foi encontrada. Voltar a "),_c('a',{attrs:{"href":"/"}},[_vm._v("home")])])])])],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_500_vue__ = __webpack_require__(370);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e76532_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_500_vue__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e76532_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_500_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e76532_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_500_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-2 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("\n            Ops! Ocorreu algum problema na comunicação com o servidor.\n          ")]),_vm._v(" "),_c('p',[_vm._v("Por segurança, pode ser necessário que voce realize um novo login.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n            Voltar para a "),_c('router-link',{attrs:{"to":{ name: 'index'}}},[_vm._v("Dashboard")])],1)])])],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthorizationIndex_vue__ = __webpack_require__(371);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98b4bc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthorizationIndex_vue__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthorizationIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98b4bc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthorizationIndex_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98b4bc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthorizationIndex_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var Api = (0, _api.resolveHTTP)('/bl/process-items');

Api.storeByFileRoute = function () {
  return Api.apiURl + Api.relativeUrl + '/store-by-file';
};

exports.default = Api;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var Api = (0, _api.resolveHTTP)('/bl/jurisprudence-files');

Api.storeByFileRoute = function () {
  return Api.apiURl + Api.relativeUrl + '/store-by-file';
};

exports.default = Api;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _JurisprudenceFile = __webpack_require__(815);

var _JurisprudenceFile2 = _interopRequireDefault(_JurisprudenceFile);

var _JurisprudenceCategory = __webpack_require__(817);

var _JurisprudenceCategory2 = _interopRequireDefault(_JurisprudenceCategory);

var _JurisprudenceCategoryCard = __webpack_require__(374);

var _JurisprudenceCategoryCard2 = _interopRequireDefault(_JurisprudenceCategoryCard);

var _Resume = __webpack_require__(821);

var _Resume2 = _interopRequireDefault(_Resume);

var _ResumeCard = __webpack_require__(823);

var _ResumeCard2 = _interopRequireDefault(_ResumeCard);

var _ProcessCategory = __webpack_require__(826);

var _ProcessCategory2 = _interopRequireDefault(_ProcessCategory);

var _ProcessCategoryCard = __webpack_require__(828);

var _ProcessCategoryCard2 = _interopRequireDefault(_ProcessCategoryCard);

var _StoryCategory = __webpack_require__(831);

var _StoryCategory2 = _interopRequireDefault(_StoryCategory);

var _StoryCategoryCard = __webpack_require__(833);

var _StoryCategoryCard2 = _interopRequireDefault(_StoryCategoryCard);

var _BankAccount = __webpack_require__(836);

var _BankAccount2 = _interopRequireDefault(_BankAccount);

var _Question = __webpack_require__(838);

var _Question2 = _interopRequireDefault(_Question);

var _ProcessCard = __webpack_require__(840);

var _ProcessCard2 = _interopRequireDefault(_ProcessCard);

var _Process = __webpack_require__(843);

var _Process2 = _interopRequireDefault(_Process);

var _ProcessItem = __webpack_require__(846);

var _ProcessItem2 = _interopRequireDefault(_ProcessItem);

var _ProcessFileType = __webpack_require__(848);

var _ProcessFileType2 = _interopRequireDefault(_ProcessFileType);

var _ProcessType = __webpack_require__(850);

var _ProcessType2 = _interopRequireDefault(_ProcessType);

var _BannerCard = __webpack_require__(852);

var _BannerCard2 = _interopRequireDefault(_BannerCard);

var _QuestionCard = __webpack_require__(855);

var _QuestionCard2 = _interopRequireDefault(_QuestionCard);

var _ProcessTypeCard = __webpack_require__(858);

var _ProcessTypeCard2 = _interopRequireDefault(_ProcessTypeCard);

var _Banner = __webpack_require__(861);

var _Banner2 = _interopRequireDefault(_Banner);

var _User = __webpack_require__(864);

var _User2 = _interopRequireDefault(_User);

var _Story = __webpack_require__(866);

var _Story2 = _interopRequireDefault(_Story);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Bl: {
    BankAccount: _BankAccount2.default,
    QuestionCard: _QuestionCard2.default,
    Question: _Question2.default,
    JurisprudenceFile: _JurisprudenceFile2.default,
    JurisprudenceCategory: _JurisprudenceCategory2.default,
    JurisprudenceCategoryCard: _JurisprudenceCategoryCard2.default,
    Resume: _Resume2.default,
    ResumeCard: _ResumeCard2.default,
    ProcessCategory: _ProcessCategory2.default,
    ProcessCategoryCard: _ProcessCategoryCard2.default,
    StoryCategory: _StoryCategory2.default,
    StoryCategoryCard: _StoryCategoryCard2.default,
    ProcessFileType: _ProcessFileType2.default,
    ProcessTypeCard: _ProcessTypeCard2.default,
    ProcessType: _ProcessType2.default,
    ProcessItem: _ProcessItem2.default,
    ProcessCard: _ProcessCard2.default,
    Process: _Process2.default,
    Story: _Story2.default,
    BannerCard: _BannerCard2.default,
    Banner: _Banner2.default
  },
  System: {
    User: _User2.default
  }
};

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JurisprudenceFile_vue__ = __webpack_require__(372);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff15373_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceFile_vue__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JurisprudenceFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff15373_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceFile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff15373_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceFile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Arquivo"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n\n    Deseja remover o arquivo do item de Jurisprudencia? Ao confirmar essa ação o item não poderá ser recuperado.\n    "),_c('br'),_vm._v("\n    Caso deseje substituir o arquivo recomendamos que inative esse item e crie um novo.\n  ")]),_vm._v(" "),_c('b-card',{attrs:{"title":"Jurisprudencia","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"name"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Nome","required":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Categoria","label-for":"category_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('category_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('category_id')
          },attrs:{"placeholder":"Selecione a categoria","allowEmpty":true,"options":_vm.categories,"label":"name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('category_id', arguments[0])}},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Fonte","label-for":"source"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('source'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('source')
          },attrs:{"id":"source","placeholder":"Fonte"},model:{value:(_vm.form.source),callback:function ($$v) {_vm.$set(_vm.form, "source", $$v)},expression:"form.source"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Anexo","label-for":"file"}},[_c('single-file-input',{attrs:{"id":"file","value":_vm.fileInstance,"url":_vm.uploadUrl},on:{"success":_vm.handleUploadFile,"remove-file":_vm.handleRemoveFile}})],1)],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JurisprudenceCategory_vue__ = __webpack_require__(373);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e14ee7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceCategory_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JurisprudenceCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e14ee7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceCategory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e14ee7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JurisprudenceCategory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Categoria de Jurisprudência","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Titulo","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
          },attrs:{"id":"slug","placeholder":"Slug"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1),_vm._v(" "),_vm._t("footer")],2),_vm._v(" "),(_vm.form.id)?_c('b-card',{attrs:{"title":"Items da categoria","header-tag":"header","footer-tag":"footer"}},[_c('multiple-file-input',{attrs:{"id":"file","fields":{ category_id: _vm.form.id, process_id: _vm.form.process_id },"url":_vm.processItemHttp.storeByFileRoute()},on:{"error":function($event){_vm.$toasted.error(arguments[1])},"success":_vm.handleUploadFile}}),_vm._v(" "),_c('draggable',{staticClass:"sortable-container p-3 row",attrs:{"element":"div"},on:{"end":_vm.handleDrop},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},_vm._l((_vm.items),function(item,index){return _c(_vm.processItemEntity.sortableComponent,{key:("sortable-category-item-" + (item.id)),tag:"component",attrs:{"instance":item,"http":_vm.processItemHttp,"entity":_vm.processItemEntity},on:{"item-removed":function($event){_vm.handleRemoveFile(arguments[0])}}})}))],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Categoria de Jurisprudência"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.name)+" do site ? Ao confirmar essa ação, o item não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-sm-8 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.edit',
                params: { entity: 'bl-jurisprudence-files', id: _vm.instance.id }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col p-0 cursor-pointer"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}})])])])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resume_vue__ = __webpack_require__(376);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a36353e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resume_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resume_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a36353e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resume_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a36353e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resume_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Currículo","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Titulo","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
          },attrs:{"id":"slug","placeholder":"Slug"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Subtítulo","label-for":"subtitle","description":"(Obrigatório)"}},[_c('rich-textarea',{attrs:{"height":200,"name":"subtitle","toolbar":[
            ['font', ['bold', 'italic', 'underline', 'clear']],
            // ['fontsize', ['fontsize']],
            // ['para', ['ul', 'ol', 'paragraph']],
            // ['color', ['color']],
            // ['insert', ['link', 'hr']]
            ['insert', ['link']]
          ]},model:{value:(_vm.form.subtitle),callback:function ($$v) {_vm.$set(_vm.form, "subtitle", $$v)},expression:"form.subtitle"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Currículo","label-for":"resume","description":"(Obrigatório)"}},[_c('rich-textarea',{attrs:{"height":200,"name":"resume","toolbar":[
            ['font', ['bold', 'italic', 'underline', 'clear']],
            // ['fontsize', ['fontsize']],
            // ['para', ['ul', 'ol', 'paragraph']],
            // ['color', ['color']],
            // ['insert', ['link', 'hr']]
            ['insert', ['link']]
          ]},model:{value:(_vm.form.resume),callback:function ($$v) {_vm.$set(_vm.form, "resume", $$v)},expression:"form.resume"}})],1)],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResumeCard_vue__ = __webpack_require__(377);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611771d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResumeCard_vue__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(824)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-611771d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResumeCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611771d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResumeCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611771d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResumeCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Currículo"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.name)+" do site ? Ao confirmar essa ação, o item não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-sm-8 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.edit',
                params: { entity: 'bl-resumes', id: _vm.instance.id }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col p-0 cursor-pointer"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}})])])])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessCategory_vue__ = __webpack_require__(378);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716e608c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCategory_vue__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716e608c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCategory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716e608c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCategory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Categorias dos Processos","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Nome","label-for":"name","description":"(Obrigatório)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Nome","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
          },attrs:{"id":"slug","value":_vm.form.slug},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Processo","label-for":"process_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('process_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('process_id')
          },attrs:{"allowEmpty":true,"options":_vm.processes,"placeholder":"Selecione um processo","label":"company_name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('process_id', arguments[0])}},model:{value:(_vm.selectedProcess),callback:function ($$v) {_vm.selectedProcess=$$v},expression:"selectedProcess"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Tipo","label-for":"type_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('type_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('type_id')
          },attrs:{"placeholder":"Selecione o tipo","disabled":_vm.form.type_id ? true : false,"allowEmpty":true,"options":_vm.types,"label":"name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('type_id', arguments[0])}},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1)],1),_vm._v(" "),_vm._t("footer")],2),_vm._v(" "),(_vm.form.id && (_vm.instance.type === 'files' || _vm.instance.type === 'images'))?_c('b-card',{attrs:{"title":"Items da categoria","header-tag":"header","footer-tag":"footer"}},[(_vm.instance.type === 'files' || _vm.instance.type === 'images')?_c('multiple-file-input',{attrs:{"id":"file","fields":{ category_id: _vm.form.id, process_id: _vm.form.process_id },"url":_vm.processItemHttp.storeByFileRoute()},on:{"error":function($event){_vm.$toasted.error(arguments[1])},"success":_vm.handleUploadFile}}):_vm._e(),_vm._v(" "),_c('draggable',{staticClass:"sortable-container p-3 row",attrs:{"element":"div"},on:{"end":_vm.handleDrop},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},_vm._l((_vm.items),function(item,index){return _c(_vm.processItemEntity.sortableComponent,{key:("sortable-category-item-" + (item.id)),tag:"component",attrs:{"instance":item,"http":_vm.processItemHttp,"entity":_vm.processItemEntity},on:{"item-removed":function($event){_vm.handleRemoveFile(arguments[0])}}})}))],1):_vm._e(),_vm._v(" "),(_vm.instance.type === 'video')?_c('div',[_vm._v("\n    Para adicionar um video na categoria é necessário realizar um cadastro de um novo item\n    "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"/#/bl-process-items/new","role":"button"}},[_vm._v("Clicando aqui")])]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessCategoryCard_vue__ = __webpack_require__(379);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c47af5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCategoryCard_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(829)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01c47af5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessCategoryCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c47af5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCategoryCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c47af5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCategoryCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-9 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-3 col-xl-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('toggle-option-element',{attrs:{"instance":_vm.instance,"field":{ key: 'status'},"http":_vm.http,"entity":_vm.entity,"classes":['fa fa-eye','fa fa-eye-slash'],"labels":['Visível', 'Oculto']}})],1),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.nested.edit',
                params: {
                  entity: 'bl-processes',
                  id: _vm.instance.process_id,
                  nestedEntity: 'bl-process-categories',
                  nestedId: _vm.instance.id
                }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('delete-element',{attrs:{"instance":_vm.instance,"http":_vm.http,"entity":_vm.entity},on:{"refresh":function($event){_vm.$emit('item-removed', _vm.instance)}}})],1)])])])])])])}
var staticRenderFns = []


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryCategory_vue__ = __webpack_require__(380);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e57ce4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryCategory_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e57ce4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryCategory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e57ce4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryCategory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Categoria","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Titulo","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
          },attrs:{"id":"slug","placeholder":"Slug"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryCategoryCard_vue__ = __webpack_require__(381);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e3dd56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryCategoryCard_vue__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(834)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91e3dd56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryCategoryCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e3dd56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryCategoryCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e3dd56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryCategoryCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-9 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-3 col-xl-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('toggle-option-element',{attrs:{"instance":_vm.instance,"field":{ key: 'status'},"http":_vm.http,"entity":_vm.entity,"classes":['fa fa-eye','fa fa-eye-slash'],"labels":['Visível', 'Oculto']}})],1),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.nested.edit',
                params: {
                  entity: 'bl-story',
                  id: _vm.instance.process_id,
                  nestedEntity: 'bl-story-categories',
                  nestedId: _vm.instance.id
                }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('delete-element',{attrs:{"instance":_vm.instance,"http":_vm.http,"entity":_vm.entity},on:{"refresh":function($event){_vm.$emit('item-removed', _vm.instance)}}})],1)])])])])])])}
var staticRenderFns = []


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankAccount_vue__ = __webpack_require__(382);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95361240_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankAccount_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95361240_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankAccount_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95361240_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankAccount_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Arquivo"},on:{"ok":_vm.removeFile},model:{value:(_vm.showDeleteFileModal),callback:function ($$v) {_vm.showDeleteFileModal=$$v},expression:"showDeleteFileModal"}},[_vm._v("\n\n    Deseja remover o arquivo do processo? Ao confirmar essa ação o item não poderá ser recuperado.\n  ")]),_vm._v(" "),_c('b-card',{attrs:{"title":"Processo","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Mesma Favorecido\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'SIM', unchecked: 'NÃO'}},model:{value:(_vm.form.same_person),callback:function ($$v) {_vm.$set(_vm.form, "same_person", $$v)},expression:"form.same_person"}}),_vm._v(" "),_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Processo","label-for":"process_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('process_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('process_id')
          },attrs:{"allowEmpty":true,"options":_vm.processes,"placeholder":"Selecione um processo","label":"company_name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('process_id', arguments[0])}},model:{value:(_vm.selectedProcess),callback:function ($$v) {_vm.selectedProcess=$$v},expression:"selectedProcess"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"* Banco","label-for":"bank","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('bank'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('bank')
          },attrs:{"id":"bank","placeholder":"Banco","required":""},model:{value:(_vm.form.bank),callback:function ($$v) {_vm.$set(_vm.form, "bank", $$v)},expression:"form.bank"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"* Agência","label-for":"agency","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('agency'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('agency')
          },attrs:{"id":"agency","placeholder":"Conta","required":""},model:{value:(_vm.form.agency),callback:function ($$v) {_vm.$set(_vm.form, "agency", $$v)},expression:"form.agency"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"* Número da Conta","label-for":"account_number","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('account_number'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('account_number')
          },attrs:{"id":"account_number","placeholder":"Conta","required":""},model:{value:(_vm.form.account_number),callback:function ($$v) {_vm.$set(_vm.form, "account_number", $$v)},expression:"form.account_number"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"* Nome do favorecido","label-for":"creditor_name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('creditor_name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('creditor_name')
          },attrs:{"id":"creditor_name","placeholder":"Nome do credor","required":""},model:{value:(_vm.form.creditor_name),callback:function ($$v) {_vm.$set(_vm.form, "creditor_name", $$v)},expression:"form.creditor_name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Tipo de Favorecido","label-for":"favored_type"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('favored_type'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('favored_type')
          },attrs:{"placeholder":"Selecione o tipo","allowEmpty":true,"options":_vm.types,"label":"name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('favored_type', arguments[0])}},model:{value:(_vm.selectedFavoredType),callback:function ($$v) {_vm.selectedFavoredType=$$v},expression:"selectedFavoredType"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"* Nome do favorecido","label-for":"favored_name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('favored_name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('favored_name')
          },attrs:{"id":"favored_name","placeholder":"Nome do Favorecido","required":""},model:{value:(_vm.form.favored_name),callback:function ($$v) {_vm.$set(_vm.form, "favored_name", $$v)},expression:"form.favored_name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"* Documento do favorecido","label-for":"favored_document","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('favored_document'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('favored_document')
          },attrs:{"id":"favored_document","placeholder":"Documento do Favorecido","required":""},model:{value:(_vm.form.favored_document),callback:function ($$v) {_vm.$set(_vm.form, "favored_document", $$v)},expression:"form.favored_document"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Observações","label-for":"observations","description":""}},[_c('b-form-textarea',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('observations'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('observations')
          },attrs:{"id":"observations","placeholder":"Observações Gerais","rows":3,"max-rows":6},model:{value:(_vm.form.observations),callback:function ($$v) {_vm.$set(_vm.form, "observations", $$v)},expression:"form.observations"}})],1),_vm._v(" "),(_vm.instance.file)?_c('div',{staticClass:"col-12"},[_vm._v("\n        Documento enviado:\n\n        "),_c('a',{attrs:{"href":_vm.get(_vm.instance, '_links.download', '#!')}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-download",attrs:{"title":"Download"}}),_vm._v("\n\n          "+_vm._s(_vm.instance.file.file.original_name)+"\n        ")])]):_vm._e()],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__(383);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb7792e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb7792e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb7792e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"FAQ","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n      As perguntas devem ser do tipo bláblá blá?\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"* Pergunta","label-for":"query","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('query'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('query')
          },attrs:{"id":"query","type":"text","required":"","placeholder":"Pergunta"},model:{value:(_vm.form.query),callback:function ($$v) {_vm.$set(_vm.form, "query", $$v)},expression:"form.query"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"* Resposta","label-for":"answer","description":""}},[_c('b-form-textarea',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('answer'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('answer')
          },attrs:{"id":"answer","placeholder":"Resposta","required":"","rows":10},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)],1),_vm._v(" "),_vm._t("footer",[_c('div',{staticClass:"text-right",attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","variant":"success"}},[_vm._v("\n          Salvar\n        ")])],1)])],2)],1)}
var staticRenderFns = []


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessCard_vue__ = __webpack_require__(384);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6d0a5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCard_vue__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(841)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60b6d0a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6d0a5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6d0a5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Dúvida frequente"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover o processo #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.company_name)+" do site ? Ao confirmar essa ação não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-sm-8 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.company_name)+" "),_c('span',{staticStyle:{"color":"#9c9c9c"}},[_vm._v("("+_vm._s(_vm.instance.type.name)+")")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.edit',
                params: { entity: 'bl-process-types', id: _vm.instance.id }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col p-0 cursor-pointer"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}})])])])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Process_vue__ = __webpack_require__(385);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbe5094_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(844)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dbe5094"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Process_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbe5094_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbe5094_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Process_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Arquivo"},on:{"ok":_vm.removeFile},model:{value:(_vm.showDeleteFileModal),callback:function ($$v) {_vm.showDeleteFileModal=$$v},expression:"showDeleteFileModal"}},[_vm._v("\n\n    Deseja remover o arquivo do processo? Ao confirmar essa ação o item não poderá ser recuperado.\n  ")]),_vm._v(" "),_c('b-card',{attrs:{"title":"Processo","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right"},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Imagem","label-for":"media"}},[_c('single-media-uploader',{attrs:{"name":"file","placeholder":"static/img/defaults/upload.png","url":_vm.mediaUrl,"source":_vm.mediaInstance},on:{"success":_vm.handleUploadMedia}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Tipo","label-for":"type_id"}},[_c('multiselect',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('type_id'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('type_id')
              },attrs:{"placeholder":"Selecione o tipo","allowEmpty":true,"options":_vm.types,"label":"name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('type_id', arguments[0])}},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"company_name","description":""}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('company_name'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('company_name')
              },attrs:{"id":"company_name","placeholder":"Nome da Empresa","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.company_name),callback:function ($$v) {_vm.$set(_vm.form, "company_name", $$v)},expression:"form.company_name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Slug","label-for":"slug","description":"Se vazia será gerada uma slug automática"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
              },attrs:{"id":"slug"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Data","label-for":"date"}},[_c('date-picker',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('date'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('date')
              },attrs:{"config":_vm.datepickerOptions},on:{"dp-change":_vm.updateDate},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Descrição","label-for":"description","description":"(Obrigatório)"}},[_c('rich-textarea',{attrs:{"height":200,"name":"description","toolbar":[
                ['font', ['bold', 'italic', 'underline', 'clear']],
                // ['fontsize', ['fontsize']],
                // ['para', ['ul', 'ol', 'paragraph']],
                // ['color', ['color']],
                // ['insert', ['link', 'hr']]
                ['insert', ['link']]
              ]},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)],1)])],1),_vm._v(" "),_vm._t("footer")],2),_vm._v(" "),(_vm.instance.id)?_c('b-card',{attrs:{"title":"Documentos recebidos","header-tag":"header","footer-tag":"footer","sort-desc":_vm.submissionDefaultSort},on:{"update:sortDesc":function($event){_vm.submissionDefaultSort=$event}}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"horizontal":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Digite para buscar"},model:{value:(_vm.submissionFilter),callback:function ($$v) {_vm.submissionFilter=$$v},expression:"submissionFilter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.submissionFilter},on:{"click":function($event){_vm.submissionFilter = ''}}},[_vm._v("\n                Limpar\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),(_vm.get(_vm.form, 'submissions', []).length == 0)?_c('p',[_vm._v("\n      Nenhum envio foi realizado até esse momento.\n    ")]):_c('b-table',{attrs:{"striped":"","hover":"","table-w-hover":"","current-page":_vm.submissionPagination.current,"per-page":_vm.submissionPagination.perPage,"fields":_vm.submissionFields,"items":_vm.form.submissions,"filter":_vm.submissionFilter},on:{"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"id",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();toggleDetails($event)}}},[_vm._v("\n          #"+_vm._s(item.id)+"\n        ")])]}},{key:"user_name",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();toggleDetails($event)}}},[_vm._v("\n          "+_vm._s(_vm.get(item, 'user.name', ''))+" "),_c('small',[_vm._v("("+_vm._s(_vm.get(item, 'user.main_role.name', ''))+")")])])]}},{key:"type_name",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();toggleDetails($event)}}},[_vm._v("\n          "+_vm._s(_vm.get(item, 'type.name', ''))+"\n        ")])]}},{key:"reference_date",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();toggleDetails($event)}}},[_vm._v("\n          "+_vm._s(_vm._f("moment")(item.reference_date,'MM/YYYY'))+"\n        ")])]}},{key:"created_at",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();toggleDetails($event)}}},[_vm._v("\n          "+_vm._s(_vm._f("moment")(item.created_at,'DD/MM/YYYY hh:mm'))+"\n        ")])]}},{key:"actions",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"title":_vm.get(item, 'attachments', []).length + ' anexos'}},[_c('i',{staticClass:"fa fa-paperclip"})]),_vm._v(" "),(_vm.get(item, '_links', false))?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"href":_vm.get(item, '_links.download', '#!'),"title":"Baixar todos"}},[_c('i',{staticClass:"fa fa-download"})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mr-1",attrs:{"title":"Detalhes"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();toggleDetails($event)}}},[_c('i',{staticClass:"fa fa-info-circle"})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":"","title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.confirmDeleteFile(item)}}},[_c('i',{staticClass:"fa fa-trash-o"})])]}},{key:"row-details",fn:function(ref){
              var item = ref.item;
              var toggleDetails = ref.toggleDetails;
return [(item.observations)?_c('b-row',[_c('b-col',[_c('b',[_vm._v("Observações:")]),_vm._v(" "+_vm._s(item.observations)+"\n          ")])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[(item.attachments.length)?_c('fieldset',{staticClass:"attachments"},[_c('legend',{attrs:{"align":"left"}},[_c('b',[_vm._v("Download")])]),_vm._v(" "),_vm._l((item.attachments),function(attachment,index){return _c('span',{key:attachment.id},[_c('a',{staticClass:"col-lg-6",attrs:{"href":_vm.get(attachment, '_links.download', '#!')}},[_vm._v("\n                  "+_vm._s(attachment.file.original_name)+"\n                ")]),_vm._v(" "),(_vm.get(item, '_links', false))?_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"col-lg-6",attrs:{"href":_vm.get(item, '_links.download', '#!'),"title":"Baixar todos"}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Baixar todos\n                ")]):_vm._e()])})],2):_vm._e()])],1)]}}])}),_vm._v(" "),_c('div',{staticClass:"pagination-module"},[_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0 float-right",attrs:{"total-rows":_vm.submissionPagination.total,"per-page":_vm.submissionPagination.perPage},model:{value:(_vm.submissionPagination.current),callback:function ($$v) {_vm.$set(_vm.submissionPagination, "current", $$v)},expression:"submissionPagination.current"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.instance.id)?_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col"},[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n          Categorias\n        ")])]),_vm._v(" "),(_vm.nestedCreateRoute)?_c('div',{staticClass:"col"},[_c('router-link',{attrs:{"to":_vm.nestedCreateRoute}},[_c('label',{staticClass:"btn btn-primary float-right",staticStyle:{"margin":"4px 0px 0px"}},[_c('i',{staticClass:"fa fa-plus mr-1"}),_vm._v(" Incluir\n          ")])])],1):_vm._e()]),_vm._v(" "),_c('sortable',{attrs:{"entity":_vm.categoryEntity,"http":_vm.categoryHttp,"filter":{ process_id: _vm.instance.id },"card":false}})],1):_vm._e(),_vm._v(" "),(_vm.instance.id)?_c('b-card',{attrs:{"title":"Seguidores","header-tag":"header","footer-tag":"footer"}},[(_vm.get(_vm.form, 'followers', []).length == 0)?_c('p',[_vm._v("\n      Nenhum seguidor neste processo.\n    ")]):_c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.followersFields,"items":_vm.followers}})],1):_vm._e(),_vm._v(" "),_c('b-card',{attrs:{"title":"Popup","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right"},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.popup_status),callback:function ($$v) {_vm.$set(_vm.form, "popup_status", $$v)},expression:"form.popup_status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-12",attrs:{"label":"Título do Popup","label-for":"popup_title","description":""}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('popup_title'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('popup_title')
              },attrs:{"id":"popup_title","placeholder":"Título"},on:{"input":_vm.slugify},model:{value:(_vm.form.popup_title),callback:function ($$v) {_vm.$set(_vm.form, "popup_title", $$v)},expression:"form.popup_title"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Texto do Popup","label-for":"popup_description","description":""}},[_c('rich-textarea',{attrs:{"height":200,"name":"popup_description","toolbar":[
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['insert', ['link']]
              ]},model:{value:(_vm.form.popup_description),callback:function ($$v) {_vm.$set(_vm.form, "popup_description", $$v)},expression:"form.popup_description"}})],1)],1)])]),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessItem_vue__ = __webpack_require__(386);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4059247e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItem_vue__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4059247e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4059247e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Arquivo"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n\n    Deseja remover o arquivo do item do Processo? Ao confirmar essa ação o item não poderá ser recuperado.\n    "),_c('br'),_vm._v("\n    Caso deseje substituir o arquivo recomendamos que inative esse item e crie um novo.\n  ")]),_vm._v(" "),_c('b-card',{attrs:{"title":"Item do Processo","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Processo","label-for":"process_id"}},[_c('multiselect',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('process_id'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('process_id')
              },attrs:{"placeholder":"Selecione o Processo","allowEmpty":true,"options":_vm.processes,"label":"company_name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('process_id', arguments[0])}},model:{value:(_vm.selectedProcess),callback:function ($$v) {_vm.selectedProcess=$$v},expression:"selectedProcess"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Categoria","label-for":"category_id"}},[_c('multiselect',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('category_id'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('category_id')
              },attrs:{"disabled":_vm.selectedProcess === null,"placeholder":_vm.selectedProcess
                ? 'Selecione a categoria'
                : 'Selecione primeiro o processo',"allowEmpty":true,"options":_vm.categories,"label":"name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('category_id', arguments[0])}},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{class:'col-12 col-sm-6',attrs:{"label":"* Nome","label-for":"name"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('name')
              },attrs:{"id":"name","placeholder":"Nome","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
              },attrs:{"id":"slug","placeholder":"slug"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1)])]),_vm._v(" "),(_vm.selectedCategory !== null)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('hr')]),_vm._v(" "),(_vm.selectedCategory.type_id === 1)?_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Imagem","label-for":"media"}},[_c('single-media-uploader',{attrs:{"name":"file","placeholder":"static/img/defaults/upload.png","url":_vm.mediaUrl,"source":_vm.mediaInstance},on:{"success":_vm.handleUploadMedia}})],1):_vm._e(),_vm._v(" "),(_vm.selectedCategory.type_id === 2 || _vm.selectedCategory.type_id === 4)?_c('b-form-group',{class:'col-12',attrs:{"label":"Fonte","label-for":"source"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('source'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('source')
          },attrs:{"id":"source","placeholder":"Fonte (URL)"},model:{value:(_vm.form.source),callback:function ($$v) {_vm.$set(_vm.form, "source", $$v)},expression:"form.source"}})],1):_vm._e(),_vm._v(" "),(_vm.selectedCategory.type_id === 4)?_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Anexo","label-for":"file"}},[_c('single-file-input',{attrs:{"id":"file","value":_vm.fileInstance,"url":_vm.uploadUrl},on:{"error":function($event){_vm.$toasted.error(arguments[1])},"success":_vm.handleUploadFile,"remove-file":_vm.handleRemoveFile}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessFileType_vue__ = __webpack_require__(387);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f68c79a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessFileType_vue__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessFileType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f68c79a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessFileType_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f68c79a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessFileType_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Tipo dos Processos","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Nome","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
          },attrs:{"id":"slug-input"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-6",attrs:{"label":"Perfil","label-for":"role_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('role_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('role_id')
          },attrs:{"placeholder":"Selecione o perfil","allowEmpty":false,"options":_vm.roles,"label":"name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('role_id', arguments[0])}},model:{value:(_vm.selectedRole),callback:function ($$v) {_vm.selectedRole=$$v},expression:"selectedRole"}})],1)],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessType_vue__ = __webpack_require__(388);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadb454a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessType_vue__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadb454a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessType_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadb454a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessType_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Tipo dos Processos","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"* Nome","label-for":"name","description":""}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('name')
          },attrs:{"id":"name","placeholder":"Nome","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
          },attrs:{"id":"slug-input"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1)],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BannerCard_vue__ = __webpack_require__(389);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f9182a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BannerCard_vue__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(853)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24f9182a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BannerCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f9182a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BannerCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f9182a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BannerCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-4 col-lg-3"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Arquivo"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover o banner #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.heading)+" do site ? Ao confirmar essa ação o banner não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"image-container d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.mediaInstance.url,"blank":"","alt":"Banner"}})]),_vm._v(" "),_c('div',{staticClass:"card-body banner-title"},[_c('h6',{staticClass:"card-title"},[_vm._v("\n        #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.heading)+"\n      ")])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},[_c('li',{staticClass:"list-group-item"},[_c('span',{staticClass:"card-link"},[_c('i',{class:{
            'fa mr-1': true,
            'fa-circle success': _vm.instance.status,
            'fa-circle-o': !_vm.instance.status
          }}),_vm._v("\n\n          "+_vm._s(_vm.instance.status ? 'Ativo' : 'Inativo')+"\n        ")])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('router-link',{staticClass:"card-link",attrs:{"to":{
            name: 'manageables.edit',
            params: { entity: 'bl-banners', id: _vm.instance.id }
          }}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Editar\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('a',{staticClass:"card-link",attrs:{"href":"#","tabindex":"-1"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" Remover\n        ")])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionCard_vue__ = __webpack_require__(390);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71151ef5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(856)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71151ef5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71151ef5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71151ef5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Dúvida frequente"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover a dúvida frequente #"+_vm._s(_vm.instance.id)+" do site ? Ao confirmar essa ação a dúvida frequente não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-sm-8 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.query)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.edit',
                params: { entity: 'bl-questions', id: _vm.instance.id }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col p-0 cursor-pointer"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}})])])])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessTypeCard_vue__ = __webpack_require__(391);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5f9932_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessTypeCard_vue__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(859)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f5f9932"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessTypeCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5f9932_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessTypeCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5f9932_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessTypeCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Dúvida frequente"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover o tipo de processo #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.name)+" do site ? Ao confirmar essa ação não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-sm-8 col-xl-10 mb-0"},[_vm._v("\n          "+_vm._s(_vm.instance.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.edit',
                params: { entity: 'bl-process-types', id: _vm.instance.id }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col p-0 cursor-pointer"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}})])])])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__(392);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b234e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(862)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b234e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b234e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Banner","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-lg-6",attrs:{"label":"Imagem","label-for":"media"}},[_c('single-media-uploader',{attrs:{"name":"file","url":_vm.mediaUrl,"placeholder":"static/img/defaults/upload.png","source":_vm.mediaInstance},on:{"success":_vm.handleUploadMedia}},[_c('div',{class:("w-100 banner-data-preview text-" + (_vm.form.alignment)),attrs:{"slot":"mask"},slot:"mask"},[_c('div',{staticClass:"heading-text"},[_vm._v("\n              "+_vm._s(_vm.form.heading)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"subheading-text"},[_vm._v("\n              "+_vm._s(_vm.form.subheading)+"\n            ")]),_vm._v(" "),(_vm.form.anchor_label)?_c('div',{staticClass:"anchor-text"},[_c('b-button',{attrs:{"size":"sm","variant":"outline-secondary"}},[_vm._v("\n                "+_vm._s(_vm.form.anchor_label)+"\n              ")])],1):_vm._e()])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Título","label-for":"heading","description":"(Obrigatório)"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('heading'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('heading')
              },attrs:{"id":"heading","placeholder":"Titulo","required":""},model:{value:(_vm.form.heading),callback:function ($$v) {_vm.$set(_vm.form, "heading", $$v)},expression:"form.heading"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Subtítulo","label-for":"subheading"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('subheading'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('subheading')
              },attrs:{"id":"subheading","placeholder":"Subtítulo"},model:{value:(_vm.form.subheading),callback:function ($$v) {_vm.$set(_vm.form, "subheading", $$v)},expression:"form.subheading"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Alinhamento","label-for":"alignment"}},[_c('b-form-radio-group',{attrs:{"id":"alignment","name":"alignment"},model:{value:(_vm.form.alignment),callback:function ($$v) {_vm.$set(_vm.form, "alignment", $$v)},expression:"form.alignment"}},[_c('b-form-radio',{attrs:{"value":"left"}},[_vm._v("Esquerda")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"center"}},[_vm._v("Centro")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"right"}},[_vm._v("Direita")])],1)],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 alpha"},[_c('label',[_vm._v("Texto do botão")]),_vm._v(" "),_c('b-form-input',{class:{
                      'col': true,
                      'is-invalid': _vm.submitted && _vm.form.errors.has('anchor_label'),
                      'is-valid': _vm.submitted && !_vm.form.errors.has('anchor_label')
                    },attrs:{"id":"anchor_label","placeholder":"Mais"},model:{value:(_vm.form.anchor_label),callback:function ($$v) {_vm.$set(_vm.form, "anchor_label", $$v)},expression:"form.anchor_label"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 omega"},[_c('label',[_vm._v("Abrir em")]),_vm._v(" "),_c('multiselect',{attrs:{"showLabels":false,"allowEmpty":false,"options":_vm.targets,"label":"text","placeholder":"Selecione","track-by":"id"},on:{"select":function($event){_vm.updateForm('anchor_target', arguments[0])}},model:{value:(_vm.selectedTarget),callback:function ($$v) {_vm.selectedTarget=$$v},expression:"selectedTarget"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 alpha omega"},[_c('br'),_vm._v(" "),_c('label',[_vm._v("Link")]),_vm._v(" "),_c('b-form-input',{class:{
                  'col-12': true,
                  'is-invalid': _vm.submitted && _vm.form.errors.has('anchor_url'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('anchor_url')
                },attrs:{"id":"anchor_url","placeholder":"http://..."},model:{value:(_vm.form.anchor_url),callback:function ($$v) {_vm.$set(_vm.form, "anchor_url", $$v)},expression:"form.anchor_url"}})],1)])],1)])],1),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(393);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab041b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab041b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab041b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('b-card',{attrs:{"title":"Usuário","header-tag":"header","footer-tag":"footer"}},[(_vm.emptyInstance)?[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-12 text-right "},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n                Ativar e Autorizar\n              ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{ checked: 'SIM', unchecked: 'NÃO' }},model:{value:(_vm.form._authorized),callback:function ($$v) {_vm.$set(_vm.form, "_authorized", $$v)},expression:"form._authorized"}})],1)])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Perfil","label-for":"roles","description":"Os dados do usuário variam conforme o o perfil adotado"}},[_c('multiselect',{attrs:{"showLabels":false,"allowEmpty":false,"options":_vm.roles,"label":"name","placeholder":"Selecione a perfil","track-by":"id"},on:{"select":function($event){_vm.updateForm('role_id', arguments[0])}},scopedSlots:_vm._u([{key:"clear",fn:function(props){return [(_vm.selectedRole)?_c('div',{staticClass:"multiselect__clear",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();_vm.selectedRole = null}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()]}}]),model:{value:(_vm.selectedRole),callback:function ($$v) {_vm.selectedRole=$$v},expression:"selectedRole"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4 is-valid",attrs:{"label":"Nome Completo","label-for":"name","description":""}},[_c('b-form-input',{class:{
              'is-invalid': _vm.submitted && _vm.form.errors.has('name'),
              'is-valid': _vm.submitted && !_vm.form.errors.has('name')
            },attrs:{"id":"name","type":"text","required":"","placeholder":"Nome Completo"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Email","label-for":"email","description":""}},[_c('b-form-input',{class:{
              'is-invalid': _vm.submitted && _vm.form.errors.has('email'),
              'is-valid': _vm.submitted && !_vm.form.errors.has('email')
            },attrs:{"id":"email","type":"text","placeholder":"Email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.instance.id),expression:"instance.id"}],staticClass:"col-12 text-right"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.togglePassword($event)}}},[_c('small',[_vm._v(_vm._s(_vm.updatePassword ? 'Ocultar' : 'Alterar Senha'))])])]),_vm._v(" "),(_vm.updatePassword)?[_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Senha","label-for":"password","description":_vm.instance.id ? 'Apenas preencha os campos de senha se você quiser atualiza-la' : ''}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('password'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('password')
              },attrs:{"id":"password","type":"password","placeholder":"***"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Confirmação Senha","label-for":"password_confirmation","description":""}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('password'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('password')
              },attrs:{"id":"password_confirmation","type":"password","placeholder":"***"},model:{value:(_vm.form.password_confirmation),callback:function ($$v) {_vm.$set(_vm.form, "password_confirmation", $$v)},expression:"form.password_confirmation"}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.showAddress)?[_c('hr'),_vm._v(" "),(_vm.get(_vm.selectedRole, 'slug', false) === 'process')?_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Processo","label-for":"profile[process_id]"}},[_c('multiselect',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('profile.process_id'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('profile.process_id')
              },attrs:{"allowEmpty":true,"options":_vm.processes,"label":"company_name","placeholder":"Selecione o processo","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('profile.process_id', arguments[0])}},scopedSlots:_vm._u([{key:"clear",fn:function(props){return [(_vm.selectedProcess)?_c('div',{staticClass:"multiselect__clear",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();_vm.selectedProcess = null}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()]}}]),model:{value:(_vm.selectedProcess),callback:function ($$v) {_vm.selectedProcess=$$v},expression:"selectedProcess"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Documento (CNPJ)","label-for":"document"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##.###.###/####-##'),expression:"'##.###.###/####-##'"}],class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('document'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('document')
              },attrs:{"id":"document","type":"text","placeholder":"CNPJ"},model:{value:(_vm.form.document),callback:function ($$v) {_vm.$set(_vm.form, "document", $$v)},expression:"form.document"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Telefone","label-for":"phone_number"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(['+XX (##) ####-####', '+XX (##) #####-####']),expression:"['+XX (##) ####-####', '+XX (##) #####-####']"}],class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('phone_number'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('phone_number')
              },attrs:{"id":"phone_number","type":"text","placeholder":"+55 (XX) XXXXX-XXXX"},model:{value:(_vm.form.phone_number),callback:function ($$v) {_vm.$set(_vm.form, "phone_number", $$v)},expression:"form.phone_number"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.get(_vm.selectedRole, 'slug', false) === 'attorney')?[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Documento (OAB)","label-for":"document"}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('document'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('document')
                },attrs:{"id":"document","type":"text","placeholder":"OAB..."},model:{value:(_vm.form.document),callback:function ($$v) {_vm.$set(_vm.form, "document", $$v)},expression:"form.document"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6",attrs:{"label":"Telefone","label-for":"phone_number"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(['+## (##) ####-####', '+## (##) #####-####']),expression:"['+## (##) ####-####', '+## (##) #####-####']"}],class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('phone_number'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('phone_number')
                },attrs:{"id":"phone_number","type":"text","placeholder":"+55 (XX) XXXXX-XXXX"},model:{value:(_vm.form.phone_number),callback:function ($$v) {_vm.$set(_vm.form, "phone_number", $$v)},expression:"form.phone_number"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h6',{staticClass:"col-12"},[_vm._v("Dados do Cliente")]),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-4",attrs:{"label":"Tipo","label-for":"profile[client_type]"}},[_c('multiselect',{attrs:{"options":_vm.entityTypes,"searchable":false,"close-on-select":false,"allow-empty":false,"show-labels":false,"track-by":"value","label":"label","placeholder":"Selecione o Tipo"},on:{"select":function($event){_vm.updateForm(_vm.profileEntityType, arguments[0])}},model:{value:(_vm.selectedEntityType),callback:function ($$v) {_vm.selectedEntityType=$$v},expression:"selectedEntityType"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-4",attrs:{"label":"Nome","label-for":"profile[client_name]"}},[_c('b-form-input',{class:{
                    'is-invalid': _vm.submitted && _vm.form.errors.has('profile[client_name]'),
                    'is-valid': _vm.submitted && !_vm.form.errors.has('profile[client_name]')
                  },attrs:{"id":"profile[client_name]","type":"text","placeholder":"XPTO ltda"},model:{value:(_vm.form.profile.client_name),callback:function ($$v) {_vm.$set(_vm.form.profile, "client_name", $$v)},expression:"form.profile.client_name"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-4",attrs:{"label":_vm.get(_vm.selectedEntityType, 'value', 1) === 1 ? 'CPF' : 'CNPJ',"label-for":"profile[client_document]"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.documentMask),expression:"documentMask"}],class:{
                    'is-invalid': _vm.submitted && _vm.form.errors.has('profile[client_document]'),
                    'is-valid': _vm.submitted && !_vm.form.errors.has('profile[client_document]')
                  },attrs:{"id":"profile[client_document]","type":"text","placeholder":_vm.get(_vm.selectedEntityType, 'value', 1) === 1 ? '000.000.000-00' : '00.000.000/0000-00'},model:{value:(_vm.form.profile.client_document),callback:function ($$v) {_vm.$set(_vm.form.profile, "client_document", $$v)},expression:"form.profile.client_document"}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.get(_vm.selectedRole, 'slug', false) === 'creditor')?[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-3",attrs:{"label":"Tipo","label-for":"profile[entity_type]"}},[_c('multiselect',{attrs:{"options":_vm.entityTypes,"searchable":false,"allow-empty":false,"close-on-select":false,"show-labels":false,"track-by":"value","label":"label","placeholder":"Selecione o Tipo"},on:{"select":function($event){_vm.updateForm(_vm.profileEntityType, arguments[0])}},model:{value:(_vm.selectedEntityType),callback:function ($$v) {_vm.selectedEntityType=$$v},expression:"selectedEntityType"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-3",attrs:{"label":_vm.get(_vm.selectedEntityType, 'value', 1) === 1 ? 'CPF' : 'CNPJ',"label-for":"document"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.documentMask),expression:"documentMask"}],class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('document'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('document')
                },attrs:{"id":"document","type":"text","placeholder":_vm.get(_vm.selectedEntityType, 'value', 1) === 1 ? '000.000.000-00' : '00.000.000/0000-00'},model:{value:(_vm.form.document),callback:function ($$v) {_vm.$set(_vm.form, "document", $$v)},expression:"form.document"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-3",attrs:{"label":"Telefone","label-for":"phone_number"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:(['+## (##) ####-####', '+## (##) #####-####']),expression:"['+## (##) ####-####', '+## (##) #####-####']"}],class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('phone_number'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('phone_number')
                },attrs:{"id":"phone_number","type":"text","placeholder":"+XX (XX) XXXXX-XXXX"},model:{value:(_vm.form.phone_number),callback:function ($$v) {_vm.$set(_vm.form, "phone_number", $$v)},expression:"form.phone_number"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-3",attrs:{"label":"Advogado","label-for":"profile[attorney_name]"}},[_c('b-form-input',{class:{
                  'is-invalid': _vm.submitted && _vm.form.errors.has('profile[attorney_name]'),
                  'is-valid': _vm.submitted && !_vm.form.errors.has('profile[attorney_name]')
                },attrs:{"id":"profile[attorney_name]","type":"text","placeholder":"XPTO"},model:{value:(_vm.form.profile.attorney_name),callback:function ($$v) {_vm.$set(_vm.form.profile, "attorney_name", $$v)},expression:"form.profile.attorney_name"}})],1)],1)]:_vm._e()]:_vm._t("footer")],2),_vm._v(" "),(_vm.instance.bank_accounts)?_c('b-card',{attrs:{"title":"Dados bancários"}},[_c('datatable',{attrs:{"entity":_vm.bankAccountEntity,"http":_vm.bankAccountHttp,"card":false,"filter":{ user_id: _vm.instance.id }}})],1):_vm._e(),_vm._v(" "),(_vm.showAddress)?_c('b-card',{attrs:{"title":"Endereço","header-tag":"header","footer-tag":"footer"}},[_c('address-fields',{attrs:{"form":_vm.form}}),_vm._v(" "),_vm._t("footer")],2):_vm._e()],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Story_vue__ = __webpack_require__(394);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28053e62_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(867)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28053e62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Story_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28053e62_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28053e62_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('b-card',{attrs:{"title":"Notícia","header-tag":"header","footer-tag":"footer"}},[_c('div',{staticClass:"row mb-0 align-items-right",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"switch-container"},[_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"color":'#d39e00',"switch-color":"#d39e00","labels":{ checked: 'SIM', unchecked: 'NÃO' }},model:{value:(_vm.form.highlight),callback:function ($$v) {_vm.$set(_vm.form, "highlight", $$v)},expression:"form.highlight"}}),_vm._v(" "),_c('span',{staticClass:"switch-label ml-1"},[_vm._v("\n            Destaque\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('div',{staticClass:"switch-container"},[_c('span',{staticClass:"switch-label mr-1"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('toggle-button',{staticClass:"mb-0",attrs:{"width":70,"height":25,"labels":{checked: 'Ativo', unchecked: 'Inativo'}},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Imagem","label-for":"media"}},[_c('single-media-uploader',{attrs:{"name":"file","url":_vm.mediaUrl,"placeholder":"static/img/defaults/upload.png","source":_vm.mediaInstance},on:{"success":_vm.handleUploadMedia}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Título","label-for":"title","description":"(Obrigatório)"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('title'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('title')
              },attrs:{"id":"title","placeholder":"Titulo","required":""},on:{"input":_vm.slugify},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Slug","label-for":"slug","description":"(Se vazia será gerada uma slug automática)"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('slug'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('slug')
              },attrs:{"id":"slug","placeholder":"Slug"},on:{"change":function($event){_vm.userEditedSlug = true}},model:{value:(_vm.form.slug),callback:function ($$v) {_vm.$set(_vm.form, "slug", $$v)},expression:"form.slug"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Manchete","label-for":"headline"}},[_c('b-form-input',{class:{
                'is-invalid': _vm.submitted && _vm.form.errors.has('headline'),
                'is-valid': _vm.submitted && !_vm.form.errors.has('headline')
              },attrs:{"id":"headline","placeholder":"Manchete"},model:{value:(_vm.form.headline),callback:function ($$v) {_vm.$set(_vm.form, "headline", $$v)},expression:"form.headline"}})],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Data de publicação","label-for":"release_date"}},[_c('date-picker',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('release_date'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('release_date')
          },attrs:{"config":_vm.datepickerOptions},on:{"dp-change":_vm.updateReleaseDate},model:{value:(_vm.form.release_date),callback:function ($$v) {_vm.$set(_vm.form, "release_date", $$v)},expression:"form.release_date"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Categoria","label-for":"category_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('category_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('category_id')
          },attrs:{"allowEmpty":true,"options":_vm.categories,"label":"name","placeholder":"Selecione a categoria","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('category_id', arguments[0])}},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-md-4",attrs:{"label":"Processo","label-for":"process_id"}},[_c('multiselect',{class:{
            'is-invalid': _vm.submitted && _vm.form.errors.has('process_id'),
            'is-valid': _vm.submitted && !_vm.form.errors.has('process_id')
          },attrs:{"placeholder":"Selecione o processo","allowEmpty":true,"options":_vm.processes,"label":"company_name","showLabels":false,"track-by":"id"},on:{"select":function($event){_vm.updateForm('process_id', arguments[0])}},model:{value:(_vm.selectedProcess),callback:function ($$v) {_vm.selectedProcess=$$v},expression:"selectedProcess"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Corpo","label-for":"body"}},[_c('rich-textarea',{model:{value:(_vm.form.body),callback:function ($$v) {_vm.$set(_vm.form, "body", $$v)},expression:"form.body"}})],1)],1)]),_vm._v(" "),_c('b-card',{attrs:{"title":"SEO / URLs amigáveis","header-tag":"header","footer-tag":"footer"}},[_c('seo-fields',{attrs:{"form":_vm.form,"urls":_vm.friendlyUrls,"slugable":_vm.form.title}}),_vm._v(" "),_vm._t("footer")],2)],1)}
var staticRenderFns = []


/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.route}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.icon,attrs:{"title":_vm.label}})])}
var staticRenderFns = []


/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Deseja remover o item?"},on:{"ok":_vm.remove},model:{value:(_vm.showDeleteModal),callback:function ($$v) {_vm.showDeleteModal=$$v},expression:"showDeleteModal"}},[_vm._v("\n      Ao confirmar essa ação o item não poderá ser recuperado. Deseja remover o item "),_c('b',[_vm._v(_vm._s(_vm.instance.representation || ''))]),_vm._v("?\n  ")]),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.icon,attrs:{"title":_vm.label},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showDeleteModal = true}}})],1)}
var staticRenderFns = []


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entity)?_c('div',{class:{
    'animated fadeIn': true,
    card: _vm.card,
  }},[(_vm.card)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:{ 'card-body': _vm.card }},[_c('form',{staticClass:"form-inline form-inputs",on:{"submit":function($event){$event.preventDefault();_vm.firstPageSearch($event)}}},[_c('div',{staticClass:"form-group col-sm-4 search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.search),expression:"input.search"}],ref:"search",staticClass:"form-control",staticStyle:{"margin-bottom":"0","width":"100%"},attrs:{"type":"text","name":"search","id":"search","placeholder":"Buscar","autofocus":""},domProps:{"value":(_vm.input.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "search", $event.target.value)},function($event){$event.preventDefault();_vm.callDebouncedFirstPageSearch($event)}],"blur":function($event){$event.preventDefault();_vm.firstPageSearch($event)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.collection.length > 0)?_c('table',{staticClass:"table table-sm table-hover table-striped col-sm-12"},[_c('thead',[_c('tr',[_vm._l((_vm.options.fields),function(field,index){return _c('th',{key:'datatable-header-' + index,class:[
              _vm.get(field, 'sortable', false) ? 'sortable' : null,
              _vm.get(field, 'action', false) ? 'action' : 'field',
              _vm.get(_vm.input, 'orderBy.name', null) === field.key ? 'active' : null,
              'text-' + _vm.get(field, 'align', 'left'),
              field.class || ''
            ],style:(field.style || ''),on:{"click":function($event){field.sortable ? _vm.sortCollection(field) : null}}},[_vm._v("\n\n            "+_vm._s(field.label || '')+"\n\n            "),((field.sortable === true) && (_vm.get(_vm.input, 'orderBy.name', null) === field.key))?_c('i',{class:("float-right fa fa-sort-alpha-" + (_vm.input.orderBy.direction))}):_vm._e()])}),_vm._v(" "),(_vm.actions.length)?_c('th',{staticClass:"text-center"},[_vm._v("\n            Ações\n          ")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.collection),function(instance,index){return _c('tr',{key:("row-" + index)},[_vm._l((_vm.options.fields),function(field,fieldIndex){return _c('td',{key:("cell-field-" + index + "-" + fieldIndex),class:[
              'text-' + _vm.get(field, 'align', 'left'),
              field.class || ''
            ],style:(field.style)},[(field.component)?[_c(field.component,_vm._b({tag:"component",attrs:{"field":field,"entity":_vm.entity,"http":_vm.http,"instance":instance}},'component',field.props || {},false))]:_c('span',[_c('router-link',{attrs:{"to":{ name: 'manageables.edit', params: {
                entity: _vm.entity.key,
                id: instance.id
              }}}},[_vm._v("\n                "+_vm._s(_vm.applyFormatters(field, _vm.get(instance, field.key, '')))+"\n              ")])],1)],2)}),_vm._v(" "),(_vm.actions.length)?_c('td',{staticClass:"text-center"},[_vm._l((_vm.actions),function(action,actionIndex){return [(action.component)?_c('div',{key:("cell-action-" + index + "-" + actionIndex),staticStyle:{"display":"inline-block"}},[_c(action.component,{tag:"component",attrs:{"entity":_vm.entity,"instance":instance,"http":_vm.http},on:{"refresh":_vm.search}})],1):_c('span',{key:("cell-action-" + index + "-" + actionIndex)},[_vm._v("\n                --\n              ")])]})],2):_vm._e()],2)}))]):[(!_vm.processing)?_c('div',[_vm._v("\n        Nenhum registro "),(_vm.entity.name)?_c('span',[_vm._v("de "+_vm._s(_vm.entity.name)+" ")]):_vm._e(),_vm._v("foi encontrado. Verifique os dados de pequisa"),(_vm.entity.add !== false)?_c('span',[_vm._v("\n           ou\n          "),_c('router-link',{attrs:{"to":{ name: 'manageables.create', params: { entity: _vm.entity.key }}}},[_vm._v("\n            clique aqui para criar um novo\n          ")])],1):_vm._e(),_vm._v(".\n      ")]):_c('div',[_vm._v("\n        Buscando ...\n      ")])],_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('multiselect',{staticStyle:{"width":"100px","display":"inline-block"},attrs:{"placeholder":"Quantidade por página","allowEmpty":false,"showLabels":false,"options":_vm.per_pageOptions},on:{"input":_vm.firstPageSearch},model:{value:(_vm.input.per_page),callback:function ($$v) {_vm.$set(_vm.input, "per_page", $$v)},expression:"input.per_page"}}),_vm._v(" "),_c('span',[_vm._v(" Itens por página")])],1),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.pagination.total > 0)?_c('div',{staticClass:"pagination-module"},[_c('div',{staticClass:"align-left"},[_vm._v("\n            Página "),_c('b',[_vm._v(_vm._s(_vm.pagination.current_page))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.pagination.last_page))]),_vm._v(", \n            "),_c('b',[_vm._v(_vm._s(_vm.pagination.from))]),_vm._v(" até "),_c('b',[_vm._v(_vm._s(_vm.pagination.to))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.pagination.total))]),_vm._v(" registros\n          ")]),_vm._v(" "),_c('div',{staticClass:"align-left"},[_c('b-pagination',{attrs:{"total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page,"limit":3,"hide-ellipsis":true,"align":"right"},on:{"change":_vm.search},model:{value:(_vm.input.page),callback:function ($$v) {_vm.$set(_vm.input, "page", $$v)},expression:"input.page"}})],1)]):_vm._e()])])],2)]):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivateUserElement_vue__ = __webpack_require__(400);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a89217d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivateUserElement_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(876)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a89217d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivateUserElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a89217d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivateUserElement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a89217d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivateUserElement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var Api = (0, _api.resolveHTTP)('/activations');

Api.force = function (user, options) {
  return Api.resource.post('/force/' + user.email, Api.parseOptions(options));
};

Api.resend = function (user, options) {
  return Api.resource.post('/resend/' + user.email, Api.parseOptions(options));
};

exports.default = Api;

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instance.activated === false)?_c('div',[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Deseja ativar o usuário?"},on:{"ok":_vm.activate},model:{value:(_vm.showConfirmModal),callback:function ($$v) {_vm.showConfirmModal=$$v},expression:"showConfirmModal"}},[_vm._v("\n\n      Deseja realizar a ativação do usuário. Recomenda-se que o usuário ative a conta por meio do link enviado para o seu email. "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.resend($event)}}},[_vm._v("Clique aqui para reenviar o email")]),_vm._v(".\n  ")]),_vm._v(" "),_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-paper-plane-o",attrs:{"title":"Reenviar ativação"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.resend($event)}}})]),_vm._v(" "),_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.icon,attrs:{"title":_vm.label},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showConfirmModal = true}}})])],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderElement_vue__ = __webpack_require__(401);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143da9f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderElement_vue__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(880)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-143da9f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143da9f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderElement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143da9f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderElement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.route}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.icon,attrs:{"title":_vm.label}})])}
var staticRenderFns = []


/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('span',[(_vm.showConfirmModal)?_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Deseja realizar essa operação?"},on:{"ok":_vm.update},model:{value:(_vm.showConfirmModal),callback:function ($$v) {_vm.showConfirmModal=$$v},expression:"showConfirmModal"}},[_vm._v("\n\n     Deseja realizar essa atualização para o item "),_c('b',[_vm._v(_vm._s(_vm.instance.representation || ''))]),_vm._v("?\n  ")]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.currentClass,style:(("color: " + _vm.color + ";")),attrs:{"title":_vm.label || ''},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.attemptUpdate($event)}}})],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 float-left"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"visible":_vm.instanceToDelete !== null,"title":"Remover Contato","cancel-title":"Cancelar"},on:{"ok":_vm.remove,"cancel":function($event){_vm.instanceToDelete = null},"hide":function($event){_vm.instanceToDelete = null}}},[_vm._v("\n\n      Deseja remover o contato?\n      "),_c('br'),_vm._v("\n      Essa ação não poderá ser recuperada\n    ")]),_vm._v(" "),(_vm.entity)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"wrapper wrapper-content"},[_c('div',{staticClass:"row"},[(_vm.entity.filters.length > 0)?_c('div',{staticClass:"col-lg-2 mailbox-filter card"},[_c('div',{staticClass:"float-e-margins"},[_vm._m(0),_vm._v(" "),_c('a',{on:{"click":function($event){$event.preventDefault();_vm.resetSearch()}}},[_c('i',{staticClass:"fa fa-inbox mr-1"}),_vm._v("\n                Todos\n              ")]),_vm._v(" "),_vm._l((_vm.entity.filters),function(filter,index){return _c('a',{key:("filter-" + index),class:{ active: _vm.filterIsActive(filter) },on:{"click":function($event){$event.preventDefault();_vm.searchByFilter(filter)}}},[_c('i',{class:("mr-1 " + (filter.icon))}),_vm._v("\n                "+_vm._s(filter.label)+"\n              ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.entity.filters.length > 0 ? 'col-lg-10' : 'col-lg-12' + ' animated fadeInRight'},[(!_vm.selectedContact)?_c('div',{staticClass:"mailbox-container card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('form',{staticClass:"col-lg-6",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.firstPageSearch($event)}}},[_c('div',{staticClass:"input-group search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.q),expression:"input.q"}],ref:"search",staticClass:"form-control input-sm",attrs:{"type":"text","id":"search","placeholder":"Buscar","autofocus":""},domProps:{"value":(_vm.input.q)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "q", $event.target.value)},function($event){$event.preventDefault();_vm.callDebouncedFirstPageSearch($event)}],"blur":function($event){$event.preventDefault();_vm.firstPageSearch($event)}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-sm col-sm-12 table-mail"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.collection),function(instance){return _c('tr',{class:{
                        read: instance.status,
                        unread: !instance.status,
                        selected: instance.selected
                      }},[_c('td',[(_vm.hasAttachments(instance))?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"fa fa-paperclip ml-1",attrs:{"title":"Possui anexo(s)"}}):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectedContact = instance}}},[_vm._v("\n                          "+_vm._s(instance.name || 'Anônimo')+"\n                        ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectedContact = instance}}},[_vm._v("\n                          "+_vm._s(instance.email || (instance.phone_number || ''))+"\n                        ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectedContact = instance}}},[_vm._v("\n                          "+_vm._s(_vm._f("truncate")(instance[_vm.subjectField] || '',60))+"\n                        ")])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectedContact = instance}}},[_vm._v("\n                          "+_vm._s(_vm._f("moment")(instance.created_at,'DD/MM/YYYY HH:mm'))+"\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){_vm.showDeleteModal(instance)}}})])])}))]),_vm._v(" "),(_vm.pagination.total > 0)?_c('div',{staticClass:"pagination-module"},[_c('div',{staticClass:"align-left"},[_vm._v("\n                    Página "),_c('b',[_vm._v(_vm._s(_vm.pagination.current_page))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.pagination.last_page))]),_vm._v(", \n                    "),_c('b',[_vm._v(_vm._s(_vm.pagination.from))]),_vm._v(" até "),_c('b',[_vm._v(_vm._s(_vm.pagination.to))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.pagination.total))]),_vm._v(" registros\n                  ")]),_vm._v(" "),_c('div',{staticClass:"align-left"},[_c('b-pagination',{attrs:{"total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page,"limit":3,"hide-ellipsis":true,"align":"right"},on:{"change":_vm.search},model:{value:(_vm.input.page),callback:function ($$v) {_vm.$set(_vm.input, "page", $$v)},expression:"input.page"}})],1)]):_vm._e()])]):_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"col-lg-6"},[_vm._v("\n                    Mensagem\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 text-right",staticStyle:{"padding-top":"8px"}},[_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn ",on:{"click":function($event){_vm.selectedContact = null}}},[_c('i',{staticClass:"fa fa-chevron-left",staticStyle:{"font-size":"13px"}}),_vm._v(" Voltar\n                      ")]),_vm._v(" "),_c('a',{staticClass:"btn ",on:{"click":function($event){_vm.showDeleteModal(_vm.selectedContact)}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" Deletar\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('ul',{staticClass:"full list col-lg-12"},[_c('li',[_c('span',{staticClass:"full part"},[_c('b',{staticClass:"col-title no-padding"},[_vm._v("Assunto:")]),_vm._v("\n                      "+_vm._s(_vm.selectedContact[_vm.subjectField])+"\n                    ")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"float-left full part"},[_c('b',{staticClass:"col-title no-padding"},[_vm._v("\n                        De:\n                      ")]),_vm._v(" \n\n                      "),(_vm.selectedContact.name || _vm.selectedContact.email)?_c('span',[_vm._v("\n                        "+_vm._s(_vm.selectedContact.name || '')+" ("+_vm._s(_vm.selectedContact.email || '')+")\n                      ")]):_c('span',[_vm._v("\n                        Anônimo\n                      ")])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"full part"},[_c('b',{staticClass:"col-title no-padding"},[_vm._v("Enviado em:")]),_vm._v("\n                      "+_vm._s(_vm._f("moment")(_vm.selectedContact.created_at,'DD/MM/YYYY HH:mm'))+"\n                    ")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"float-left full part"},[_c('b',{staticClass:"col-title no-padding"},[_vm._v("Cidade:")]),_vm._v("\n                      "+_vm._s(_vm.selectedContact.city ? _vm.selectedContact.city.representation : ' Cidade não informada')+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"full"},[_vm._v("\n                    "+_vm._s(_vm.selectedContact[_vm.bodyField])+"\n                  ")])])]),_vm._v(" "),(_vm.selectedContact[_vm.attachmentsField])?_c('div',{staticClass:"col-lg-12 no-padding"},[(_vm.selectedContact[_vm.attachmentsField].length > 0)?_c('div',{staticClass:"mail-attachment"},[(_vm.options.multipleAttachments)?_vm._l((_vm.selectedContact[_vm.attachmentsField]),function(file,index){return _c('div',{key:("selected-contact-file-" + index),staticClass:"file"},[(file._links.download)?_c('a',{attrs:{"href":file._links.download || '!#'}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("\n                        "+_vm._s(file.file.original_name)),_c('br')]):_vm._e()])}):[_c('div',{staticClass:"file"},[(_vm.selectedContact._links.download)?_c('a',{attrs:{"href":_vm.selectedContact._links.download || '!#'}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("\n                        "+_vm._s(_vm.selectedContact.file[0].original_name)),_c('br')]):_vm._e()])]],2):_vm._e()]):_vm._e()])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h1',[_vm._v("\n                  Filtros\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Autor")]),_vm._v(" "),_c('th',[_vm._v("Contato")]),_vm._v(" "),_c('th',[_vm._v("Assunto")]),_vm._v(" "),_c('th',[_vm._v("Recebido em")]),_vm._v(" "),_c('th',{staticClass:"text-center"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-left full part"},[_c('b',[_vm._v("Mensagem:")])])}]


/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.entity !== undefined),expression:"entity !== undefined"}],class:{
    'animated fadeIn': true,
    card: _vm.card,
  }},[(_vm.card)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:{ 'card-box': _vm.card, row: !_vm.card }},[_c('div',{staticClass:"col"},[_c('draggable',{staticClass:"sortable-container p-3 row",attrs:{"element":"div"},on:{"end":_vm.handleDrop},model:{value:(_vm.collection),callback:function ($$v) {_vm.collection=$$v},expression:"collection"}},_vm._l((_vm.collection),function(instance){return _c(_vm.entity.options.component,{key:instance.id,tag:"component",attrs:{"instance":instance,"entity":_vm.entity,"http":_vm.http},on:{"item-removed":function($event){_vm.removeFromCollection(arguments[0])}}})}))],1)])])}
var staticRenderFns = []


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportAccountsButton_vue__ = __webpack_require__(408);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266d7922_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportAccountsButton_vue__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportAccountsButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266d7922_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportAccountsButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266d7922_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportAccountsButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var Api = (0, _api.resolveHTTP)('/bl/bank-accounts');

Api.exportRoute = function () {
  return Api.apiURl + Api.relativeUrl + '/xlsx';
};

exports.default = Api;

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.exportRoute,"target":"_blank"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-success float-right",staticStyle:{"margin":"4px"}},[_c('i',{staticClass:"fa fa-file-excel-o mr-1"}),_vm._v(" Dados Bancários\n  ")])}]


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessItemCard_vue__ = __webpack_require__(409);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9676b63c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItemCard_vue__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(892)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9676b63c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessItemCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9676b63c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItemCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9676b63c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItemCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Remover Categoria de Processo"},on:{"ok":_vm.removeFile},model:{value:(_vm.confirmRemoveModal),callback:function ($$v) {_vm.confirmRemoveModal=$$v},expression:"confirmRemoveModal"}},[_vm._v("\n    Deseja remover #"+_vm._s(_vm.instance.id)+" "+_vm._s(_vm.instance.name)+" do site ? Ao confirmar essa ação, o item não poderá ser recuperado.\n    "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.instance.type === 'images')?[(!_vm.instance.thumbnail_url)?_c('div',{staticClass:"col-1"},[_c('i',{staticClass:"fa fa-file-o"})]):_vm._e(),_vm._v(" "),(_vm.instance.thumbnail_url)?_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"image-container d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.instance.thumbnail_url ? _vm.instance.thumbnail_url : '',"blank":"","alt":_vm.instance.name}})])]):_vm._e(),_vm._v(" "),_c('h6',{staticClass:"col-sm-8 col-xl-10 mb-0"},[_vm._v("\n            "+_vm._s(_vm.instance.name)+"\n          ")])]:_vm._e(),_vm._v(" "),(_vm.instance.type === 'video')?[_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"image-container d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.instance.thumbnail_url,"blank":"","alt":_vm.instance.name}})])]),_vm._v(" "),_c('h6',{staticClass:"col-sm-8 col-xl-10  mb-0"},[_vm._v("\n            "+_vm._s(_vm.instance.name)+"\n          ")])]:_vm._e(),_vm._v(" "),(_vm.instance.type === 'files')?[_vm._m(0),_vm._v(" "),_c('h6',{staticClass:"col-sm-9 col-xl-10"},[_vm._v("\n            "+_vm._s(_vm.instance.name)+"\n          ")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-xl-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0"},[_c('router-link',{attrs:{"to":{
                name: 'manageables.edit',
                params: { entity: 'bl-process-items', id: _vm.instance.id }
              }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-edit",attrs:{"title":"Editar"}})])],1),_vm._v(" "),_c('div',{staticClass:"col p-0 cursor-pointer"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",attrs:{"title":"Remover"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleRemove($event)}}})])])])],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1"},[_c('i',{staticClass:"fa fa-file-o"})])}]


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col"},[_c('b-card',{attrs:{"header":_vm.caption}},[_c('b-table',{attrs:{"striped":true,"bordered":false,"small":false,"fixed":false,"responsive":"sm","items":_vm.collection,"fields":_vm.fields},scopedSlots:_vm._u([{key:"HEAD_actions",fn:function(data){return [_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(data.label))])]}},{key:"user",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.user.name)+" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.item.user.email))])]}},{key:"role",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.user.roles.length ? data.item.user.roles[0].name : '')+"\n            ")]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();_vm.approve(data.item)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Aprovar\n                  ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();_vm.showDeclineModal(data.item)}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Recusar\n                  ")])],1)]}}])})],1)],1)])]),_vm._v(" "),(_vm.authorization)?_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Recusar Acesso "},on:{"ok":_vm.decline},model:{value:(_vm.declineModal),callback:function ($$v) {_vm.declineModal=$$v},expression:"declineModal"}},[_vm._v("\n    Deseja realmente negar o acesso ao usuário "+_vm._s(_vm.authorization.user.email)+" ao sistema?"),_c('br'),_vm._v("\n    O usuário será removido e deverá se cadastrar novamente.\n  ")]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Handler_vue__ = __webpack_require__(410);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff159a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Handler_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Handler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff159a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Handler_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff159a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Handler_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entity)?_c('router-view',{staticClass:"animated fadeIn",attrs:{"nested":_vm.nested,"entity":_vm.entity,"http":_vm.http}}):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(411);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7532330c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7532330c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7532330c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c(_vm.entity.indexComponent,{tag:"component",attrs:{"entity":_vm.entity,"http":_vm.http,"card":true}},[_c('div',{staticClass:"row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col"},[(_vm.entity.name)?_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n          "+_vm._s(_vm.entity.name)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.entity.add !== false)?_c('router-link',{attrs:{"to":_vm.createRoute}},[_c('label',{staticClass:"btn btn-primary float-right",staticStyle:{"margin":"4px 0px 0px"}},[_c('i',{staticClass:"fa fa-plus mr-1"}),_vm._v(" Incluir\n          ")])]):_vm._e(),_vm._v(" "),(_vm.entity.order)?_c('a',{attrs:{"href":_vm.entity.order}},[_c('label',{staticClass:"btn btn-secondary float-right",staticStyle:{"margin":"4px"}},[_c('i',{staticClass:"fa fa-sort mr-1"}),_vm._v(" Ordernar\n          ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.entity.indexButtons),function(button,index){return (_vm.entity.indexButtons && _vm.entity.indexButtons.length > 0)?[_c(button,{key:("custom-button-index-" + index),tag:"component",attrs:{"entity":_vm.entity,"http":_vm.http}})]:_vm._e()})],2)])])],1)}
var staticRenderFns = []


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__(412);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f29f4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f29f4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f29f4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.entity.form)?_c('div',[_c('flash',{attrs:{"fields":['UnprocessableEntity']}}),_vm._v(" "),(_vm.show)?_c('b-form',{on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();_vm.formSubmit($event)},"reset":function($event){$event.preventDefault();_vm.formReset($event)}}},[(_vm.form)?_c(_vm.entity.form,{tag:"component",attrs:{"form":_vm.form,"submitted":_vm.submitted,"http":_vm.http,"nested":_vm.nested,"parent-entity":_vm.parentEntity}},[_c('div',{staticClass:"text-right",attrs:{"slot":"footer"},slot:"footer"},[_c('b-form-checkbox',{attrs:{"value":true,"unchecked-value":false},model:{value:(_vm.keepCreating),callback:function ($$v) {_vm.keepCreating=$$v},expression:"keepCreating"}},[_vm._v("\n\n              Criar outro\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"success","disabled":_vm.processing}},[_vm._v("\n              Salvar\n            ")])],1)]):_vm._e()],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(413);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d92db6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d92db6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d92db6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.entity.form)?_c('div',[_c('flash',{attrs:{"fields":['UnprocessableEntity']}}),_vm._v(" "),(_vm.show)?_c('b-form',{on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();_vm.formSubmit($event)},"reset":function($event){$event.preventDefault();_vm.formReset($event)}}},[_c(_vm.entity.form,{tag:"component",attrs:{"form":_vm.form,"submitted":_vm.submitted,"instance":_vm.instance,"http":_vm.http,"nested":_vm.nested,"parent-entity":_vm.parentEntity},on:{"refresh":_vm.refreshInstance}},[_c('div',{staticClass:"text-right",attrs:{"slot":"footer"},slot:"footer"},[(_vm.hasChanges)?_c('b-button',{attrs:{"type":"reset","variant":"link"}},[_vm._v("\n            Limpar alterações\n          ")]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"success","disabled":_vm.processing}},[_vm._v("\n            Salvar\n          ")])],1)])],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(904);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = __webpack_require__(2);

var _containers = __webpack_require__(193);

var _containers2 = _interopRequireDefault(_containers);

var _core = __webpack_require__(907);

var _core2 = _interopRequireDefault(_core);

var _ui = __webpack_require__(951);

var _ui2 = _interopRequireDefault(_ui);

var _ProcessItems = __webpack_require__(980);

var _ProcessItems2 = _interopRequireDefault(_ProcessItems);

var _SeoFields = __webpack_require__(982);

var _SeoFields2 = _interopRequireDefault(_SeoFields);

var _AddressFields = __webpack_require__(985);

var _AddressFields2 = _interopRequireDefault(_AddressFields);

var _vueMultiselect = __webpack_require__(987);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vuedraggable = __webpack_require__(988);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = (0, _extends3.default)({}, _containers2.default, _core2.default, _ui2.default, {
  'seo-fields': _SeoFields2.default,
  'address-fields': _AddressFields2.default,
  'process-items': _ProcessItems2.default,

  multiselect: _vueMultiselect2.default,
  draggable: _vuedraggable2.default
});

function install(Vue) {
  (0, _keys2.default)(components).forEach(function (directive) {
    Vue.component((0, _lodash.kebabCase)(directive), components[directive]);
  });
}

exports.default = install;

/***/ }),
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Aside = __webpack_require__(908);

var _Aside2 = _interopRequireDefault(_Aside);

var _Breadcrumb = __webpack_require__(910);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Callout = __webpack_require__(913);

var _Callout2 = _interopRequireDefault(_Callout);

var _Footer = __webpack_require__(915);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(918);

var _Header2 = _interopRequireDefault(_Header);

var _Sidebar = __webpack_require__(921);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Switch = __webpack_require__(947);

var _Switch2 = _interopRequireDefault(_Switch);

var _ListGroups = __webpack_require__(949);

var _ListGroups2 = _interopRequireDefault(_ListGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  CoreAside: _Aside2.default,
  CoreBreadcrumb: _Breadcrumb2.default,
  CoreCallout: _Callout2.default,
  CoreFooter: _Footer2.default,
  CoreHeader: _Header2.default,
  CoreSidebar: _Sidebar2.default,
  CoreSwitch: _Switch2.default,
  ListGroups: _ListGroups2.default
};

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(414);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84ded4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84ded4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84ded4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(415);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ce115f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(911)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ce115f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ce115f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"w-100 float-left"},[_c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.crumbs),function(crumb,index){return (_vm.show && _vm.ready)?_c('li',{key:("breadcrumb-item-" + index),staticClass:"breadcrumb-item"},[(index === _vm.crumbs.length - 1)?_c('span',{staticClass:"active"},[_vm._v("\n          "+_vm._s(_vm.showName(crumb))+"\n        ")]):_c('router-link',{attrs:{"to":crumb.route || '#'}},[_vm._v("\n          "+_vm._s(_vm.showName(crumb))+"\n        ")])],1):_vm._e()})),_vm._v(" "),_c('div',{staticClass:"float-right back-div"},[(_vm.backRoute)?_c('router-link',{attrs:{"to":_vm.backRoute}},[_c('i',{staticClass:"fa fa-chevron-circle-left"}),_vm._v(" \n        Voltar\n      ")]):_vm._e()],1)])])}
var staticRenderFns = []


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(416);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d77ad04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d77ad04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d77ad04_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(417);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e18ae24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e18ae24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e18ae24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"ml-auto"},[_c('a',{attrs:{"href":"http://www.owinteractive.com"}},[_c('img',{attrs:{"src":__webpack_require__(917),"alt":""}})])])])}]


/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ow.8a22e0c.png";

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(418);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a324b38c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(919)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a324b38c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a324b38c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.ready())?_c('header',{staticClass:"app-header navbar"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Deseja sair?"},on:{"ok":_vm.logout},model:{value:(_vm.confirmLogoutModal),callback:function ($$v) {_vm.confirmLogoutModal=$$v},expression:"confirmLogoutModal"}},[_vm._v("\n\n      Deseja sair do Painel administrativo?\n    ")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":{ name: 'index' }}}),_vm._v(" "),_c('ul',{staticClass:"navbar-nav flex-row ml-md-auto d-none d-md-flex"},[_c('li',{staticClass:"item-in-nav-bar"},[_c('router-link',{attrs:{"to":{ name: 'app.dashboard' }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-home",attrs:{"title":"Dashboard","aria-hidden":"true"}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'manageables.index', params: { entity: 'sys-users' } }}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-users",attrs:{"title":"Usuários","aria-hidden":"true"}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.siteUrl,"target":"_blank"}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-external-link-square",attrs:{"title":"Ir para o Site","aria-hidden":"true"}})])],1),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('b',{staticClass:"user-data"},[_vm._v("\n            "+_vm._s(_vm.loggedUser.name || 'Usuário')+"\n            "),_c('i',{staticClass:"fa fa-chevron-down",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'app.profile' }}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Perfil\n        ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'app.settings' }}},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Configurações\n        ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();_vm.confirmLogoutModal = true}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Sair\n        ")])],2)],1)],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(419);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef61a4d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(922)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef61a4d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef61a4d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5234c325_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5234c325_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5234c325_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3cbd24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3cbd24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3cbd24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3c4352_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3c4352_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3c4352_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d96b80ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d96b80ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d96b80ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4c9ef66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4c9ef66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4c9ef66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1229c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1229c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1229c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47afa3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47afa3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47afa3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9fd03e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9fd03e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9fd03e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(432);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b708392c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b708392c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b708392c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-left"},[(_vm.label)?_c('span',{staticClass:"align-left"},[_vm._v("Status")]):_vm._e(),_vm._v(" "),_c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)])}
var staticRenderFns = []


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListGroups_vue__ = __webpack_require__(433);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3f562c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListGroups_vue__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3f562c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListGroups_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3f562c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListGroups_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{class:_vm.options.icon || 'fa fa-align-justify'}),_vm._v(" "),_c('strong',[_vm._v("\n      "+_vm._s(_vm.options.name || '')+"\n    ")]),_vm._v(" "),_c('small',[_vm._v("\n      "+_vm._s(_vm.options.caption || '')+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-actions text-right"},[_c('div',{staticClass:"align-left label-description"},[_vm._v("Total:")]),_vm._v(" "),_c('div',{staticClass:"align-left"},[_c('a',{attrs:{"href":_vm.options.link.href || '#!',"target":_vm.options.link.target || '_self'}},[_vm._t("action")],2)])])]),_vm._v(" "),_c('b-list-group',[_vm._t("card")],2),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer",[_c('a',{attrs:{"href":_vm.options.link.href || '#!',"target":_vm.options.link.target || '_self'}},[_c('small',{staticClass:"btn pull-right"},[_vm._v("\n          Visualizar tudo\n        ")])])])],2)],1)}
var staticRenderFns = []


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SingleMediaUploader = __webpack_require__(952);

var _SingleMediaUploader2 = _interopRequireDefault(_SingleMediaUploader);

var _SingleFileInput = __webpack_require__(955);

var _SingleFileInput2 = _interopRequireDefault(_SingleFileInput);

var _MultipleFileInput = __webpack_require__(962);

var _MultipleFileInput2 = _interopRequireDefault(_MultipleFileInput);

var _FileUploader = __webpack_require__(965);

var _FileUploader2 = _interopRequireDefault(_FileUploader);

var _Preloader = __webpack_require__(967);

var _Preloader2 = _interopRequireDefault(_Preloader);

var _Checkbox = __webpack_require__(970);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _RichTextarea = __webpack_require__(973);

var _RichTextarea2 = _interopRequireDefault(_RichTextarea);

var _SimpleCard = __webpack_require__(975);

var _SimpleCard2 = _interopRequireDefault(_SimpleCard);

var _Datatable = __webpack_require__(395);

var _Datatable2 = _interopRequireDefault(_Datatable);

var _Mailbox = __webpack_require__(404);

var _Mailbox2 = _interopRequireDefault(_Mailbox);

var _Sortable = __webpack_require__(406);

var _Sortable2 = _interopRequireDefault(_Sortable);

var _Flash = __webpack_require__(978);

var _Flash2 = _interopRequireDefault(_Flash);

var _ToggleOptionElement = __webpack_require__(402);

var _ToggleOptionElement2 = _interopRequireDefault(_ToggleOptionElement);

var _DeleteElement = __webpack_require__(136);

var _DeleteElement2 = _interopRequireDefault(_DeleteElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ToggleOptionElement: _ToggleOptionElement2.default,
  DeleteElement: _DeleteElement2.default,
  SingleFileInput: _SingleFileInput2.default,
  MultipleFileInput: _MultipleFileInput2.default,
  SingleMediaUploader: _SingleMediaUploader2.default,
  FileUploader: _FileUploader2.default,
  Preloader: _Preloader2.default,
  Datatable: _Datatable2.default,
  Mailbox: _Mailbox2.default,
  SimpleCard: _SimpleCard2.default,
  Checkbox: _Checkbox2.default,
  RichTextarea: _RichTextarea2.default,
  Sortable: _Sortable2.default,
  Flash: _Flash2.default
};

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleMediaUploader_vue__ = __webpack_require__(434);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43635a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleMediaUploader_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(953)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleMediaUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43635a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleMediaUploader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43635a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleMediaUploader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-uploader',_vm._b({ref:_vm.singleMediaRef,attrs:{"url":_vm.url,"name":_vm.name,"params":_vm.params,"transmit-ref":_vm.transmitRef},on:{"processing":_vm.handleProcessing,"success":_vm.handleSuccess,"error":_vm.handleError}},'file-uploader',_vm.options,false),[_c('div',{class:{
      'single-media-input d-flex align-items-center justify-content-center': true,
      'alert-danger': _vm.hasError(_vm.name)
    },on:{"click":_vm.triggerBrowse}},[_c('preloader',{attrs:{"show":_vm.processing}},[_vm._t("mask"),_vm._v(" "),_c('img',{staticClass:"media-preview",attrs:{"src":_vm.source.url || _vm.placeholder,"alt":_vm.alt}})],2)],1)])}
var staticRenderFns = []


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleFileInput_vue__ = __webpack_require__(435);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b35e83c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleFileInput_vue__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(956)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleFileInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b35e83c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleFileInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b35e83c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleFileInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-uploader',_vm._b({ref:_vm.singleFileRef,attrs:{"url":_vm.url,"name":_vm.name,"max-file-size":500,"params":_vm.params,"transmit-ref":_vm.transmitRef},on:{"processing":_vm.handleProcessing,"success":_vm.handleSuccess,"error":_vm.handleError},scopedSlots:_vm._u([{key:"files",fn:function(ref){
var files = ref.files;
return [(_vm.processing && _vm.emptyValue)?_c('div',{staticClass:"clearfix w-100"},_vm._l((files),function(file,i){return _c('div',{key:file.id,class:{'w-100': i === 0}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"float-left"},[_c('strong',[_vm._v(_vm._s(_vm._f("fixed")(file.upload.progress,2))+"%")])]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("fixed")(file.upload.speed.kbps,2))+" kbps")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"primary"},model:{value:(file.upload.progress),callback:function ($$v) {_vm.$set(file.upload, "progress", $$v)},expression:"file.upload.progress"}}),_vm._v(" "),(_vm.processing && _vm.success)?_c('div',{staticClass:"float-right"},[_c('small',{staticClass:"text-muted"},[_vm._v("\n            Upload feito com sucesso!\n          ")])]):_vm._e()],1)})):_vm._e()]}}])},'file-uploader',_vm.options,false),[(!_vm.emptyValue)?_c('div',[_c('b-media',[_c('b-img',{attrs:{"slot":"aside","blank":"","blank-color":"#ccc","width":"64","alt":"placeholder"},slot:"aside"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("\n          "+_vm._s(_vm.value.name)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("\n            "+_vm._s(_vm.value.size)+" bytes\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.value._links && _vm.value._links.download)?_c('span',{staticClass:"text-muted"},[_c('a',{attrs:{"href":_vm.value._links.download || '!#'}},[_vm._v("Download do Arquivo")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("\n            "+_vm._s(_vm.value.downloads || '0')+" downloads realizados\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 justify-content-end"},[_c('b-button',{staticClass:"float-right",attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.$emit('remove-file', _vm.value)}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" Remover\n          ")])],1)])],1)],1):_vm._e(),_vm._v(" "),(!_vm.processing && _vm.emptyValue)?_c('div',{staticClass:"w-100 h-100"},[_c('div',{staticClass:"row h-100 justify-content-center align-items-center"},[_c('div',{staticClass:"col-12 col-sm-3 col-lg-3 col-xl-2 "},[_c('b-button',{attrs:{"variant":"primary","block":true},on:{"click":_vm.triggerBrowse}},[_vm._v("\n            Subir arquivo\n        ")])],1)])]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleFileInput_vue__ = __webpack_require__(438);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aae890e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleFileInput_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(963)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleFileInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aae890e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleFileInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aae890e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleFileInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-uploader',_vm._b({ref:_vm.multiFileRef,attrs:{"url":_vm.url,"single":false,"name":_vm.name,"max-file-size":500,"params":_vm.params,"transmit-ref":_vm.transmitRef},on:{"processing":_vm.handleProcessing,"success":_vm.handleSuccess,"error":_vm.handleError},scopedSlots:_vm._u([{key:"files",fn:function(props){return [_vm._t("files",[_c('div',{staticClass:"clearfix w-100"},_vm._l((props.files),function(file,i){return _c('div',{key:file.id,class:{'w-100': i === 0}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(file.upload.progress < 100),expression:"file.upload.progress < 100"}]},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"float-left"},[_c('strong',[_vm._v(_vm._s(_vm._f("fixed")(file.upload.progress,2))+"%")])]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("fixed")(file.upload.speed.kbps,2))+" kbps")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"primary"},model:{value:(file.upload.progress),callback:function ($$v) {_vm.$set(file.upload, "progress", $$v)},expression:"file.upload.progress"}}),_vm._v(" "),(_vm.processing && _vm.success)?_c('div',{staticClass:"float-right"},[_c('small',{staticClass:"text-muted"},[_vm._v("\n                Upload feito com sucesso!\n              ")])]):_vm._e()],1)])}))],{files:props})]}}])},'file-uploader',_vm.options,false),[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-button',{attrs:{"variant":"primary","block":true},on:{"click":_vm.triggerBrowse}},[_vm._v("\n          Subir arquivo\n      ")])],1)])])}
var staticRenderFns = []


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploader_vue__ = __webpack_require__(439);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1456b9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploader_vue__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1456b9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1456b9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-transmit',_vm._b({ref:_vm.transmitRef,staticClass:"d-flex w-100",attrs:{"upload-area-classes":['bg-faded', 'w-100'],"params":_vm.params,"max-file-size":_vm.maxFileSize},on:{"error":_vm.handleError,"processing":function($event){_vm.$emit('processing',arguments[0])},"success":function($event){_vm.$emit('success', arguments[0], arguments[1], arguments[2])}},scopedSlots:_vm._u([{key:"files",fn:function(props){return [_vm._t("files",null,{files:props.files})]}}])},'vue-transmit',_vm.options,false),[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__ = __webpack_require__(440);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2583b9f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(968)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2583b9f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2583b9f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100"},[(_vm.show)?_c('div',{staticClass:"d-flex preloader-wrapper justify-content-center align-items-center h-100 w-100"},[_c('div',{staticClass:"d-flex preloader animated fadeIn"})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__(441);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59d19a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(971)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59d19a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59d19a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{staticClass:"hidden-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isChecked)?[_vm._t("on",[_c('span',[_vm._v("ON")])])]:[_vm._t("off",[_c('span',[_vm._v("OFF")])])],_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichTextarea_vue__ = __webpack_require__(442);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f232beac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichTextarea_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f232beac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichTextarea_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f232beac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichTextarea_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"name":_vm.name}})}
var staticRenderFns = []


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleCard_vue__ = __webpack_require__(443);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccd4080_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleCard_vue__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(976)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ccd4080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccd4080_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccd4080_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card quick-access"},[_c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("\n      "+_vm._s(_vm.card.title)+"\n    ")]),_vm._v(" "),(_vm.card.showTotal)?_c('span',{staticClass:"pull-right label-description"},[_c('span',{staticClass:"label label-success"},[_vm._v("\n        "+_vm._s(_vm.total)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table no-margin table-resume"},[_c('tr',_vm._l((_vm.data),function(d){return _c('td',[_c('b',[_vm._v("\n            "+_vm._s(d.label)+"\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{class:("label label-" + (d.color))},[_vm._v("\n            "+_vm._s(d.value)+"\n          ")])])}))])]),_vm._v(" "),(_vm.card.action !== null)?_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-white",attrs:{"href":_vm.card.link.href,"target":_vm.card.link.target}},[_vm._v("\n\n      "+_vm._s(_vm.card.action.text)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flash_vue__ = __webpack_require__(444);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46beb874_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flash_vue__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46beb874_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flash_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46beb874_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flash_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getErrors(_vm.fields)),function(group){return _c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[(!group.important)?_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.clearError([group.name])}}},[_vm._v("\n\n      ×\n    ")]):_vm._e(),_vm._v(" "),(group.name === 'UnprocessableEntity')?_c('h5',[_vm._v("\n      Os seguintes erros de validação foram encontrados\n    ")]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((group.data.errors),function(messages){return _c('li',_vm._l((messages),function(message,index){return _c('span',[_vm._v("\n          "+_vm._s(message)+"\n        ")])}))}))])}))}
var staticRenderFns = []


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessItems_vue__ = __webpack_require__(445);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab82376_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItems_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab82376_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItems_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab82376_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessItems_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col"},[_c('multiple-file-input',{attrs:{"id":"file","fields":{ category_id: _vm.category.id, process_id: _vm.category.process_id },"items":_vm.collection,"url":_vm.uploadUrl},on:{"error":function($event){_vm.$toasted.error(arguments[1])},"success":_vm.handleUploadFile,"remove-file":_vm.handleRemoveFile}})],1)])}
var staticRenderFns = []


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeoFields_vue__ = __webpack_require__(446);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b38237_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeoFields_vue__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeoFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b38237_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeoFields_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b38237_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeoFields_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(6);

var Api = (0, _api.resolveHTTP)('/seo/friendly-urls');

Api.check = function (seoId, url) {
  return Api.resource.get('/check/' + (seoId || ''), { params: { url: url } });
};

exports.default = Api;

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-6 col-md-4",attrs:{"label":"Titulo","label-for":"title"}},[_c('b-form-input',{class:{
          'is-invalid': _vm.form.errors.has('seo.title'),
          'is-valid': !_vm.form.errors.has('seo.title')
      },attrs:{"id":"name","type":"text","value":_vm.seo.title,"placeholder":"Título"},on:{"input":function($event){_vm.updateSeo('title', arguments[0])}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-md-8",attrs:{"label":"Descrição","label-for":"description","description":"Utilize no máximo 80 caracteres"}},[_c('b-form-input',{class:{
          'is-invalid': _vm.form.errors.has('seo.description'),
          'is-valid': !_vm.form.errors.has('seo.description')
      },attrs:{"id":"name","type":"text","value":_vm.seo.description,"placeholder":"Descrição"},on:{"input":function($event){_vm.updateSeo('description', arguments[0])}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-alert',{attrs:{"show":""}},[_vm._v("\n        A URL amigavel deve facilitar o acesso ao conteúdo. Ela deve ser única para cada tipo de conteúdo.\n        "),_c('br'),_vm._v("\n        Desta forma, para criar uma nova URL utilize o mecanismo para verificar a existência.\n      ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12",attrs:{"label":"Nova URL","label-for":"url","description":"Não utilize caracteres especiais"}},[_c('b-input-group',[_c('b-form-input',{class:{
            'is-invalid': _vm.form.errors.has('friendlyUrl.0.url'),
            'is-valid': !_vm.form.errors.has('friendlyUrl.0.url')
        },attrs:{"id":"url","type":"text","value":_vm.friendlyUrl,"formatter":_vm.slugify,"lazy-formatter":"","placeholder":""},on:{"input":function($event){_vm.updateUrl(arguments[0])}}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"variant":"outline-success"},on:{"click":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"provent",undefined,$event.key)){ return null; }$event.stopPropagation();_vm.checkUrl($event)}}},[_vm._v("Checar")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUrls),expression:"showUrls"}],staticClass:"col-12"},[_c('h4',[_vm._v("\n        URLs cadastradas\n      ")]),_vm._v(" "),_c('b-list-group',{staticClass:"mb-1"},_vm._l((_vm.urls),function(url,index){return _c('b-list-group-item',{key:("url.url-" + index),staticClass:"d-flex justify-content-between align-items-center"},[_vm._v("\n\n          "+_vm._s(url.url)+"\n\n          "),(index === 0)?_c('b-badge',{attrs:{"variant":"primary","pill":""}},[_vm._v("\n            PRINCIPAL\n          ")]):_vm._e()],1)}))],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressFields_vue__ = __webpack_require__(447);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d873c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressFields_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d873c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressFields_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d873c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressFields_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('b-form-group',{staticClass:"col-12 col-sm-8 col-md-9 col-lg-10",attrs:{"label":"Endereço","label-for":"address"}},[_c('b-form-input',{class:{
          'is-invalid': _vm.form.errors.has('address.address'),
          'is-valid': !_vm.form.errors.has('address.address')
      },attrs:{"id":"address","type":"text","value":_vm.address.address,"placeholder":"Logradouro"},on:{"input":function($event){_vm.updateForm('address', arguments[0])}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-4 col-md-3 col-lg-2",attrs:{"label":"Número","label-for":"number"}},[_c('b-form-input',{class:{
          'is-invalid': _vm.form.errors.has('address.number'),
          'is-valid': !_vm.form.errors.has('address.number')
      },attrs:{"id":"number","type":"text","value":_vm.address.number,"placeholder":"Número"},on:{"input":function($event){_vm.updateForm('number', arguments[0])}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-3",attrs:{"label":"Complemento","label-for":"complement"}},[_c('b-form-input',{class:{
          'is-invalid': _vm.form.errors.has('address.complement'),
          'is-valid': !_vm.form.errors.has('address.complement')
      },attrs:{"id":"complement","type":"text","value":_vm.address.complement,"placeholder":"Complemento"},on:{"input":function($event){_vm.updateForm('complement', arguments[0])}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-3",attrs:{"label":"Bairro","label-for":"neighborhood"}},[_c('b-form-input',{class:{
          'is-invalid': _vm.form.errors.has('address.neighborhood'),
          'is-valid': !_vm.form.errors.has('address.neighborhood')
      },attrs:{"id":"neighborhood","type":"text","value":_vm.address.neighborhood,"placeholder":"Bairro"},on:{"input":function($event){_vm.updateForm('neighborhood', arguments[0])}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-2",attrs:{"label":"CEP","label-for":"zipcode"}},[_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##.###-###'),expression:"'##.###-###'"}],class:{
          'is-invalid': _vm.form.errors.has('address.zipcode'),
          'is-valid': !_vm.form.errors.has('address.zipcode')
      },attrs:{"id":"zipcode","type":"text","value":_vm.address.zipcode,"placeholder":"CEP"},on:{"input":function($event){_vm.updateForm('zipcode', arguments[0])}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-12 col-sm-6 col-lg-4",attrs:{"label":"Cidade","label-for":"city_id"}},[_c('multiselect',{attrs:{"loading":_vm.processingCities,"options":_vm.cities,"track-by":"id","label":"name","placeholder":"Pesquisar...","limit":10,"hide-selected":false,"show-no-results":false,"open-direction":"bottom","internal-search":false,"close-on-select":true,"clear-on-select":true,"showLabels":false},on:{"search-change":_vm.searchCities},scopedSlots:_vm._u([{key:"clear",fn:function(props){return [(_vm.city !== null)?_c('div',{staticClass:"multiselect__clear",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();_vm.clearCity(props.search)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()]}}]),model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)])}
var staticRenderFns = []


/***/ })
],[449]);


// WEBPACK FOOTER //
// static/js/app.b3435cc8f8caa271f195.js